<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<style>
  :host {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    font-size: 14px;
    color: #333;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 8px 0;
  }

  p {
    margin: 0;
  }

  .spacer {
    flex: 1;
  }

  .toolbar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    display: none; /*flex*/
    align-items: center;
    background-color: #1976d2;
    color: white;
    font-weight: 600;
  }

  .toolbar img {
    margin: 0 16px;
  }

  .toolbar #twitter-logo {
    height: 40px;
    margin: 0 16px;
  }

  .toolbar #twitter-logo:hover {
    opacity: 0.8;
  }

  .content {
    display: none; /*flex*/
    margin: 82px auto 32px;
    padding: 0 16px;
    max-width: 960px;
    flex-direction: column;
    align-items: center;
  }

  svg.material-icons {
    height: 24px;
    width: auto;
  }

  svg.material-icons:not(:last-child) {
    margin-right: 8px;
  }

  .card svg.material-icons path {
    fill: #888;
  }

  .card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 16px;
  }

  .card {
    border-radius: 4px;
    border: 1px solid #eee;
    background-color: #fafafa;
    height: 40px;
    width: 200px;
    margin: 0 8px 16px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    line-height: 24px;
  }

  .card-container .card:not(:last-child) {
    margin-right: 0;
  }

  .card.card-small {
    height: 16px;
    width: 168px;
  }

  .card-container .card:not(.highlight-card) {
    cursor: pointer;
  }

  .card-container .card:not(.highlight-card):hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 17px rgba(0, 0, 0, 0.35);
  }

  .card-container .card:not(.highlight-card):hover .material-icons path {
    fill: rgb(105, 103, 103);
  }

  .card.highlight-card {
    background-color: #1976d2;
    color: white;
    font-weight: 600;
    border: none;
    width: auto;
    min-width: 30%;
    position: relative;
  }

  .card.card.highlight-card span {
    margin-left: 60px;
  }

  svg#rocket {
    width: 80px;
    position: absolute;
    left: -10px;
    top: -24px;
  }

  svg#rocket-smoke {
    height: calc(100vh - 95px);
    position: absolute;
    top: 10px;
    right: 180px;
    z-index: -10;
  }

  a,
  a:visited,
  a:hover {
    color: #1976d2;
    text-decoration: none;
  }

  a:hover {
    color: #125699;
  }

  .terminal {
    position: relative;
    width: 80%;
    max-width: 600px;
    border-radius: 6px;
    padding-top: 45px;
    margin-top: 8px;
    overflow: hidden;
    background-color: rgb(15, 15, 16);
  }

  .terminal::before {
    content: "\2022 \2022 \2022";
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: rgb(58, 58, 58);
    color: #c2c3c4;
    width: 100%;
    font-size: 2rem;
    line-height: 0;
    padding: 14px 0;
    text-indent: 4px;
  }

  .terminal pre {
    font-family: SFMono-Regular, Consolas, Liberation Mono, Menlo, monospace;
    color: white;
    padding: 0 1rem 1rem;
    margin: 0;
  }

  .circle-link {
    height: 40px;
    width: 40px;
    border-radius: 40px;
    margin: 8px;
    background-color: white;
    border: 1px solid #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: 1s ease-out;
  }

  .circle-link:hover {
    transform: translateY(-0.25rem);
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  }

  footer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    line-height: 20px;
  }

  footer a {
    display: flex;
    align-items: center;
  }

  .github-star-badge {
    color: #24292e;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 3px 10px;
    border: 1px solid rgba(27, 31, 35, 0.2);
    border-radius: 3px;
    background-image: linear-gradient(-180deg, #fafbfc, #eff3f6 90%);
    margin-left: 4px;
    font-weight: 600;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial,
      sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  }

  .github-star-badge:hover {
    background-image: linear-gradient(-180deg, #f0f3f6, #e6ebf1 90%);
    border-color: rgba(27, 31, 35, 0.35);
    background-position: -0.5em;
  }

  .github-star-badge .material-icons {
    height: 16px;
    width: 16px;
    margin-right: 4px;
  }

  svg#clouds {
    position: fixed;
    bottom: -160px;
    left: -230px;
    z-index: -10;
    width: 1920px;
  }

  /* Responsive Styles */
  @media screen and (max-width: 767px) {
    .card-container > *:not(.circle-link),
    .terminal {
      width: 100%;
    }

    .card:not(.highlight-card) {
      height: 16px;
      margin: 8px 0;
    }

    .card.highlight-card span {
      margin-left: 72px;
    }

    svg#rocket-smoke {
      right: 120px;
      transform: rotate(-5deg);
    }
  }

  @media screen and (max-width: 575px) {
    svg#rocket-smoke {
      display: none;
      visibility: hidden;
    }
  }
</style>

<!-- Toolbar -->
<div class="toolbar" role="banner">
  <img
    width="40"
    alt="Angular Logo"
    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj4KICAgIDxwYXRoIGZpbGw9IiNERDAwMzEiIGQ9Ik0xMjUgMzBMMzEuOSA2My4ybDE0LjIgMTIzLjFMMTI1IDIzMGw3OC45LTQzLjcgMTQuMi0xMjMuMXoiIC8+CiAgICA8cGF0aCBmaWxsPSIjQzMwMDJGIiBkPSJNMTI1IDMwdjIyLjItLjFWMjMwbDc4LjktNDMuNyAxNC4yLTEyMy4xTDEyNSAzMHoiIC8+CiAgICA8cGF0aCAgZmlsbD0iI0ZGRkZGRiIgZD0iTTEyNSA1Mi4xTDY2LjggMTgyLjZoMjEuN2wxMS43LTI5LjJoNDkuNGwxMS43IDI5LjJIMTgzTDEyNSA1Mi4xem0xNyA4My4zaC0zNGwxNy00MC45IDE3IDQwLjl6IiAvPgogIDwvc3ZnPg=="
  />
  <span>Welcome</span>
  <div class="spacer"></div>
  <a
    aria-label="Angular on twitter"
    target="_blank"
    rel="noopener"
    href="https://twitter.com/angular"
    title="Twitter"
  >
    <svg
      id="twitter-logo"
      height="24"
      data-name="Logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
    >
      <rect width="400" height="400" fill="none" />
      <path
        d="M153.62,301.59c94.34,0,145.94-78.16,145.94-145.94,0-2.22,0-4.43-.15-6.63A104.36,104.36,0,0,0,325,122.47a102.38,102.38,0,0,1-29.46,8.07,51.47,51.47,0,0,0,22.55-28.37,102.79,102.79,0,0,1-32.57,12.45,51.34,51.34,0,0,0-87.41,46.78A145.62,145.62,0,0,1,92.4,107.81a51.33,51.33,0,0,0,15.88,68.47A50.91,50.91,0,0,1,85,169.86c0,.21,0,.43,0,.65a51.31,51.31,0,0,0,41.15,50.28,51.21,51.21,0,0,1-23.16.88,51.35,51.35,0,0,0,47.92,35.62,102.92,102.92,0,0,1-63.7,22A104.41,104.41,0,0,1,75,278.55a145.21,145.21,0,0,0,78.62,23"
        fill="#fff"
      />
    </svg>
  </a>
</div>

<div class="content" role="main">
  <!-- Highlight Card -->
  <div class="card highlight-card card-small">
    <svg
      id="rocket"
      alt="Rocket Ship"
      xmlns="http://www.w3.org/2000/svg"
      width="101.678"
      height="101.678"
      viewBox="0 0 101.678 101.678"
    >
      <g id="Group_83" data-name="Group 83" transform="translate(-141 -696)">
        <circle
          id="Ellipse_8"
          data-name="Ellipse 8"
          cx="50.839"
          cy="50.839"
          r="50.839"
          transform="translate(141 696)"
          fill="#dd0031"
        />
        <g
          id="Group_47"
          data-name="Group 47"
          transform="translate(165.185 720.185)"
        >
          <path
            id="Path_33"
            data-name="Path 33"
            d="M3.4,42.615a3.084,3.084,0,0,0,3.553,3.553,21.419,21.419,0,0,0,12.215-6.107L9.511,30.4A21.419,21.419,0,0,0,3.4,42.615Z"
            transform="translate(0.371 3.363)"
            fill="#fff"
          />
          <path
            id="Path_34"
            data-name="Path 34"
            d="M53.3,3.221A3.09,3.09,0,0,0,50.081,0,48.227,48.227,0,0,0,18.322,13.437c-6-1.666-14.991-1.221-18.322,7.218A33.892,33.892,0,0,1,9.439,25.1l-.333.666a3.013,3.013,0,0,0,.555,3.553L23.985,43.641a2.9,2.9,0,0,0,3.553.555l.666-.333A33.892,33.892,0,0,1,32.647,53.3c8.55-3.664,8.884-12.326,7.218-18.322A48.227,48.227,0,0,0,53.3,3.221ZM34.424,9.772a6.439,6.439,0,1,1,9.106,9.106,6.368,6.368,0,0,1-9.106,0A6.467,6.467,0,0,1,34.424,9.772Z"
            transform="translate(0 0.005)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>

    <span>{{ title }} app is running!</span>

    <svg
      id="rocket-smoke"
      alt="Rocket Ship Smoke"
      xmlns="http://www.w3.org/2000/svg"
      width="516.119"
      height="1083.632"
      viewBox="0 0 516.119 1083.632"
    >
      <path
        id="Path_40"
        data-name="Path 40"
        d="M644.6,141S143.02,215.537,147.049,870.207s342.774,201.755,342.774,201.755S404.659,847.213,388.815,762.2c-27.116-145.51-11.551-384.124,271.9-609.1C671.15,139.365,644.6,141,644.6,141Z"
        transform="translate(-147.025 -140.939)"
        fill="#f5f5f5"
      />
    </svg>
  </div>

  <!-- Resources -->
  <h2>Resources</h2>
  <p>Here are some links to help you get started:</p>

  <div class="card-container">
    <a
      class="card"
      target="_blank"
      rel="noopener"
      href="https://angular.io/tutorial"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
        />
      </svg>

      <span>Learn Angular</span>

      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
      </svg>
    </a>

    <a
      class="card"
      target="_blank"
      rel="noopener"
      href="https://angular.io/cli"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
        />
      </svg>

      <span>CLI Documentation</span>

      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
      </svg>
    </a>

    <a
      class="card"
      target="_blank"
      rel="noopener"
      href="https://blog.angular.io/"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
        />
      </svg>

      <span>Angular Blog</span>

      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
      </svg>
    </a>
  </div>

  <!-- Next Steps -->
  <h2>Next Steps</h2>
  <p>What do you want to do next with your app?</p>

  <input type="hidden" #selection />

  <div class="card-container">
    <div
      class="card card-small"
      (click)="selection.value = 'component'"
      tabindex="0"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>

      <span>New Component</span>
    </div>

    <div
      class="card card-small"
      (click)="selection.value = 'material'"
      tabindex="0"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>

      <span>Angular Material</span>
    </div>

    <div class="card card-small" (click)="selection.value = 'pwa'" tabindex="0">
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>

      <span>Add PWA Support</span>
    </div>

    <div
      class="card card-small"
      (click)="selection.value = 'dependency'"
      tabindex="0"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>

      <span>Add Dependency</span>
    </div>

    <div
      class="card card-small"
      (click)="selection.value = 'test'"
      tabindex="0"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>

      <span>Run and Watch Tests</span>
    </div>

    <div
      class="card card-small"
      (click)="selection.value = 'build'"
      tabindex="0"
    >
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      </svg>

      <span>Build for Production</span>
    </div>
  </div>

  <!-- Terminal -->
  <div class="terminal" [ngSwitch]="selection.value">
    <pre *ngSwitchDefault>ng generate component xyz</pre>
    <pre *ngSwitchCase="'material'">ng add @angular/material</pre>
    <pre *ngSwitchCase="'pwa'">ng add @angular/pwa</pre>
    <pre *ngSwitchCase="'dependency'">ng add _____</pre>
    <pre *ngSwitchCase="'test'">ng test</pre>
    <pre *ngSwitchCase="'build'">ng build --prod</pre>
  </div>

  <!-- Links -->
  <div class="card-container">
    <a
      class="circle-link"
      title="Animations"
      href="https://angular.io/guide/animations"
      target="_blank"
      rel="noopener"
    >
      <svg
        id="Group_20"
        data-name="Group 20"
        xmlns="http://www.w3.org/2000/svg"
        width="21.813"
        height="23.453"
        viewBox="0 0 21.813 23.453"
      >
        <path
          id="Path_15"
          data-name="Path 15"
          d="M4099.584,972.736h0l-10.882,3.9,1.637,14.4,9.245,5.153,9.245-5.153,1.686-14.4Z"
          transform="translate(-4088.702 -972.736)"
          fill="#ffa726"
        />
        <path
          id="Path_16"
          data-name="Path 16"
          d="M4181.516,972.736v23.453l9.245-5.153,1.686-14.4Z"
          transform="translate(-4170.633 -972.736)"
          fill="#fb8c00"
        />
        <path
          id="Path_17"
          data-name="Path 17"
          d="M4137.529,1076.127l-7.7-3.723,4.417-2.721,7.753,3.723Z"
          transform="translate(-4125.003 -1058.315)"
          fill="#ffe0b2"
        />
        <path
          id="Path_18"
          data-name="Path 18"
          d="M4137.529,1051.705l-7.7-3.723,4.417-2.721,7.753,3.723Z"
          transform="translate(-4125.003 -1036.757)"
          fill="#fff3e0"
        />
        <path
          id="Path_19"
          data-name="Path 19"
          d="M4137.529,1027.283l-7.7-3.723,4.417-2.721,7.753,3.723Z"
          transform="translate(-4125.003 -1015.199)"
          fill="#fff"
        />
      </svg>
    </a>

    <a
      class="circle-link"
      title="CLI"
      href="https://cli.angular.io/"
      target="_blank"
      rel="noopener"
    >
      <svg
        alt="Angular CLI Logo"
        xmlns="http://www.w3.org/2000/svg"
        width="21.762"
        height="23.447"
        viewBox="0 0 21.762 23.447"
      >
        <g id="Group_21" data-name="Group 21" transform="translate(0)">
          <path
            id="Path_20"
            data-name="Path 20"
            d="M2660.313,313.618h0l-10.833,3.9,1.637,14.4,9.2,5.152,9.244-5.152,1.685-14.4Z"
            transform="translate(-2649.48 -313.618)"
            fill="#37474f"
          />
          <path
            id="Path_21"
            data-name="Path 21"
            d="M2741.883,313.618v23.447l9.244-5.152,1.685-14.4Z"
            transform="translate(-2731.05 -313.618)"
            fill="#263238"
          />
          <path
            id="Path_22"
            data-name="Path 22"
            d="M2692.293,379.169h11.724V368.618h-11.724Zm11.159-.6h-10.608v-9.345h10.621v9.345Z"
            transform="translate(-2687.274 -362.17)"
            fill="#fff"
          />
          <path
            id="Path_23"
            data-name="Path 23"
            d="M2709.331,393.688l.4.416,2.265-2.28-2.294-2.294-.4.4,1.893,1.893Z"
            transform="translate(-2702.289 -380.631)"
            fill="#fff"
          />
          <rect
            id="Rectangle_12"
            data-name="Rectangle 12"
            width="3.517"
            height="0.469"
            transform="translate(9.709 13.744)"
            fill="#fff"
          />
        </g>
      </svg>
    </a>

    <a
      class="circle-link"
      title="Augury"
      href="https://augury.rangle.io/"
      target="_blank"
      rel="noopener"
    >
      <svg
        alt="Angular Augury Logo"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="21.81"
        height="23.447"
        viewBox="0 0 21.81 23.447"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_13"
              data-name="Rectangle 13"
              width="10.338"
              height="10.27"
              fill="none"
            />
          </clipPath>
        </defs>
        <g id="Group_25" data-name="Group 25" transform="translate(0)">
          <path
            id="Path_24"
            data-name="Path 24"
            d="M3780.155,311.417h0l-10.881,3.9,1.637,14.4,9.244,5.152,9.244-5.152,1.685-14.4Z"
            transform="translate(-3769.274 -311.417)"
            fill="#4a3493"
          />
          <path
            id="Path_25"
            data-name="Path 25"
            d="M3862.088,311.417v23.447l9.244-5.152,1.685-14.4Z"
            transform="translate(-3851.207 -311.417)"
            fill="#311b92"
          />
          <g
            id="Group_24"
            data-name="Group 24"
            transform="translate(6.194 6.73)"
            opacity="0.5"
          >
            <g id="Group_23" data-name="Group 23" transform="translate(0 0)">
              <g id="Group_22" data-name="Group 22" clip-path="url(#clip-path)">
                <path
                  id="Path_26"
                  data-name="Path 26"
                  d="M3832.4,373.252a5.168,5.168,0,1,1-5.828-4.383,5.216,5.216,0,0,1,2.574.3,3.017,3.017,0,1,0,3.252,4.086Z"
                  transform="translate(-3822.107 -368.821)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
          <path
            id="Path_27"
            data-name="Path 27"
            d="M3830.582,370.848a5.162,5.162,0,1,1-3.254-4.086,3.017,3.017,0,1,0,3.252,4.086Z"
            transform="translate(-3814.311 -359.969)"
            fill="#fff"
          />
        </g>
      </svg>
    </a>

    <a
      class="circle-link"
      title="Protractor"
      href="https://www.protractortest.org/"
      target="_blank"
      rel="noopener"
    >
      <svg
        alt="Angular Protractor Logo"
        xmlns="http://www.w3.org/2000/svg"
        width="21.81"
        height="23.447"
        viewBox="0 0 21.81 23.447"
      >
        <g id="Group_26" data-name="Group 26" transform="translate(0)">
          <path
            id="Path_28"
            data-name="Path 28"
            d="M4620.155,311.417h0l-10.881,3.9,1.637,14.4,9.244,5.152,9.244-5.152,1.685-14.4Z"
            transform="translate(-4609.274 -311.417)"
            fill="#e13439"
          />
          <path
            id="Path_29"
            data-name="Path 29"
            d="M4702.088,311.417v23.447l9.244-5.152,1.685-14.4Z"
            transform="translate(-4691.207 -311.417)"
            fill="#b52f32"
          />
          <path
            id="Path_30"
            data-name="Path 30"
            d="M4651.044,369.58v-.421h1.483a7.6,7.6,0,0,0-2.106-5.052l-1.123,1.123-.3-.3,1.122-1.121a7.588,7.588,0,0,0-4.946-2.055v1.482h-.421v-1.485a7.589,7.589,0,0,0-5.051,2.058l1.122,1.121-.3.3-1.123-1.123a7.591,7.591,0,0,0-2.106,5.052h1.482v.421h-1.489v1.734h15.241V369.58Zm-10.966-.263a4.835,4.835,0,0,1,9.67,0Z"
            transform="translate(-4634.008 -355.852)"
            fill="#fff"
          />
        </g>
      </svg>
    </a>

    <a
      class="circle-link"
      title="Find a Local Meetup"
      href="https://www.meetup.com/find/?keywords=angular"
      target="_blank"
      rel="noopener"
    >
      <svg
        alt="Meetup Logo"
        xmlns="http://www.w3.org/2000/svg"
        width="24.607"
        height="23.447"
        viewBox="0 0 24.607 23.447"
      >
        <path
          id="logo--mSwarm"
          d="M21.221,14.95A4.393,4.393,0,0,1,17.6,19.281a4.452,4.452,0,0,1-.8.069c-.09,0-.125.035-.154.117a2.939,2.939,0,0,1-2.506,2.091,2.868,2.868,0,0,1-2.248-.624.168.168,0,0,0-.245-.005,3.926,3.926,0,0,1-2.589.741,4.015,4.015,0,0,1-3.7-3.347,2.7,2.7,0,0,1-.043-.38c0-.106-.042-.146-.143-.166a3.524,3.524,0,0,1-1.516-.69A3.623,3.623,0,0,1,2.23,14.557a3.66,3.66,0,0,1,1.077-3.085.138.138,0,0,0,.026-.2,3.348,3.348,0,0,1-.451-1.821,3.46,3.46,0,0,1,2.749-3.28.44.44,0,0,0,.355-.281,5.072,5.072,0,0,1,3.863-3,5.028,5.028,0,0,1,3.555.666.31.31,0,0,0,.271.03A4.5,4.5,0,0,1,18.3,4.7a4.4,4.4,0,0,1,1.334,2.751,3.658,3.658,0,0,1,.022.706.131.131,0,0,0,.1.157,2.432,2.432,0,0,1,1.574,1.645,2.464,2.464,0,0,1-.7,2.616c-.065.064-.051.1-.014.166A4.321,4.321,0,0,1,21.221,14.95ZM13.4,14.607a2.09,2.09,0,0,0,1.409,1.982,4.7,4.7,0,0,0,1.275.221,1.807,1.807,0,0,0,.9-.151.542.542,0,0,0,.321-.545.558.558,0,0,0-.359-.534,1.2,1.2,0,0,0-.254-.078c-.262-.047-.526-.086-.787-.138a.674.674,0,0,1-.617-.75,3.394,3.394,0,0,1,.218-1.109c.217-.658.509-1.286.79-1.918a15.609,15.609,0,0,0,.745-1.86,1.95,1.95,0,0,0,.06-1.073,1.286,1.286,0,0,0-1.051-1.033,1.977,1.977,0,0,0-1.521.2.339.339,0,0,1-.446-.042c-.1-.092-.2-.189-.307-.284a1.214,1.214,0,0,0-1.643-.061,7.563,7.563,0,0,1-.614.512A.588.588,0,0,1,10.883,8c-.215-.115-.437-.215-.659-.316a2.153,2.153,0,0,0-.695-.248A2.091,2.091,0,0,0,7.541,8.562a9.915,9.915,0,0,0-.405.986c-.559,1.545-1.015,3.123-1.487,4.7a1.528,1.528,0,0,0,.634,1.777,1.755,1.755,0,0,0,1.5.211,1.35,1.35,0,0,0,.824-.858c.543-1.281,1.032-2.584,1.55-3.875.142-.355.28-.712.432-1.064a.548.548,0,0,1,.851-.24.622.622,0,0,1,.185.539,2.161,2.161,0,0,1-.181.621c-.337.852-.68,1.7-1.018,2.552a2.564,2.564,0,0,0-.173.528.624.624,0,0,0,.333.71,1.073,1.073,0,0,0,.814.034,1.22,1.22,0,0,0,.657-.655q.758-1.488,1.511-2.978.35-.687.709-1.37a1.073,1.073,0,0,1,.357-.434.43.43,0,0,1,.463-.016.373.373,0,0,1,.153.387.7.7,0,0,1-.057.236c-.065.157-.127.316-.2.469-.42.883-.846,1.763-1.262,2.648A2.463,2.463,0,0,0,13.4,14.607Zm5.888,6.508a1.09,1.09,0,0,0-2.179.006,1.09,1.09,0,0,0,2.179-.006ZM1.028,12.139a1.038,1.038,0,1,0,.01-2.075,1.038,1.038,0,0,0-.01,2.075ZM13.782.528a1.027,1.027,0,1,0-.011,2.055A1.027,1.027,0,0,0,13.782.528ZM22.21,6.95a.882.882,0,0,0-1.763.011A.882.882,0,0,0,22.21,6.95ZM4.153,4.439a.785.785,0,1,0,.787-.78A.766.766,0,0,0,4.153,4.439Zm8.221,18.22a.676.676,0,1,0-.677.666A.671.671,0,0,0,12.374,22.658ZM22.872,12.2a.674.674,0,0,0-.665.665.656.656,0,0,0,.655.643.634.634,0,0,0,.655-.644A.654.654,0,0,0,22.872,12.2ZM7.171-.123A.546.546,0,0,0,6.613.43a.553.553,0,1,0,1.106,0A.539.539,0,0,0,7.171-.123ZM24.119,9.234a.507.507,0,0,0-.493.488.494.494,0,0,0,.494.494.48.48,0,0,0,.487-.483A.491.491,0,0,0,24.119,9.234Zm-19.454,9.7a.5.5,0,0,0-.488-.488.491.491,0,0,0-.487.5.483.483,0,0,0,.491.479A.49.49,0,0,0,4.665,18.936Z"
          transform="translate(0 0.123)"
          fill="#f64060"
        />
      </svg>
    </a>

    <a
      class="circle-link"
      title="Join the Conversation on Gitter"
      href="https://gitter.im/angular/angular"
      target="_blank"
      rel="noopener"
    >
      <svg
        alt="Gitter Logo"
        xmlns="http://www.w3.org/2000/svg"
        width="19.447"
        height="19.447"
        viewBox="0 0 19.447 19.447"
      >
        <g id="Group_40" data-name="Group 40" transform="translate(-1612 -405)">
          <rect
            id="Rectangle_19"
            data-name="Rectangle 19"
            width="19.447"
            height="19.447"
            transform="translate(1612 405)"
            fill="#e60257"
          />
          <g id="gitter" transform="translate(1617.795 408.636)">
            <g id="Group_33" data-name="Group 33" transform="translate(0 0)">
              <rect
                id="Rectangle_15"
                data-name="Rectangle 15"
                width="1.04"
                height="9.601"
                transform="translate(2.304 2.324)"
                fill="#fff"
              />
              <rect
                id="Rectangle_16"
                data-name="Rectangle 16"
                width="1.04"
                height="9.601"
                transform="translate(4.607 2.324)"
                fill="#fff"
              />
              <rect
                id="Rectangle_17"
                data-name="Rectangle 17"
                width="1.04"
                height="4.648"
                transform="translate(6.91 2.324)"
                fill="#fff"
              />
              <rect
                id="Rectangle_18"
                data-name="Rectangle 18"
                width="1.04"
                height="6.971"
                transform="translate(0 0)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </svg>
    </a>
  </div>

  <!-- Footer -->
  <footer>
    Love Angular?&nbsp;
    <a href="https://github.com/angular/angular" target="_blank" rel="noopener">
      Give our repo a star.
      <div class="github-star-badge">
        <svg
          class="material-icons"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
          />
        </svg>
        Star
      </div>
    </a>
    <a href="https://github.com/angular/angular" target="_blank" rel="noopener">
      <svg
        class="material-icons"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
          fill="#1976d2"
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </a>
  </footer>

  <svg
    id="clouds"
    alt="Gray Clouds Background"
    xmlns="http://www.w3.org/2000/svg"
    width="2611.084"
    height="485.677"
    viewBox="0 0 2611.084 485.677"
  >
    <path
      id="Path_39"
      data-name="Path 39"
      d="M2379.709,863.793c10-93-77-171-168-149-52-114-225-105-264,15-75,3-140,59-152,133-30,2.83-66.725,9.829-93.5,26.25-26.771-16.421-63.5-23.42-93.5-26.25-12-74-77-130-152-133-39-120-212-129-264-15-54.084-13.075-106.753,9.173-138.488,48.9-31.734-39.726-84.4-61.974-138.487-48.9-52-114-225-105-264,15a162.027,162.027,0,0,0-103.147,43.044c-30.633-45.365-87.1-72.091-145.206-58.044-52-114-225-105-264,15-75,3-140,59-152,133-53,5-127,23-130,83-2,42,35,72,70,86,49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33,61.112,8.015,113.854-5.72,150.492-29.764a165.62,165.62,0,0,0,110.861-3.236c47,94,178,113,251,33,31.385,4.116,60.563,2.495,86.487-3.311,25.924,5.806,55.1,7.427,86.488,3.311,73,80,204,61,251-33a165.625,165.625,0,0,0,120,0c51,13,108,15,157-5a147.188,147.188,0,0,0,33.5-18.694,147.217,147.217,0,0,0,33.5,18.694c49,20,106,18,157,5a165.625,165.625,0,0,0,120,0c47,94,178,113,251,33C2446.709,1093.793,2554.709,922.793,2379.709,863.793Z"
      transform="translate(142.69 -634.312)"
      fill="#eee"
    />
  </svg>
</div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content above * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced. * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * End of Placeholder * * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<router-outlet></router-outlet>
<div class="footer">
  <div style="margin-left: 12px">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 49.93 10.41"
      class="company-logo"
    >
      <path
        d="M12,3.14V7.86A.1.1,0,0,0,12,8h0c.07,0,.1,0,.1-.11V3.14a.1.1,0,0,0-.1-.11.1.1,0,0,0-.11.08ZM12.19.89a.2.2,0,0,1,.06.14.2.2,0,0,1-.06.15.19.19,0,0,1-.28,0A.22.22,0,0,1,11.85,1a.21.21,0,0,1,.2-.2.2.2,0,0,1,.14.06"
        style="fill: #fff"
      ></path>
      <path
        d="M12.06.91A.1.1,0,0,0,12,1a.15.15,0,0,0,0,.09.12.12,0,0,0,0,.1.14.14,0,0,0,.18,0h0a.12.12,0,0,0,0-.1.17.17,0,0,0-.14-.13m0,.41a.3.3,0,0,1-.2-.08.3.3,0,0,1-.08-.2.27.27,0,0,1,.08-.19.28.28,0,0,1,.2-.08.27.27,0,0,1,.27.27.28.28,0,0,1-.08.2.27.27,0,0,1-.19.08m0,1.79s0,0,0,0V7.87s0,0,0,0,0,0,0,0V3.14s0,0,0,0m0,4.94a.16.16,0,0,1-.18-.16V3.14A.17.17,0,0,1,12,3h0a.17.17,0,0,1,.18.16V7.86a.17.17,0,0,1-.15.19Z"
        style="fill: #fff"
      ></path>
      <path
        d="M16.68,1.05a3.14,3.14,0,0,0-2.32,1,3.28,3.28,0,0,0-1,2.37A3.3,3.3,0,0,0,19,6.76h0a.09.09,0,0,1,.13,0l0,0a.1.1,0,0,1,0,.14h0a3.46,3.46,0,0,1-5,0l0,0a3.49,3.49,0,0,1-1-2.53,3.52,3.52,0,0,1,1-2.53,3.47,3.47,0,0,1,5,0l0,0a.11.11,0,0,1,0,.16.11.11,0,0,1-.15,0,3.13,3.13,0,0,0-2.34-1"
        style="fill: #fff"
      ></path>
      <path
        d="M16.68.9a3.28,3.28,0,0,0-2.43,1,3.41,3.41,0,0,0-1,2.47,3.35,3.35,0,0,0,1,2.47,3.4,3.4,0,0,0,4.86,0l0,0s0,0,0-.06h0l0,0a3.34,3.34,0,0,1-4.77,0h0a3.31,3.31,0,0,1-1-2.42A3.37,3.37,0,0,1,19.07,2s0,0,0,0,0,0,.06,0,0,0,0,0A3.37,3.37,0,0,0,16.68.9m0,7.15A3.39,3.39,0,0,1,14.15,7,3.6,3.6,0,0,1,13.1,4.4a3.6,3.6,0,0,1,1.05-2.58,3.55,3.55,0,0,1,5.07,0l0,0a.19.19,0,0,1,0,.26.17.17,0,0,1-.26,0,3.18,3.18,0,0,0-4.55,0l0,0a3.17,3.17,0,0,0-.95,2.32A3.23,3.23,0,0,0,19,6.71l0,0a.16.16,0,0,1,.12-.06.16.16,0,0,1,.13.06.18.18,0,0,1,0,.25l0,0a3.48,3.48,0,0,1-2.57,1.09"
        style="fill: #fff"
      ></path>
      <path
        d="M22.51,7.75A2.23,2.23,0,1,0,20.3,5.5a2.23,2.23,0,0,0,2.21,2.25m0-4.72a2.3,2.3,0,0,1,1.71.72,2.4,2.4,0,0,1,.71,1.74A2.45,2.45,0,0,1,22.5,8a2.29,2.29,0,0,1-1.71-.72,2.36,2.36,0,0,1-.71-1.74,2.38,2.38,0,0,1,.71-1.74A2.28,2.28,0,0,1,22.51,3"
        style="fill: #fff"
      ></path>
      <path
        d="M22.51,3.33a2.18,2.18,0,1,0,2.14,2.18A2.26,2.26,0,0,0,24,4a2.08,2.08,0,0,0-1.52-.64m0,4.49A2.3,2.3,0,1,1,24.78,5.5a2.31,2.31,0,0,1-2.27,2.32m0-4.71a2.4,2.4,0,1,0,2.36,2.4,2.38,2.38,0,0,0-2.36-2.4m0,4.94A2.53,2.53,0,1,1,25,5.5a2.52,2.52,0,0,1-2.5,2.55"
        style="fill: #fff"
      ></path>
      <path
        d="M28.17,3a2.3,2.3,0,0,1,1.71.72,2.4,2.4,0,0,1,.71,1.74V7.85a2.45,2.45,0,0,1-2.43,2.47,2.41,2.41,0,0,1-1.71-.71.1.1,0,0,1,0-.14h0a.09.09,0,0,1,.13,0s0,0,0,0a2.19,2.19,0,0,0,3.13,0,2.28,2.28,0,0,0,.63-1.57V5.51a2.21,2.21,0,1,0-4.42,0A2.22,2.22,0,0,0,29.7,7.12h0a.09.09,0,0,1,.13,0l0,0a.1.1,0,0,1,0,.14l0,0a2.43,2.43,0,0,1-4.13-1.75,2.38,2.38,0,0,1,.71-1.74A2.41,2.41,0,0,1,28.17,3"
        style="fill: #fff"
      ></path>
      <path
        d="M26.54,9.5h0l0,0a0,0,0,0,0,0,.06,2.32,2.32,0,0,0,3.33,0,2.43,2.43,0,0,0,.67-1.68V5.51a2.36,2.36,0,1,0-4.72,0,2.36,2.36,0,0,0,4,1.72l0,0v0l0,0,0,0a2.26,2.26,0,0,1-3.24,0,2.29,2.29,0,1,1,3.91-1.62V7.88a2.28,2.28,0,0,1-3.89,1.65,0,0,0,0,0,0,0m1.63.91a2.39,2.39,0,0,1-1.76-.73.17.17,0,0,1,0-.25h0a.16.16,0,0,1,.12-.06.16.16,0,0,1,.13.06,2.12,2.12,0,0,0,3,0,2.18,2.18,0,0,0,.61-1.52V5.51A2.14,2.14,0,1,0,26,5.5a2.23,2.23,0,0,0,.63,1.55,2.1,2.1,0,0,0,3,0h0A.13.13,0,0,1,29.79,7a.16.16,0,0,1,.13.06.18.18,0,0,1,.06.13.17.17,0,0,1-.07.13,2.47,2.47,0,0,1-3.54,0,2.56,2.56,0,0,1-.72-1.78,2.51,2.51,0,0,1,5,0V7.86a2.52,2.52,0,0,1-2.5,2.55"
        style="fill: #fff"
      ></path>
      <path
        d="M33.65,3a2.06,2.06,0,0,1,1.58.72,2.54,2.54,0,0,1,.66,1.74V7.85a.1.1,0,0,1-.08.11h0c-.07,0-.1,0-.1-.11V5.5a2.31,2.31,0,0,0-.59-1.59,1.88,1.88,0,0,0-2.86,0,2.31,2.31,0,0,0-.59,1.59V7.86a.1.1,0,0,1-.1.11.1.1,0,0,1-.11-.08V3.14A.1.1,0,0,1,31.51,3h0c.07,0,.1,0,.1.11v1.3a2.44,2.44,0,0,1,.81-1,2,2,0,0,1,1.2-.4"
        style="fill: #fff"
      ></path>
      <path
        d="M33.65,3.18a2,2,0,0,1,1.48.69,2.48,2.48,0,0,1,.62,1.64V7.87s0,0,0,0,0,0,0,0V5.5a2.47,2.47,0,0,0-.64-1.7,2,2,0,0,0-2.69-.32,2.33,2.33,0,0,0-.79,1l-.14.32V3.14s0,0,0,0,0,0,0,0V7.86s0,0,0,0,0,0,0,0V5.5a2.38,2.38,0,0,1,.62-1.64,1.82,1.82,0,0,1,1.46-.68m2.12,4.87a.17.17,0,0,1-.18-.16V5.5A2.28,2.28,0,0,0,35,4a1.82,1.82,0,0,0-2.58-.18L32.26,4a2.28,2.28,0,0,0-.57,1.54V7.86a.17.17,0,0,1-.15.19h0a.16.16,0,0,1-.18-.16V3.14A.17.17,0,0,1,31.48,3h0a.16.16,0,0,1,.18.16v1a2.47,2.47,0,0,1,.7-.77,2.13,2.13,0,0,1,2.88.34,2.54,2.54,0,0,1,.67,1.8V7.86a.17.17,0,0,1-.15.19h0"
        style="fill: #fff"
      ></path>
      <path
        d="M36.88,3.14V7.86A.1.1,0,0,0,37,8h0c.07,0,.1,0,.1-.11V3.14A.1.1,0,0,0,37,3a.1.1,0,0,0-.11.08ZM37.13.89a.2.2,0,0,1,.06.14.2.2,0,0,1-.06.15.2.2,0,0,1-.14.06.24.24,0,0,1-.15-.06A.22.22,0,0,1,36.78,1a.2.2,0,0,1,.06-.14A.2.2,0,0,1,37,.83a.25.25,0,0,1,.14.06"
        style="fill: #fff"
      ></path>
      <path
        d="M37,.91a.1.1,0,0,0-.09,0,.15.15,0,0,0,0,.09.12.12,0,0,0,0,.1.14.14,0,0,0,.18,0h0a.12.12,0,0,0,0-.1A.17.17,0,0,0,37,.91m0,.41a.27.27,0,0,1-.2-.09.29.29,0,0,1-.07-.2A.26.26,0,0,1,36.8.84.28.28,0,0,1,37,.76a.27.27,0,0,1,.27.27.3.3,0,0,1-.08.2.28.28,0,0,1-.2.09m0,1.79s0,0,0,0V7.87s0,0,0,0,0,0,0,0V3.14s0,0,0,0m0,4.94a.16.16,0,0,1-.18-.16V3.14A.17.17,0,0,1,37,3h0a.17.17,0,0,1,.18.16V7.86a.17.17,0,0,1-.15.19Z"
        style="fill: #fff"
      ></path>
      <path
        d="M38.52,3.26V5.51a2.25,2.25,0,0,0,2.21,2.25.12.12,0,0,1,.1.13.12.12,0,0,1-.1.1A2.33,2.33,0,0,1,39,7.27a2.4,2.4,0,0,1-.71-1.74V.94a.1.1,0,0,1,.08-.11h0c.07,0,.1,0,.1.11V3h2.21a.12.12,0,0,1,.1.13.12.12,0,0,1-.1.1Z"
        style="fill: #fff"
      ></path>
      <path
        d="M38.42.9s0,0,0,0V5.5a2.38,2.38,0,0,0,2.36,2.4s0,0,0,0,0,0,0,0A2.31,2.31,0,0,1,38.45,5.5V3.18h2.29s0,0,0,0,0,0,0,0H38.45V1s0,0,0,0m2.31,7.15A2.54,2.54,0,0,1,38.22,5.5V.94a.17.17,0,0,1,.15-.19h0a.17.17,0,0,1,.18.16V3h2.14a.18.18,0,0,1,.18.19.19.19,0,0,1-.18.19H38.58V5.5a2.16,2.16,0,0,0,2.14,2.17.18.18,0,0,1,.18.19.17.17,0,0,1-.17.19"
        style="fill: #fff"
      ></path>
      <path
        d="M45.92,7.86a.1.1,0,0,1-.08.11h0c-.07,0-.1,0-.1-.11V6.56a2.3,2.3,0,0,1-.81,1,2.09,2.09,0,0,1-1.21.4,2,2,0,0,1-1.58-.72,2.54,2.54,0,0,1-.66-1.74V3.14A.1.1,0,0,1,41.53,3h0c.07,0,.1,0,.1.11V5.5a2.31,2.31,0,0,0,.59,1.59,1.9,1.9,0,0,0,1.44.66,1.86,1.86,0,0,0,1.43-.66,2.31,2.31,0,0,0,.59-1.59V3.14a.1.1,0,0,1,.1-.11.1.1,0,0,1,.11.08V7.86Z"
        style="fill: #fff"
      ></path>
      <path
        d="M45.78,6.21V7.86s0,0,0,0,0,0,0,0V3.14s0,0,0,0,0,0,0,0V5.5a2.42,2.42,0,0,1-.61,1.64,2,2,0,0,1-2.78.19,1.62,1.62,0,0,1-.18-.19A2.4,2.4,0,0,1,41.6,5.5V3.14s0,0,0,0,0,0,0,0V5.5a2.47,2.47,0,0,0,.64,1.7,2,2,0,0,0,2.69.32,2.3,2.3,0,0,0,.79-1Zm0,1.84a.17.17,0,0,1-.18-.16v-1a2.35,2.35,0,0,1-.7.77,2.13,2.13,0,0,1-2.88-.34,2.52,2.52,0,0,1-.67-1.8V3.14A.17.17,0,0,1,41.53,3h0a.16.16,0,0,1,.18.16V5.5A2.28,2.28,0,0,0,42.31,7a1.81,1.81,0,0,0,2.58.17A1.37,1.37,0,0,0,45.06,7a2.28,2.28,0,0,0,.57-1.54V3.14A.17.17,0,0,1,45.78,3h0a.16.16,0,0,1,.18.16V7.86a.17.17,0,0,1-.15.19Z"
        style="fill: #fff"
      ></path>
      <path
        d="M49.51,5.55a1.54,1.54,0,0,1,0,2,1.33,1.33,0,0,1-1,.45H46.83a.1.1,0,0,1-.11-.08v0c0-.08,0-.1.11-.1h1.63a1.12,1.12,0,0,0,.9-.39,1.34,1.34,0,0,0,0-1.65,1.49,1.49,0,0,0-1.18-.39A1.51,1.51,0,0,1,47,5a1.2,1.2,0,0,1-.29-.78A1.15,1.15,0,0,1,47,3.41a1,1,0,0,1,.84-.36h1.58a.11.11,0,0,1,.12.1.12.12,0,0,1-.1.13h-1.6a.83.83,0,0,0-.67.28.92.92,0,0,0-.22.63.92.92,0,0,0,.22.63c.16.2.53.3,1.1.3a1.47,1.47,0,0,1,1.24.43"
        style="fill: #fff"
      ></path>
      <path
        d="M46.84,7.82s0,0,0,0a0,0,0,0,0,0,0h1.63a1.26,1.26,0,0,0,1-.43,1.46,1.46,0,0,0,0-1.87,1.54,1.54,0,0,0-1.2-.43,1.5,1.5,0,0,1-1.16-.32,1,1,0,0,1-.23-.68,1,1,0,0,1,.24-.68.91.91,0,0,1,.73-.31h1.58s0,0,0,0,0,0,0,0H47.85a1,1,0,0,0-.78.33,1,1,0,0,0-.26.73,1.06,1.06,0,0,0,.27.74,1.44,1.44,0,0,0,1.11.33,1.56,1.56,0,0,1,1.24.42,1.43,1.43,0,0,1,0,1.75,1.2,1.2,0,0,1-1,.42Zm1.62.23H46.83a.18.18,0,0,1-.18-.19.19.19,0,0,1,.18-.19h1.63a1,1,0,0,0,.84-.36,1.26,1.26,0,0,0,0-1.56,1.44,1.44,0,0,0-1.13-.36A1.59,1.59,0,0,1,47,5a1.27,1.27,0,0,1,0-1.66A1.12,1.12,0,0,1,47.84,3h1.58a.18.18,0,0,1,.18.19.19.19,0,0,1-.18.19H47.84a.78.78,0,0,0-.62.26.82.82,0,0,0-.2.58.87.87,0,0,0,.2.58,1.39,1.39,0,0,0,1,.27,1.65,1.65,0,0,1,1.3.47,1.62,1.62,0,0,1,0,2.07,1.4,1.4,0,0,1-1.1.48"
        style="fill: #fff"
      ></path>
      <path
        d="M31.44,8.61s0,0,0,0V9.79s0,0,0,0a0,0,0,0,1,0,0h0V8.62h0"
        style="fill: #fff"
      ></path>
      <path
        d="M31.44,8.61v0Zm0,1.23a0,0,0,0,1,0,0V8.63s0-.05,0-.05h0a0,0,0,0,1,0,.05h0V9.8a.05.05,0,0,1,0,0h0"
        style="fill: #fff"
      ></path>
      <path
        d="M33.08,8.61s0,0,0,0v0h-.32V9.79a0,0,0,0,1,0,0h0a0,0,0,0,1,0,0V8.65H32.4s0,0,0,0a0,0,0,0,1,0,0h.68Z"
        style="fill: #fff"
      ></path>
      <path
        d="M32.74,9.84a0,0,0,0,1,0,0h0V8.67h-.29s0,0,0,0,0-.05,0-.05h.69s0,0,0,.05a0,0,0,0,1,0,0H32.8V9.79a0,0,0,0,1,0,0h0Z"
        style="fill: #fff"
      ></path>
      <path
        d="M35.2,9.81h0a0,0,0,0,0,0,0v0h.42a.28.28,0,0,0,.23-.09.32.32,0,0,0,.07-.19.26.26,0,0,0-.1-.24.7.7,0,0,0-.25-.05.75.75,0,0,1-.26,0,.22.22,0,0,1-.11-.24.29.29,0,0,1,.07-.2.25.25,0,0,1,.2-.1h.4s0,0,0,0h-.4a.21.21,0,0,0-.17.08.28.28,0,0,0-.06.18.23.23,0,0,0,.1.22.61.61,0,0,0,.24,0,.75.75,0,0,1,.26.05.28.28,0,0,1,.12.27.32.32,0,0,1-.1.22.31.31,0,0,1-.24.08Z"
        style="fill: #fff"
      ></path>
      <path
        d="M35.6,9.84h-.43s0,0,0,0,0,0,0,0h.44a.27.27,0,0,0,.21-.07.26.26,0,0,0,.07-.16q0-.16-.09-.21a.6.6,0,0,0-.24-.05.58.58,0,0,1-.26-.06.26.26,0,0,1-.13-.28.34.34,0,0,1,.07-.22.27.27,0,0,1,.22-.11h.39l0,0a0,0,0,0,1,0,0s0,0,0,0h-.42a.21.21,0,0,0-.15.07.22.22,0,0,0-.05.16.19.19,0,0,0,.09.19.59.59,0,0,0,.23.05.63.63,0,0,1,.27.06.28.28,0,0,1,.13.29.36.36,0,0,1-.1.25.6.6,0,0,1-.28.08"
        style="fill: #fff"
      ></path>
      <path
        d="M37.43,9.78A.56.56,0,0,0,38,9.22a.56.56,0,1,0-1.11,0,.59.59,0,0,0,.16.4.51.51,0,0,0,.39.17m0-1.17a.6.6,0,1,1-.59.6A.56.56,0,0,1,37,8.79a.52.52,0,0,1,.41-.18"
        style="fill: #fff"
      ></path>
      <path
        d="M37.43,8.67a.54.54,0,1,0,.53.54.58.58,0,0,0-.15-.38.57.57,0,0,0-.38-.16m0,1.17a.63.63,0,0,1,0-1.26.62.62,0,0,1,.62.63.67.67,0,0,1-.18.44.63.63,0,0,1-.44.19"
        style="fill: #fff"
      ></path>
      <path
        d="M39.63,9.78s0,0,0,0v0h-.25A.41.41,0,0,1,39,9.4V8.62h0v.77a.38.38,0,0,0,.37.38Z"
        style="fill: #fff"
      ></path>
      <path
        d="M39.63,9.84h-.25A.44.44,0,0,1,39,9.4V8.64a0,0,0,0,1,0,0h0a0,0,0,0,1,0,0h0v.77a.35.35,0,0,0,.34.35h.25a0,0,0,0,1,0,.05s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M41.39,8.61a0,0,0,0,1,0,0v.71a.5.5,0,0,1-.12.34.4.4,0,0,1-.57,0l0,0a.5.5,0,0,1-.12-.34V8.63a0,0,0,0,1,0,0h0s0,0,0,0v.71a.47.47,0,0,0,.12.31.36.36,0,0,0,.52,0l0,0a.48.48,0,0,0,.12-.31V8.63s0,0,0,0h0"
        style="fill: #fff"
      ></path>
      <path
        d="M41,9.84a.41.41,0,0,1-.32-.15.47.47,0,0,1-.13-.35V8.63s0-.05,0-.05h0a0,0,0,0,1,0,.05h0v.71a.44.44,0,0,0,.11.29.34.34,0,0,0,.48,0l0,0a.46.46,0,0,0,.11-.29V8.64s0,0,0,0a0,0,0,0,1,0,0v.71a.53.53,0,0,1-.13.36.52.52,0,0,1-.33.13"
        style="fill: #fff"
      ></path>
      <path
        d="M43,8.61s0,0,0,0v0h-.32V9.79a0,0,0,0,1,0,0,0,0,0,0,1,0,0V8.65h-.34s0,0,0,0Z"
        style="fill: #fff"
      ></path>
      <path
        d="M42.65,9.84a0,0,0,0,1,0,0V8.67h-.29s0,0,0,0,0-.05,0-.05H43s0,0,0,.05a0,0,0,0,1,0,0h-.3V9.79a0,0,0,0,1,0,0h0"
        style="fill: #fff"
      ></path>
      <path
        d="M44,8.61s0,0,0,0V9.79s0,0,0,0a0,0,0,0,1,0,0V8.63s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M44,8.61v0Zm0,1.23a0,0,0,0,1,0,0h0V8.64a0,0,0,1,1,.08,0V9.8a0,0,0,0,1,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M45.53,9.78a.55.55,0,0,0,.55-.57.56.56,0,0,0-.56-.56.55.55,0,0,0-.55.57.52.52,0,0,0,.17.39.56.56,0,0,0,.39.17m0-1.17a.6.6,0,0,1,.59.6.59.59,0,0,1-.59.6.6.6,0,0,1-.59-.6.6.6,0,0,1,.59-.6"
        style="fill: #fff"
      ></path>
      <path
        d="M45.53,8.67a.54.54,0,1,0,.53.54.58.58,0,0,0-.15-.38.53.53,0,0,0-.38-.16m0,1.17a.63.63,0,0,1,0-1.26.62.62,0,0,1,.62.63.65.65,0,0,1-.18.44.6.6,0,0,1-.44.19"
        style="fill: #fff"
      ></path>
      <path
        d="M47.52,8.61a.41.41,0,0,1,.31.14.46.46,0,0,1,.12.34v.7a0,0,0,0,1,0,0h0a0,0,0,0,1,0,0v-.7a.47.47,0,0,0-.12-.31.37.37,0,0,0-.56,0,.43.43,0,0,0-.12.31v.73s0,0,0,0V8.64h0V8.9a.5.5,0,0,1,.15-.2.45.45,0,0,1,.26-.09"
        style="fill: #fff"
      ></path>
      <path
        d="M47.93,9.84a0,0,0,0,1,0,0h0v-.7a.46.46,0,0,0-.11-.29.34.34,0,0,0-.48,0l0,0a.46.46,0,0,0-.11.29V9.8a0,0,0,0,1-.08,0V8.64a0,0,0,1,1,.08,0V8.8a.63.63,0,0,1,.11-.12.45.45,0,0,1,.26-.08.41.41,0,0,1,.32.15.47.47,0,0,1,.13.36v.71s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M48.88,9.81h0v0h.42a.28.28,0,0,0,.23-.09.32.32,0,0,0,.07-.19.26.26,0,0,0-.1-.24,1,1,0,0,0-.24,0,.75.75,0,0,1-.26,0,.27.27,0,0,1-.12-.25.29.29,0,0,1,.07-.2.25.25,0,0,1,.2-.1h.4s0,0,0,0h-.4a.21.21,0,0,0-.17.08.28.28,0,0,0-.06.18.23.23,0,0,0,.1.22.61.61,0,0,0,.24,0,.75.75,0,0,1,.26.05.28.28,0,0,1,.12.27.32.32,0,0,1-.1.22.31.31,0,0,1-.24.08Z"
        style="fill: #fff"
      ></path>
      <path
        d="M49.28,9.84h-.43s0,0,0,0,0,0,0,0h.44a.27.27,0,0,0,.21-.07.26.26,0,0,0,.07-.16c0-.11,0-.18-.09-.21a.6.6,0,0,0-.24-.05A.58.58,0,0,1,49,9.2a.26.26,0,0,1-.13-.28.34.34,0,0,1,.07-.22.27.27,0,0,1,.22-.11h.39l0,0a0,0,0,0,1,0,0s0,0,0,0h-.42a.21.21,0,0,0-.15.07.22.22,0,0,0-.05.16.19.19,0,0,0,.09.19.59.59,0,0,0,.23.05.63.63,0,0,1,.27.06.28.28,0,0,1,.13.29.36.36,0,0,1-.1.25.57.57,0,0,1-.28.08"
        style="fill: #fff"
      ></path>
      <path
        d="M8.49,4.51,6.79,6.07V9.84H6.11V5.76L8,4ZM7.72,1.18,5.81,3.61V9.83H5.13V3.37L7.2.75ZM4.84,9.84H4.16v-5L1.94,2.59l.49-.49L4.84,4.57ZM10.23,0H0V10.4H10.23Z"
        style="fill: #fff"
      ></path>
    </svg>
    &nbsp;<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38.59 10.46"
      class="company-logo"
    >
      <path
        d="M20.44.12h4a2.11,2.11,0,0,1,0,.83h-3c0,.06,0,1.86,0,2h2.39a2.11,2.11,0,0,1,0,.83H21.47V6.07h3.08a3.22,3.22,0,0,1,0,.82H20.44Z"
        style="fill: #fff"
      ></path>
      <path
        d="M29.82.27A2.61,2.61,0,0,1,29.6,1l-.08,0a4.22,4.22,0,0,0-.87-.19l-.33,0a2.83,2.83,0,0,0-.71,0,1.35,1.35,0,0,0-.51.21.77.77,0,0,0-.31.52.87.87,0,0,0,0,.36.81.81,0,0,0,.28.43,1.84,1.84,0,0,0,.61.34l.8.29a4.61,4.61,0,0,1,.81.38,1.72,1.72,0,0,1,.7.74,1.71,1.71,0,0,1,.15.59,2.35,2.35,0,0,1-.09.87,1.82,1.82,0,0,1-.91,1.06,2.81,2.81,0,0,1-1,.32A6.4,6.4,0,0,1,27,7a5,5,0,0,1-1.28-.22l-.21-.06a.32.32,0,0,1,0-.17,3,3,0,0,1,.21-.64l0,0,.09,0a5,5,0,0,0,.85.21,4.76,4.76,0,0,0,1,0A2.63,2.63,0,0,0,28.31,6,1.08,1.08,0,0,0,29,5.28a1.18,1.18,0,0,0,0-.62.84.84,0,0,0-.32-.45A2,2,0,0,0,28.2,4l-1.07-.41a4,4,0,0,1-.69-.32,1.51,1.51,0,0,1-.71-1,2,2,0,0,1,0-.87,1.6,1.6,0,0,1,.91-1,2.55,2.55,0,0,1,.91-.24,4.59,4.59,0,0,1,1,0,5.85,5.85,0,0,1,1.18.22s0,0,.07,0"
        style="fill: #fff"
      ></path>
      <path
        d="M38.26.27A3,3,0,0,1,38,1L38,1a3.72,3.72,0,0,0-.75-.17l-.44,0a2.75,2.75,0,0,0-.64,0A1.55,1.55,0,0,0,35.7,1a.8.8,0,0,0-.44.53.83.83,0,0,0,0,.58,1.08,1.08,0,0,0,.33.38,3.26,3.26,0,0,0,.62.31l.86.32a3.32,3.32,0,0,1,.6.29,1.73,1.73,0,0,1,.64.59,1.75,1.75,0,0,1,.23.7,2.34,2.34,0,0,1,0,.7,1.81,1.81,0,0,1-1,1.29,2.85,2.85,0,0,1-.95.3,6.29,6.29,0,0,1-1.15,0A5.54,5.54,0,0,1,34,6.75l-.05,0a3.21,3.21,0,0,1,.24-.84l.08,0a6.69,6.69,0,0,0,.77.2,3.66,3.66,0,0,0,.57,0,3.94,3.94,0,0,0,.77,0,1.52,1.52,0,0,0,.69-.29,1,1,0,0,0,.39-.74,1.33,1.33,0,0,0,0-.4.86.86,0,0,0-.32-.48A1.86,1.86,0,0,0,36.67,4l-1.19-.47A4.67,4.67,0,0,1,35,3.25a1.5,1.5,0,0,1-.82-1.07,1.91,1.91,0,0,1,.06-1,1.61,1.61,0,0,1,.88-.95A2.67,2.67,0,0,1,36,0a4.49,4.49,0,0,1,1,0,5.42,5.42,0,0,1,1.2.23l.07,0"
        style="fill: #fff"
      ></path>
      <path
        d="M5,5.93a2.58,2.58,0,0,1,.28.76.2.2,0,0,0-.08,0,4.23,4.23,0,0,1-1,.25,5.91,5.91,0,0,1-.84,0,3.78,3.78,0,0,1-1.72-.43A2.86,2.86,0,0,1,.37,5.3,3.59,3.59,0,0,1,.06,4.24a3.82,3.82,0,0,1,0-1A3.85,3.85,0,0,1,.41,1.7,3,3,0,0,1,2.61.08,4.91,4.91,0,0,1,3.76,0,5.52,5.52,0,0,1,5,.22l.12,0A2.21,2.21,0,0,1,4.92,1L4.81,1A4.56,4.56,0,0,0,4.17.87a4.72,4.72,0,0,0-.92,0A2.47,2.47,0,0,0,2.49,1a1.94,1.94,0,0,0-1,.89,2.78,2.78,0,0,0-.31.92,5.25,5.25,0,0,0-.06.79,3.53,3.53,0,0,0,.21,1.2A2,2,0,0,0,2,5.67,2.19,2.19,0,0,0,3,6.13a3.77,3.77,0,0,0,1.91-.19H5"
        style="fill: #fff"
      ></path>
      <path
        d="M12.24,5.19V.12a3.22,3.22,0,0,1,1,0V6.9l-.27,0a3,3,0,0,1-.6,0,.17.17,0,0,1-.13-.08L9.11,1.93a.35.35,0,0,1,0-.13A5.11,5.11,0,0,1,9,1c0-.19,0-.38,0-.57a1.1,1.1,0,0,0,0-.18.08.08,0,0,1,0,0l3.12,5h0"
        style="fill: #fff"
      ></path>
      <path
        d="M14.4.12h4.87a2.06,2.06,0,0,1,0,.82H17.36s0,.07,0,.1V6.9a4.52,4.52,0,0,1-1,0v-6H14.4a2.06,2.06,0,0,1,0-.82"
        style="fill: #fff"
      ></path>
      <path
        d="M32.55,6.91a3.56,3.56,0,0,1-1,0V.13a2.55,2.55,0,0,1,1,0Z"
        style="fill: #fff"
      ></path>
      <path
        d="M6.64.12a3.42,3.42,0,0,1,1,0c0,.06,0,6.69,0,6.78a2.91,2.91,0,0,1-1,0Z"
        style="fill: #fff"
      ></path>
      <path
        d="M6.69,9.25s0-.06,0-.09V8.47a0,0,0,0,1,0,0,.77.77,0,0,1,.26,0v2a.56.56,0,0,1-.29,0s0-.06,0-.09V9.61a.28.28,0,0,0,0-.09c-.06,0-.83,0-.92,0s0,.05,0,.08v.82a.48.48,0,0,1-.29,0v-2a1,1,0,0,1,.25,0l0,0s0,0,0,.06v.7s0,0,0,0h.83l.08,0"
        style="fill: #fff"
      ></path>
      <path
        d="M19.43,10.41a.82.82,0,0,1-.31,0,.12.12,0,0,1-.06-.06l-.58-.77-.07-.09.07,0a.83.83,0,0,0,.3-.14.38.38,0,0,0,.16-.4.37.37,0,0,0-.26-.28.88.88,0,0,0-.36,0,0,0,0,0,0-.05,0v1.73a.57.57,0,0,1-.29,0v-2l.15,0a2.25,2.25,0,0,1,.58,0,.77.77,0,0,1,.38.17.51.51,0,0,1,.17.35.55.55,0,0,1-.31.55l-.15.08c0,.07.1.14.15.21l.15.21.15.2a1.16,1.16,0,0,1,.18.22"
        style="fill: #fff"
      ></path>
      <path
        d="M15.71,10.41a.66.66,0,0,1-.28,0V9.57a.69.69,0,0,0,0-.2.25.25,0,0,0-.26-.17.4.4,0,0,0-.4.33,1.11,1.11,0,0,0,0,.19v.69a.66.66,0,0,1-.28,0v-2a.53.53,0,0,1,.28,0V9.2l0,0A.58.58,0,0,1,15.43,9a.38.38,0,0,1,.24.24,1.09,1.09,0,0,1,0,.25c0,.29,0,.58,0,.86v.06"
        style="fill: #fff"
      ></path>
      <path
        d="M31.21,9.2l0,0A.56.56,0,0,1,31.76,9a.42.42,0,0,1,.42.38,1.09,1.09,0,0,1,0,.18v.87a.53.53,0,0,1-.28,0V9.57a.69.69,0,0,0,0-.2.25.25,0,0,0-.25-.17.39.39,0,0,0-.37.22.71.71,0,0,0-.05.29v.7a.61.61,0,0,1-.27,0c0-.06,0-1.93,0-2a.5.5,0,0,1,.27,0v.79s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M8.07,9.57a6.59,6.59,0,0,0,.77,0,.3.3,0,0,0,0-.18.38.38,0,0,0-.61-.1.42.42,0,0,0-.12.28m1,.2h-1a.39.39,0,0,0,.35.45,1.06,1.06,0,0,0,.47,0l.08,0a.36.36,0,0,1,0,.21.6.6,0,0,1-.23.06,1.77,1.77,0,0,1-.46,0A.62.62,0,0,1,7.78,10a1,1,0,0,1,0-.55A.65.65,0,0,1,8.43,9a.82.82,0,0,1,.22,0A.53.53,0,0,1,9,9.22a.67.67,0,0,1,.12.55"
        style="fill: #fff"
      ></path>
      <path
        d="M21,9.57a.36.36,0,0,0-.18-.34.41.41,0,0,0-.4,0,.41.41,0,0,0-.19.34Zm.27.2h-1a.22.22,0,0,0,0,.16.37.37,0,0,0,.34.29,1.12,1.12,0,0,0,.48,0l.07,0a.36.36,0,0,1,0,.21l-.09,0a1.46,1.46,0,0,1-.59,0A.62.62,0,0,1,20,9.9a1,1,0,0,1,0-.46A.66.66,0,0,1,20.65,9l.27,0a.53.53,0,0,1,.35.33.79.79,0,0,1,0,.43"
        style="fill: #fff"
      ></path>
      <path
        d="M24.77,9.57a.35.35,0,0,0-.37-.39.36.36,0,0,0-.38.39Zm-.76.2a.41.41,0,0,0,.45.46,1.24,1.24,0,0,0,.38-.05l.07,0a.35.35,0,0,1,.05.2.77.77,0,0,1-.26.07,1.24,1.24,0,0,1-.43,0,.62.62,0,0,1-.54-.46,1,1,0,0,1,0-.57A.64.64,0,0,1,24.39,9a.74.74,0,0,1,.41.1.59.59,0,0,1,.26.43,2.42,2.42,0,0,1,0,.27H24"
        style="fill: #fff"
      ></path>
      <path
        d="M10.68,9.76a1.2,1.2,0,0,0-.28,0l-.17,0a.23.23,0,0,0-.17.28.21.21,0,0,0,.23.18c.11,0,.23,0,.34,0l0,0Zm.29.62a2,2,0,0,1-.81,0,.42.42,0,0,1-.2-.78.73.73,0,0,1,.41-.12h.3a.25.25,0,0,0-.2-.33.86.86,0,0,0-.39,0l-.12,0A.36.36,0,0,1,9.9,9L10,9a1.57,1.57,0,0,1,.53,0,.43.43,0,0,1,.42.4.76.76,0,0,1,0,.15v.84Z"
        style="fill: #fff"
      ></path>
      <path
        d="M26.61,9.75a.9.9,0,0,0-.28,0,.51.51,0,0,0-.17,0A.23.23,0,0,0,26,10a.22.22,0,0,0,.23.19c.11,0,.22,0,.33,0l.05,0V9.75Zm0-.22a.26.26,0,0,0-.27-.34,1.16,1.16,0,0,0-.37,0l-.08,0A.26.26,0,0,1,25.84,9l.1,0a1.57,1.57,0,0,1,.53,0l.14,0a.4.4,0,0,1,.29.36s0,0,0,.07v.9a.08.08,0,0,1,0,0l-.33,0a1.42,1.42,0,0,1-.46,0,.64.64,0,0,1-.18-.06.44.44,0,0,1-.15-.12.44.44,0,0,1,.12-.6.78.78,0,0,1,.39-.12h.32"
        style="fill: #fff"
      ></path>
      <path
        d="M23,9.05,23,9.24l-.11,0a.73.73,0,0,0-.36,0h0c-.07,0-.13.05-.14.13a.16.16,0,0,0,.1.17l.15.06.23.08A.36.36,0,0,1,23,10a.39.39,0,0,1-.18.39.86.86,0,0,1-.42.12,1.72,1.72,0,0,1-.39,0l-.07,0a.39.39,0,0,1,.06-.21l.08,0a1,1,0,0,0,.42,0,.33.33,0,0,0,.16-.07.17.17,0,0,0,0-.28.69.69,0,0,0-.15-.07l-.24-.08-.08,0a.32.32,0,0,1-.2-.33.35.35,0,0,1,.24-.32A.7.7,0,0,1,22.5,9a1.32,1.32,0,0,1,.48.06s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M30.13,9.23a1.37,1.37,0,0,0-.34,0,.4.4,0,0,0-.4.24.68.68,0,0,0,0,.56.41.41,0,0,0,.26.22,1,1,0,0,0,.42,0h.07a.42.42,0,0,1,.05.2l-.2,0a1.36,1.36,0,0,1-.45,0,.63.63,0,0,1-.48-.42,1,1,0,0,1,0-.59A.65.65,0,0,1,29.7,9a1.2,1.2,0,0,1,.38,0c.09,0,.09,0,.07.1s0,.06,0,.09,0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M13.75,9v.2c-.13,0-.26,0-.39,0s0,0,0,.06V10a1,1,0,0,0,0,.16.13.13,0,0,0,.14.11h.24a.31.31,0,0,1,0,.19.86.86,0,0,1-.28,0h-.13a.35.35,0,0,1-.3-.33V9.23h-.25s0,0,0-.05l.47-.49h0a.49.49,0,0,1,0,.17V9h.42Z"
        style="fill: #fff"
      ></path>
      <path
        d="M12.36,10.22a1.24,1.24,0,0,1,0,.18l0,0a.74.74,0,0,1-.39,0,.29.29,0,0,1-.2-.24.49.49,0,0,1,0-.12V8.39a.66.66,0,0,1,.28,0V10a.59.59,0,0,0,0,.14c0,.08.07.11.16.11a.32.32,0,0,0,.14,0"
        style="fill: #fff"
      ></path>
      <path
        d="M28,10.41a.61.61,0,0,1-.27,0c0-.06,0-1.34,0-1.42h.19s0,0,0,0,0,.08,0,.11,0,0,0,.06A.56.56,0,0,1,28.21,9a.54.54,0,0,1,.28,0,.36.36,0,0,1,0,.23h-.08a.37.37,0,0,0-.41.34.71.71,0,0,0,0,.14v.71"
        style="fill: #fff"
      ></path>
      <path
        d="M16.48,10.41a.48.48,0,0,1,0-.29.88.88,0,0,1,.28,0,0,0,0,0,1,0,0v.22s0,0-.05,0a.61.61,0,0,1-.27,0"
        style="fill: #fff"
      ></path>
      <path
        d="M33,10.41a.57.57,0,0,1,0-.29.71.71,0,0,1,.29,0s0,0,0,0v.22s0,0,0,0a.88.88,0,0,1-.28,0"
        style="fill: #fff"
      ></path>
    </svg>
    &nbsp;
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32.55 10.46"
      class="company-logo"
    >
      <path
        d="M8.2,1H7.62V.87H9.3a2.19,2.19,0,0,1,1.14.25.88.88,0,0,1,.42.81.87.87,0,0,1-.45.8A2,2,0,0,1,9.36,3a1.34,1.34,0,0,1-.55-.09V4.62h.6v.09H7.62V4.62H8.2V1ZM8.8,2.8a.76.76,0,0,0,.2.08,1,1,0,0,0,.93-.18.81.81,0,0,0,.3-.71A1.06,1.06,0,0,0,10,1.21,1.15,1.15,0,0,0,9.18,1H8.82V2.8Z"
        style="fill: #fff"
      ></path>
      <path
        d="M13.25.79a1.76,1.76,0,0,1,1.31.59,2,2,0,0,1,.56,1.41,2,2,0,0,1-.55,1.42A1.76,1.76,0,0,1,12,4.2a2,2,0,0,1-.56-1.41,2,2,0,0,1,.55-1.42A1.75,1.75,0,0,1,13.25.79m0,3.91A.9.9,0,0,0,14,4.39a1.57,1.57,0,0,0,.36-.73,4.17,4.17,0,0,0,.09-.88,4.19,4.19,0,0,0-.09-.89A1.62,1.62,0,0,0,14,1.17a1,1,0,0,0-.75-.31.9.9,0,0,0-.74.31,1.73,1.73,0,0,0-.36.73,4.17,4.17,0,0,0-.09.88,4.1,4.1,0,0,0,.09.88,1.52,1.52,0,0,0,.35.72.9.9,0,0,0,.75.32"
        style="fill: #fff"
      ></path>
      <path
        d="M16.13,1h-.59V.87h1.81a2.36,2.36,0,0,1,1,.2.77.77,0,0,1,.39.76.66.66,0,0,1-.39.64,2.67,2.67,0,0,1-.87.25,1.78,1.78,0,0,1,.81.23,1,1,0,0,1,.32.69l.08.66a.38.38,0,0,0,.12.27.28.28,0,0,0,.19.07.93.93,0,0,0,.24,0l0,.07-.21,0-.27,0q-.5,0-.63-.21A1.9,1.9,0,0,1,18,3.75l0-.33a.76.76,0,0,0-.2-.48.87.87,0,0,0-.62-.17h-.39V4.61h.6V4.7h-1.8V4.61h.59V1Zm.6,1.73H17a1.47,1.47,0,0,0,.83-.2.74.74,0,0,0,.28-.66,1,1,0,0,0-.21-.64A1,1,0,0,0,17.14,1h-.4V2.69Z"
        style="fill: #fff"
      ></path>
      <path
        d="M21,1h-.12a1.82,1.82,0,0,0-1,.19c-.16.12-.24.41-.24.85h-.1V.87h3.61V2H23a1.09,1.09,0,0,0-.24-.85,1.85,1.85,0,0,0-1-.19h-.13V4.62h.61v.09H20.4V4.62H21Z"
        style="fill: #fff"
      ></path>
      <path
        d="M25.42.79a1.77,1.77,0,0,1,1.31.59,2,2,0,0,1,.56,1.41,2,2,0,0,1-.55,1.42,1.76,1.76,0,0,1-2.62,0,2,2,0,0,1-.56-1.41,2,2,0,0,1,.55-1.42A1.72,1.72,0,0,1,25.42.79m0,3.91a.9.9,0,0,0,.74-.31,1.57,1.57,0,0,0,.36-.73,4.17,4.17,0,0,0,.09-.88,4.19,4.19,0,0,0-.09-.89,1.73,1.73,0,0,0-.35-.72,1,1,0,0,0-.76-.31.93.93,0,0,0-.75.31,1.57,1.57,0,0,0-.36.73,4.17,4.17,0,0,0-.09.88,4.1,4.1,0,0,0,.09.88,1.52,1.52,0,0,0,.35.72,1,1,0,0,0,.77.32"
        style="fill: #fff"
      ></path>
      <path
        d="M6,4.36a.34.34,0,0,1-.12.27.4.4,0,0,1-.3.11.44.44,0,0,1-.3-.11.36.36,0,0,1,0-.54.46.46,0,0,1,.6,0A.36.36,0,0,1,6,4.36M5,1H4.82a.26.26,0,0,0-.23.11.63.63,0,0,0-.07.35v2a1.24,1.24,0,0,1-.39,1A1.67,1.67,0,0,1,3,4.77,1.77,1.77,0,0,1,1.8,4.41a1.21,1.21,0,0,1-.43-1V1H.91V.87H2.77V1H2.29V3.36a1.55,1.55,0,0,0,.22.91.86.86,0,0,0,.82.32A1.06,1.06,0,0,0,4,4.31a1.07,1.07,0,0,0,.3-.82V1.43a.54.54,0,0,0-.09-.35A.26.26,0,0,0,4,1H3.82V.87H5V1ZM7,0H0V5.57H7Z"
        style="fill: #fff"
      ></path>
      <path
        d="M9.26,10a.39.39,0,0,1-.16.35.57.57,0,0,1-.37.12.62.62,0,0,1-.38-.12A.42.42,0,0,1,8.19,10V9.14h.17v.77c0,.08,0,.13,0,.17a.27.27,0,0,0,.06.1.41.41,0,0,0,.56,0,.21.21,0,0,0,.06-.1.72.72,0,0,0,0-.17V9.14h.17V10Z"
        style="fill: #fff"
      ></path>
      <path
        d="M10.77,10.4h-.2l-.68-1v0l0,0,0-.07v1.08H9.65V9.14h.22l.67.95h0s0,0,0,0v0h0V9.12h.17V10.4Z"
        style="fill: #fff"
      ></path>
      <rect
        x="11.22"
        y="9.14"
        width="0.17"
        height="1.25"
        style="fill: #fff"
      ></rect>
      <path
        d="M12.79,9.14l-.52,1.28h-.1l-.53-1.28h.18l.4,1a.13.13,0,0,1,0,.06s0,0,0-.06l.38-1Z"
        style="fill: #fff"
      ></path>
      <polygon
        points="13.03 9.14 13.03 10.39 13.81 10.39 13.81 10.26 13.2 10.26 13.2 9.82 13.69 9.82 13.69 9.69 13.2 9.69 13.2 9.27 13.79 9.27 13.79 9.14 13.03 9.14"
        style="fill: #fff"
      ></polygon>
      <path
        d="M15.05,10.39h-.19l-.37-.53h-.18v.53h-.18V9.14h.6l.07,0,.06.05a.32.32,0,0,1,.11.24.36.36,0,0,1-.32.35Zm-.26-.91a.22.22,0,0,0-.07-.17.4.4,0,0,0-.2,0H14.3v.45h.22q.27,0,.27-.24"
        style="fill: #fff"
      ></path>
      <path
        d="M16.09,9.23,16,9.36l-.08,0-.06,0a.58.58,0,0,0-.19,0,.36.36,0,0,0-.19.05.15.15,0,0,0-.07.13.14.14,0,0,0,.06.12l.27.15a.86.86,0,0,1,.21.13.28.28,0,0,1,.1.23.29.29,0,0,1-.12.25.53.53,0,0,1-.32.09.66.66,0,0,1-.25,0l-.17-.09.09-.12.09.05.07,0a.63.63,0,0,0,.19,0,.33.33,0,0,0,.19,0,.17.17,0,0,0,.07-.14.2.2,0,0,0,0-.09.22.22,0,0,0-.11-.1l-.08,0-.14-.07c-.19-.09-.29-.2-.29-.33a.29.29,0,0,1,.12-.24.53.53,0,0,1,.32-.09.8.8,0,0,1,.23,0,.52.52,0,0,1,.16.07"
        style="fill: #fff"
      ></path>
      <rect
        x="16.42"
        y="9.14"
        width="0.17"
        height="1.25"
        style="fill: #fff"
      ></rect>
      <path
        d="M18.17,9.76a.64.64,0,0,1-.18.45.6.6,0,0,1-.21.14.81.81,0,0,1-.29,0H17V9.14h.45a.73.73,0,0,1,.49.17.58.58,0,0,1,.19.45m-.18,0a.47.47,0,0,0-.15-.35.56.56,0,0,0-.38-.14H17.2v1h.26a.56.56,0,0,0,.37-.11l.07-.08A.31.31,0,0,0,18,10a.38.38,0,0,0,0-.1.45.45,0,0,0,0-.11"
        style="fill: #fff"
      ></path>
      <path
        d="M19.47,10.39h-.18L19.15,10H18.6l-.14.37h-.18l.5-1.28H19Zm-.37-.51-.22-.57-.22.57Z"
        style="fill: #fff"
      ></path>
      <path
        d="M20.84,9.76a.64.64,0,0,1-.18.45.6.6,0,0,1-.21.14.81.81,0,0,1-.29,0h-.45V9.14h.45a.73.73,0,0,1,.49.17.58.58,0,0,1,.19.45m-.17,0a.47.47,0,0,0-.15-.35.56.56,0,0,0-.38-.14h-.26v1h.26a.52.52,0,0,0,.36-.11l.07-.08a.31.31,0,0,0,.05-.1.19.19,0,0,0,0-.1.52.52,0,0,0,0-.11"
        style="fill: #fff"
      ></path>
      <polygon
        points="21.17 9.14 21.17 10.39 21.95 10.39 21.95 10.26 21.34 10.26 21.34 9.82 21.83 9.82 21.83 9.69 21.34 9.69 21.34 9.27 21.93 9.27 21.93 9.14 21.17 9.14"
        style="fill: #fff"
      ></polygon>
      <path
        d="M23.91,9.76a.64.64,0,0,1-.18.45.6.6,0,0,1-.21.14.81.81,0,0,1-.29,0h-.45V9.14h.45a.73.73,0,0,1,.49.17.58.58,0,0,1,.19.45m-.17,0a.47.47,0,0,0-.15-.35.56.56,0,0,0-.38-.14H23v1h.26a.5.5,0,0,0,.36-.11l.07-.08a.31.31,0,0,0,.05-.1l0-.1a.52.52,0,0,0,0-.11"
        style="fill: #fff"
      ></path>
      <path
        d="M25.48,9.76a.59.59,0,0,1-.19.46.76.76,0,0,1-1,0,.65.65,0,0,1,0-.92.76.76,0,0,1,1,0,.64.64,0,0,1,.19.46m-.19,0a.49.49,0,0,0-.15-.36.48.48,0,0,0-.7,0,.48.48,0,0,0-.14.36.52.52,0,0,0,.14.36.48.48,0,0,0,.7,0,.46.46,0,0,0,.15-.36"
        style="fill: #fff"
      ></path>
      <path
        d="M27.17,9.51a.52.52,0,0,1,0,.18.26.26,0,0,1-.1.13.36.36,0,0,1-.15.08.64.64,0,0,1-.2,0h-.21v.47h-.17V9.14h.42a.45.45,0,0,1,.33.1.33.33,0,0,1,.11.27m-.17,0a.24.24,0,0,0-.08-.19.3.3,0,0,0-.21-.05h-.23v.51h.18a.42.42,0,0,0,.18,0A.27.27,0,0,0,27,9.68a.29.29,0,0,0,0-.16"
        style="fill: #fff"
      ></path>
      <path
        d="M28.69,9.76a.59.59,0,0,1-.19.46.76.76,0,0,1-1,0,.61.61,0,0,1-.19-.46.59.59,0,0,1,.19-.46.76.76,0,0,1,1,0,.6.6,0,0,1,.19.46m-.18,0a.49.49,0,0,0-.15-.36.48.48,0,0,0-.7,0,.51.51,0,0,0,0,.72.48.48,0,0,0,.7,0,.46.46,0,0,0,.15-.36"
        style="fill: #fff"
      ></path>
      <path
        d="M29.93,10.39h-.19l-.37-.53h-.18v.53H29V9.14h.6l.07,0,.06.05a.32.32,0,0,1,.11.24.36.36,0,0,1-.32.35Zm-.26-.91a.22.22,0,0,0-.07-.17.4.4,0,0,0-.2,0h-.22v.45h.22q.27,0,.27-.24"
        style="fill: #fff"
      ></path>
      <polygon
        points="31.07 9.27 30.62 9.27 30.62 10.39 30.45 10.39 30.45 9.27 30 9.27 30 9.14 31.07 9.14 31.07 9.27"
        style="fill: #fff"
      ></polygon>
      <path
        d="M32.55,9.76a.59.59,0,0,1-.19.46.76.76,0,0,1-1,0,.65.65,0,0,1,0-.92.76.76,0,0,1,1,0,.6.6,0,0,1,.19.46m-.18,0a.49.49,0,0,0-.15-.36.48.48,0,0,0-.7,0,.48.48,0,0,0-.14.36.52.52,0,0,0,.14.36.48.48,0,0,0,.7,0,.46.46,0,0,0,.15-.36"
        style="fill: #fff"
      ></path>
      <polygon
        points="8.2 6.97 8.2 8.22 8.46 8.22 8.46 7.7 8.93 7.7 8.93 7.5 8.46 7.5 8.46 7.17 9.04 7.17 9.04 6.97 8.2 6.97"
        style="fill: #fff"
      ></polygon>
      <path
        d="M10.3,8.22H10l-.11-.31H9.47l-.11.31H9.09L9.58,7h.23Zm-.45-.51-.16-.45-.16.45Z"
        style="fill: #fff"
      ></path>
      <path
        d="M11.5,7.07l-.1.19a.54.54,0,0,0-.31-.09.48.48,0,0,0-.32.11.37.37,0,0,0-.12.29.44.44,0,0,0,.13.32.52.52,0,0,0,.36.12.89.89,0,0,0,.3-.06l.05.2-.18.06H11.1a.72.72,0,0,1-.49-.16.64.64,0,0,1,0-1,.72.72,0,0,1,.51-.17,1,1,0,0,1,.4.14"
        style="fill: #fff"
      ></path>
      <path
        d="M12.83,7.73a.62.62,0,0,1,0,.26.52.52,0,0,1-.14.16.71.71,0,0,1-.38.09.69.69,0,0,1-.38-.09A.31.31,0,0,1,11.75,8a.64.64,0,0,1,0-.27V7H12v.77c0,.19.11.28.32.28s.3-.09.3-.28V7h.26v.76Z"
        style="fill: #fff"
      ></path>
      <polygon
        points="13.16 6.97 13.16 8.22 13.97 8.22 13.97 8.02 13.42 8.02 13.42 6.97 13.16 6.97"
        style="fill: #fff"
      ></polygon>
      <path
        d="M15.39,7.59A.58.58,0,0,1,15.2,8a.76.76,0,0,1-.55.18h-.5V7h.5a.78.78,0,0,1,.55.18.58.58,0,0,1,.19.44m-.27,0A.38.38,0,0,0,15,7.25a.56.56,0,0,0-.32-.07h-.21V8h.21A.52.52,0,0,0,15,7.9a.39.39,0,0,0,.13-.31"
        style="fill: #fff"
      ></path>
      <path
        d="M16.66,8.22h-.27l-.11-.31h-.45l-.11.31h-.27L15.94,7h.23Zm-.45-.51-.16-.45-.16.45Z"
        style="fill: #fff"
      ></path>
      <path
        d="M18.07,7.59a.58.58,0,0,1-.19.44.78.78,0,0,1-.55.18h-.5V7h.5a.78.78,0,0,1,.55.18.58.58,0,0,1,.19.44m-.28,0a.38.38,0,0,0-.16-.34.56.56,0,0,0-.32-.07H17.1V8h.21a.52.52,0,0,0,.35-.11.36.36,0,0,0,.13-.31"
        style="fill: #fff"
      ></path>
      <polygon
        points="18.31 6.97 18.31 8.22 19.16 8.22 19.16 8.02 18.56 8.02 18.56 7.68 19.03 7.68 19.03 7.48 18.56 7.48 18.56 7.17 19.13 7.17 19.13 6.97 18.31 6.97"
        style="fill: #fff"
      ></polygon>
      <path
        d="M21.14,7.59A.58.58,0,0,1,21,8a.78.78,0,0,1-.55.18h-.5V7h.5a.78.78,0,0,1,.55.18.58.58,0,0,1,.19.44m-.28,0a.38.38,0,0,0-.16-.34.56.56,0,0,0-.32-.07h-.21V8h.21a.52.52,0,0,0,.35-.11.36.36,0,0,0,.13-.31"
        style="fill: #fff"
      ></path>
      <polygon
        points="21.38 6.97 21.38 8.22 22.23 8.22 22.23 8.02 21.63 8.02 21.63 7.68 22.1 7.68 22.1 7.48 21.63 7.48 21.63 7.17 22.2 7.17 22.2 6.97 21.38 6.97"
        style="fill: #fff"
      ></polygon>
      <path
        d="M24.41,8.22h-.25V7.31a.32.32,0,0,0,0,.07v0a.14.14,0,0,0,0,.06l-.31.74h-.23L23.3,7.5l0-.08,0-.12v.92H23V7h.31l.36.89s0,0,0,0l0,.06s0-.07,0-.1L24.1,7h.31Z"
        style="fill: #fff"
      ></path>
      <polygon
        points="24.79 6.97 24.79 8.22 25.64 8.22 25.64 8.02 25.05 8.02 25.05 7.68 25.51 7.68 25.51 7.48 25.05 7.48 25.05 7.17 25.61 7.17 25.61 6.97 24.79 6.97"
        style="fill: #fff"
      ></polygon>
      <path
        d="M27.12,7.59a.58.58,0,0,1-.19.44.76.76,0,0,1-.55.18h-.5V7h.5a.78.78,0,0,1,.55.18.61.61,0,0,1,.19.44m-.28,0a.38.38,0,0,0-.16-.34.56.56,0,0,0-.32-.07h-.21V8h.21a.52.52,0,0,0,.35-.11.36.36,0,0,0,.13-.31"
        style="fill: #fff"
      ></path>
      <rect
        x="27.34"
        y="6.97"
        width="0.26"
        height="1.25"
        style="fill: #fff"
      ></rect>
      <path
        d="M29,7.07l-.1.19a.54.54,0,0,0-.31-.09.48.48,0,0,0-.32.11.39.39,0,0,0-.13.29.44.44,0,0,0,.13.32A.52.52,0,0,0,28.6,8,.89.89,0,0,0,28.9,8l.05.2-.18.06h-.21a.72.72,0,0,1-.49-.16.64.64,0,0,1,0-1,.72.72,0,0,1,.51-.17.87.87,0,0,1,.41.14"
        style="fill: #fff"
      ></path>
      <rect
        x="29.2"
        y="6.97"
        width="0.26"
        height="1.25"
        style="fill: #fff"
      ></rect>
      <path
        d="M31,8.23h-.27l-.58-.81v0s0,0,0,0h0s0,0,0,0v.91h-.24V7h.3l.57.82a0,0,0,0,1,0,0,0,0,0,0,1,0,0l0,0V7H31Z"
        style="fill: #fff"
      ></path>
      <path
        d="M32.41,8.22h-.27L32,7.91h-.45l-.11.31H31.2L31.69,7h.23ZM32,7.71l-.16-.45-.15.45Z"
        style="fill: #fff"
      ></path>
      <rect
        x="0.01"
        y="6.97"
        width="7.02"
        height="3.48"
        style="
          fill: none;
          stroke: #fff;
          stroke-miterlimit: 10;
          stroke-width: 0.019999999552965164px;
        "
      ></rect>
      <rect
        x="0.29"
        y="8.71"
        width="6.45"
        height="1.47"
        style="fill: #ffdf00"
      ></rect>
      <polygon
        points="0.29 8.44 0.29 7.25 1.44 7.25 1.44 7.51 0.74 7.51 0.74 7.74 1.39 7.74 1.39 8 0.74 8 0.74 8.44 0.29 8.44"
        style="fill: #fff"
      ></polygon>
      <polygon
        points="1.63 8.44 1.63 7.25 2.35 7.25 2.68 7.99 3 7.25 3.67 7.25 3.67 8.44 3.26 8.44 3.26 7.48 2.82 8.44 2.49 8.44 2.05 7.48 2.05 8.44 1.63 8.44"
        style="fill: #fff"
      ></polygon>
      <path
        d="M3.86,7.25h.43v.68a.29.29,0,0,0,.07.22.3.3,0,0,0,.23.07.32.32,0,0,0,.22-.07.29.29,0,0,0,.08-.22V7.25h.42v.67a.47.47,0,0,1-.18.41.91.91,0,0,1-.55.13A.91.91,0,0,1,4,8.33a.48.48,0,0,1-.17-.41Z"
        style="fill: #fff"
      ></path>
      <path
        d="M5.92,7.5v.25h.24a.23.23,0,0,0,.13,0,.12.12,0,0,0,0-.18.23.23,0,0,0-.13,0H5.92Zm-.43.94V7.25h.79a.64.64,0,0,1,.38.09.32.32,0,0,1,.12.27.37.37,0,0,1-.12.29.52.52,0,0,1-.35.1H5.93v.43H5.49Z"
        style="fill: #fff"
      ></path>
    </svg>
    &nbsp;
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45.69 11.26"
      class="company-logo"
    >
      <path
        d="M6.28,10.21A1.18,1.18,0,1,0,5.13,9a1.16,1.16,0,0,0,1.15,1.18"
        style="fill: #fff"
      ></path>
      <path
        d="M3.72,10.21A1.18,1.18,0,1,0,2.57,9a1.15,1.15,0,0,0,1.15,1.18"
        style="fill: #fff"
      ></path>
      <path
        d="M3.72,7.59A1.18,1.18,0,1,0,2.57,6.41,1.15,1.15,0,0,0,3.72,7.59"
        style="fill: #fff"
      ></path>
      <path
        d="M1.15,7.59a1.18,1.18,0,0,0,0-2.36A1.19,1.19,0,0,0,0,6.42,1.16,1.16,0,0,0,1.15,7.59"
        style="fill: #fff"
      ></path>
      <path
        d="M3.72,5A1.18,1.18,0,1,0,2.57,3.8,1.16,1.16,0,0,0,3.72,5"
        style="fill: #fff"
      ></path>
      <path
        d="M1.15,5a1.18,1.18,0,0,0,0-2.36A1.18,1.18,0,0,0,1.15,5"
        style="fill: #fff"
      ></path>
      <path
        d="M3.72,2.36A1.16,1.16,0,0,0,4.87,1.18a1.15,1.15,0,1,0-2.3,0A1.16,1.16,0,0,0,3.72,2.36"
        style="fill: #fff"
      ></path>
      <path
        d="M6.28,2.36A1.16,1.16,0,0,0,7.43,1.18a1.15,1.15,0,1,0-2.3,0A1.16,1.16,0,0,0,6.28,2.36"
        style="fill: #fff"
      ></path>
      <path
        d="M9.31,4.36V.21a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V1.94a0,0,0,0,0,0,0h1.85a0,0,0,0,0,0,0V.21a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V4.36a0,0,0,0,1,0,0h-.5a0,0,0,0,1,0,0V2.5a0,0,0,0,0,0,0H9.9s0,0,0,0V4.35a0,0,0,0,1,0,0h-.5s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M13.5,2.6a0,0,0,0,0,0,0h1.59a0,0,0,0,0,0,0,.86.86,0,0,0-.05-.27A.89.89,0,0,0,15,2.08a.67.67,0,0,0-.26-.2.87.87,0,0,0-.37-.07,1,1,0,0,0-.37.08.69.69,0,0,0-.26.21.76.76,0,0,0-.15.26.74.74,0,0,0-.05.24m-.59.27a1.65,1.65,0,0,1,.38-1.14,1.31,1.31,0,0,1,1.05-.43,1.31,1.31,0,0,1,1.05.43,1.69,1.69,0,0,1,.38,1.14.79.79,0,0,1,0,.17,0,0,0,0,1,0,0H13.54a0,0,0,0,0,0,0,.8.8,0,0,0,.23.59.78.78,0,0,0,.6.24.76.76,0,0,0,.74-.42s0,0,0,0h.54s0,0,0,0v0a1.11,1.11,0,0,1-.47.68,1.53,1.53,0,0,1-.86.25,1.33,1.33,0,0,1-1-.43,1.64,1.64,0,0,1-.39-1.14"
        style="fill: #fff"
      ></path>
      <path
        d="M16.69,3.49a.42.42,0,0,0,.15.32.68.68,0,0,0,.47.13,1.25,1.25,0,0,0,.45-.07.74.74,0,0,0,.3-.19,1,1,0,0,0,.16-.25.88.88,0,0,0,.06-.28V3.06a0,0,0,0,0,0,0h-.82l-.32,0a.71.71,0,0,0-.21.08.4.4,0,0,0-.12.1.34.34,0,0,0-.06.12.16.16,0,0,0,0,.12m-.56,0a.8.8,0,0,1,.33-.66,1.55,1.55,0,0,1,1-.25h.76a.09.09,0,0,0,.06,0,.17.17,0,0,0,0,0V2.4a.81.81,0,0,0,0-.16.47.47,0,0,0-.06-.15A.41.41,0,0,0,18.07,2a.5.5,0,0,0-.22-.09,1.2,1.2,0,0,0-.35,0A.83.83,0,0,0,17,2a.48.48,0,0,0-.18.39,0,0,0,0,1,0,0h-.5a0,0,0,0,1,0,0,.93.93,0,0,1,.18-.58,1.12,1.12,0,0,1,.47-.36,1.8,1.8,0,0,1,.62-.11,1.46,1.46,0,0,1,1,.28,1,1,0,0,1,.35.82V3.58a.44.44,0,0,0,.05.23s.1.07.2.07h.11a0,0,0,0,1,0,0v.45a0,0,0,0,1,0,0h-.24a.54.54,0,0,1-.55-.27s0,0,0,0h0a1.06,1.06,0,0,1-.4.24,1.76,1.76,0,0,1-.64.1,1.36,1.36,0,0,1-.88-.26,1,1,0,0,1-.26-.7"
        style="fill: #fff"
      ></path>
      <path
        d="M19.65,4.36V.21a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V4.36a0,0,0,0,1,0,0h-.5a0,0,0,0,1,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M20.61,1.78V1.39a0,0,0,0,1,0,0h.52a0,0,0,0,0,0,0V.52a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0v.81a0,0,0,0,0,0,0h.63a0,0,0,0,1,0,0v.39a0,0,0,0,1,0,0h-.63a0,0,0,0,0,0,0V3.58c0,.2.11.3.32.3h.34a0,0,0,0,1,0,0v.45a0,0,0,0,1,0,0h-.48a.81.81,0,0,1-.54-.17.7.7,0,0,1-.2-.54V1.84a0,0,0,0,0,0,0h-.52a0,0,0,0,1,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M22.84,4.36V.21a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V1.66s0,0,0,0,0,0,0,0a1.09,1.09,0,0,1,.33-.27.94.94,0,0,1,.43-.1,1.73,1.73,0,0,1,.48.07,1,1,0,0,1,.36.2,1.1,1.1,0,0,1,.25.31,1.64,1.64,0,0,1,.14.39,2.12,2.12,0,0,1,.05.44V4.35a0,0,0,0,1,0,0H25a0,0,0,0,1,0,0V2.71a1.27,1.27,0,0,0,0-.34,1.08,1.08,0,0,0-.13-.29.82.82,0,0,0-.25-.2.83.83,0,0,0-.36-.08.68.68,0,0,0-.42.13.86.86,0,0,0-.27.33,1.08,1.08,0,0,0-.09.44V4.34a0,0,0,0,1,0,0h-.5s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M27.41,2.28a2.63,2.63,0,0,1,.22-1.12A1.7,1.7,0,0,1,28.27.4a1.73,1.73,0,0,1,1-.28,2,2,0,0,1,.66.11,1.37,1.37,0,0,1,.48.27,1.69,1.69,0,0,1,.31.35,1.46,1.46,0,0,1,.18.35,1,1,0,0,1,.05.27,0,0,0,0,1,0,0H30.4s0,0,0,0a1.09,1.09,0,0,0-1.1-.84,1.11,1.11,0,0,0-.94.44A2,2,0,0,0,28,2.29a2,2,0,0,0,.33,1.22,1.11,1.11,0,0,0,.94.44,1.25,1.25,0,0,0,.45-.08A1.12,1.12,0,0,0,30,3.65a2,2,0,0,0,.2-.26,1.59,1.59,0,0,0,.12-.27s0,0,0,0h.51a0,0,0,0,1,0,0,.83.83,0,0,1-.06.29,1.35,1.35,0,0,1-.19.35,1.7,1.7,0,0,1-.32.34,1.81,1.81,0,0,1-.48.26,1.91,1.91,0,0,1-.64.1,2,2,0,0,1-.83-.16,1.54,1.54,0,0,1-.58-.45,2,2,0,0,1-.33-.68,3.62,3.62,0,0,1-.1-.89"
        style="fill: #fff"
      ></path>
      <path
        d="M31.42,4.36V.21a0,0,0,0,1,0,0H32a0,0,0,0,1,0,0V4.36a0,0,0,0,1,0,0h-.5a0,0,0,0,1,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M32.63,3V1.39a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V3a1.27,1.27,0,0,0,0,.34.9.9,0,0,0,.13.28.61.61,0,0,0,.24.21.84.84,0,0,0,.37.08.68.68,0,0,0,.42-.13.86.86,0,0,0,.27-.33A1.08,1.08,0,0,0,34.75,3V1.39a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0v3a0,0,0,0,1,0,0h-.44s0,0,0,0l-.06-.27s0,0,0,0l0,0a.86.86,0,0,1-.3.25.9.9,0,0,1-.46.11,1.58,1.58,0,0,1-.61-.11,1,1,0,0,1-.4-.31,1.38,1.38,0,0,1-.21-.44A1.65,1.65,0,0,1,32.63,3"
        style="fill: #fff"
      ></path>
      <path
        d="M35.79,3.39a0,0,0,0,1,0,0h.49s0,0,0,0a.49.49,0,0,0,.21.39.89.89,0,0,0,.56.16l.24,0a1,1,0,0,0,.23-.06.38.38,0,0,0,.19-.14.35.35,0,0,0,.07-.23.29.29,0,0,0,0-.09.2.2,0,0,0,0-.08.17.17,0,0,0-.06-.06l-.07,0-.09,0-.1,0-.1,0h-.26l-.24,0L36.62,3l-.25-.07a1.36,1.36,0,0,1-.2-.11A.5.5,0,0,1,36,2.68a1,1,0,0,1-.11-.21.82.82,0,0,1,0-.28.77.77,0,0,1,.33-.63A1.38,1.38,0,0,1,37,1.3a1.84,1.84,0,0,1,.65.11,1,1,0,0,1,.46.36,1,1,0,0,1,.17.58s0,0,0,0h-.5a0,0,0,0,1,0,0,.47.47,0,0,0-.19-.4,1.05,1.05,0,0,0-1,0,.38.38,0,0,0-.17.28.51.51,0,0,0,0,.13.16.16,0,0,0,.07.09l.09.07a.33.33,0,0,0,.13,0l.13,0,.14,0,.13,0a4,4,0,0,1,.66.12.79.79,0,0,1,.59.5,1.17,1.17,0,0,1,0,.27.9.9,0,0,1-.17.55,1,1,0,0,1-.45.32,2.19,2.19,0,0,1-.66.09,1.44,1.44,0,0,1-1-.3.9.9,0,0,1-.35-.74"
        style="fill: #fff"
      ></path>
      <path
        d="M38.59,1.78V1.39a0,0,0,0,1,0,0h.52a0,0,0,0,0,0,0V.52a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0v.81a0,0,0,0,0,0,0h.63a0,0,0,0,1,0,0v.39a0,0,0,0,1,0,0h-.63a0,0,0,0,0,0,0V3.58c0,.2.11.3.32.3h.34a0,0,0,0,1,0,0v.45a0,0,0,0,1,0,0H39.9a.81.81,0,0,1-.54-.17.7.7,0,0,1-.2-.54V1.84a0,0,0,0,0,0,0h-.52s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M41.24,2.6a0,0,0,0,0,0,0h1.59a0,0,0,0,0,0,0,.86.86,0,0,0,0-.27.89.89,0,0,0-.14-.25.75.75,0,0,0-.26-.2.87.87,0,0,0-.37-.07,1,1,0,0,0-.37.08.69.69,0,0,0-.26.21.76.76,0,0,0-.15.26.55.55,0,0,0,0,.24m-.6.27A1.65,1.65,0,0,1,41,1.73a1.5,1.5,0,0,1,2.1,0,1.69,1.69,0,0,1,.38,1.14.79.79,0,0,1,0,.17s0,0,0,0H41.27a0,0,0,0,0,0,0,.8.8,0,0,0,.23.59.78.78,0,0,0,.6.24.76.76,0,0,0,.74-.42s0,0,0,0h.54s0,0,0,0v0a1.11,1.11,0,0,1-.47.68,1.53,1.53,0,0,1-.86.25A1.33,1.33,0,0,1,41,4a1.64,1.64,0,0,1-.39-1.14"
        style="fill: #fff"
      ></path>
      <path
        d="M44,4.36v-3a0,0,0,0,1,0,0h.44s0,0,0,0l.06.27s0,0,0,0l0,0A1.34,1.34,0,0,1,45,1.39a.76.76,0,0,1,.37-.1h.3a0,0,0,0,1,0,0v.45a0,0,0,0,1,0,0h-.3a.68.68,0,0,0-.42.13.86.86,0,0,0-.27.33,1.08,1.08,0,0,0-.09.44V4.34a0,0,0,0,1,0,0h-.5s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M9.92,7.82a0,0,0,0,0,0,0H11a.68.68,0,0,0,.5-.22.74.74,0,0,0,.21-.53.76.76,0,0,0-.22-.54A.67.67,0,0,0,11,6.33H10a0,0,0,0,0,0,0ZM9.37,10V5.85a0,0,0,0,1,0,0h1.71A1.12,1.12,0,0,1,11.7,6a1.25,1.25,0,0,1,.44.47,1.3,1.3,0,0,1,.17.64A1.25,1.25,0,0,1,12,8a1.15,1.15,0,0,1-.84.36H10a0,0,0,0,0,0,0V10a0,0,0,0,1,0,0h-.5s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M13.29,7.75a1.18,1.18,0,0,0-.24.77,1.18,1.18,0,0,0,.24.77.78.78,0,0,0,.65.29.8.8,0,0,0,.65-.29,1.16,1.16,0,0,0,.24-.77,1.18,1.18,0,0,0-.24-.77.78.78,0,0,0-.65-.29.81.81,0,0,0-.65.29m-.8.77a1.61,1.61,0,0,1,.39-1.14A1.35,1.35,0,0,1,14,7,1.34,1.34,0,0,1,15,7.38a1.64,1.64,0,0,1,.39,1.14A1.64,1.64,0,0,1,15,9.66a1.34,1.34,0,0,1-1.06.43,1.37,1.37,0,0,1-1.07-.43,1.61,1.61,0,0,1-.39-1.14"
        style="fill: #fff"
      ></path>
      <path
        d="M15.94,10V7a0,0,0,0,1,0,0h.44s0,0,0,0l.06.27s0,0,0,0l0,0A1.34,1.34,0,0,1,16.9,7,.75.75,0,0,1,17.27,7h.3a0,0,0,0,1,0,0v.45a0,0,0,0,1,0,0h-.3a.68.68,0,0,0-.42.13.86.86,0,0,0-.27.33,1.08,1.08,0,0,0-.09.44V10a0,0,0,0,1,0,0H16s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M17.86,7.43V7a0,0,0,0,1,0,0h.52a0,0,0,0,0,0,0V6.17a0,0,0,0,1,0,0H19a0,0,0,0,1,0,0V7a0,0,0,0,0,0,0h.63a0,0,0,0,1,0,0v.39a0,0,0,0,1,0,0H19a0,0,0,0,0,0,0V9.23c0,.2.1.3.32.3h.34a0,0,0,0,1,0,0V10a0,0,0,0,1,0,0h-.48a.81.81,0,0,1-.54-.17.7.7,0,0,1-.2-.54V7.49a0,0,0,0,0,0,0h-.52a0,0,0,0,1,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M20.05,8.68V7a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V8.68a1.27,1.27,0,0,0,0,.34.9.9,0,0,0,.13.28.7.7,0,0,0,.24.21.84.84,0,0,0,.37.08.68.68,0,0,0,.42-.13.86.86,0,0,0,.27-.33,1.08,1.08,0,0,0,.09-.44V7a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0v3a0,0,0,0,1,0,0h-.44s0,0,0,0l-.06-.27s0,0,0,0l0,0a.86.86,0,0,1-.3.25,1,1,0,0,1-.46.11,1.58,1.58,0,0,1-.61-.11,1,1,0,0,1-.4-.31,1.38,1.38,0,0,1-.21-.44,1.55,1.55,0,0,1-.08-.55"
        style="fill: #fff"
      ></path>
      <path
        d="M24,7.75a1.18,1.18,0,0,0-.24.77,1.18,1.18,0,0,0,.24.77.78.78,0,0,0,.65.29.75.75,0,0,0,.62-.29,1.21,1.21,0,0,0,.22-.77,1.23,1.23,0,0,0-.22-.77.72.72,0,0,0-.62-.29.81.81,0,0,0-.65.29m-.8.77a1.69,1.69,0,0,1,.38-1.14,1.27,1.27,0,0,1,1-.44A1.2,1.2,0,0,1,25,7a1.31,1.31,0,0,1,.38.23s.05,0,.06,0L25.53,7s0,0,0,0H26a0,0,0,0,1,0,0V9.9a1.33,1.33,0,0,1-.38,1,1.38,1.38,0,0,1-1,.38,1.56,1.56,0,0,1-.9-.26.87.87,0,0,1-.41-.63,0,0,0,0,1,0,0h.51s0,0,0,0a.55.55,0,0,0,.23.26.92.92,0,0,0,.51.12.94.94,0,0,0,.39-.07.59.59,0,0,0,.26-.2.87.87,0,0,0,.14-.27,1.06,1.06,0,0,0,0-.31V9.76l0,0a0,0,0,0,0,0,0,1.06,1.06,0,0,1-.32.22,1.17,1.17,0,0,1-.52.12,1.3,1.3,0,0,1-1-.44,1.65,1.65,0,0,1-.41-1.13"
        style="fill: #fff"
      ></path>
      <path
        d="M27.08,9.14a.42.42,0,0,0,.15.32.68.68,0,0,0,.47.13,1.25,1.25,0,0,0,.45-.07.74.74,0,0,0,.3-.19,1,1,0,0,0,.16-.25.88.88,0,0,0,.06-.28V8.71a0,0,0,0,0,0,0h-.82l-.32,0a.71.71,0,0,0-.21.08.4.4,0,0,0-.12.1.34.34,0,0,0-.06.12.16.16,0,0,0,0,.12m-.56,0a.8.8,0,0,1,.33-.66,1.55,1.55,0,0,1,1-.25h.76a.09.09,0,0,0,.06,0l0,0V8.05a.81.81,0,0,0,0-.16.88.88,0,0,0-.05-.15.41.41,0,0,0-.12-.14.5.5,0,0,0-.22-.09,1.2,1.2,0,0,0-.35,0,.83.83,0,0,0-.54.15.48.48,0,0,0-.18.39,0,0,0,0,1,0,0h-.5a0,0,0,0,1,0,0,.93.93,0,0,1,.18-.58,1.12,1.12,0,0,1,.47-.36A1.59,1.59,0,0,1,27.89,7a1.46,1.46,0,0,1,1,.28,1,1,0,0,1,.35.82V9.23a.44.44,0,0,0,.05.23s.1.07.2.07h.11a0,0,0,0,1,0,0V10a0,0,0,0,1,0,0h-.24a.54.54,0,0,1-.55-.27s0,0,0,0h0a1.06,1.06,0,0,1-.4.24,1.75,1.75,0,0,1-.64.11,1.36,1.36,0,0,1-.88-.26.85.85,0,0,1-.27-.71"
        style="fill: #fff"
      ></path>
      <path
        d="M30,10V5.85a0,0,0,0,1,0,0h.5a0,0,0,0,1,0,0V10a0,0,0,0,1,0,0h-.5a0,0,0,0,1,0,0"
        style="fill: #fff"
      ></path>
    </svg>
    &nbsp;
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38.61 10.41"
      class="company-logo"
    >
      <path
        d="M20,5.15a1.26,1.26,0,0,1-.6-.39,2.43,2.43,0,0,1-.71-2.15,2.59,2.59,0,0,1,1.23-2,4.14,4.14,0,0,1,3-.56A4.19,4.19,0,0,1,24.2.47,2.82,2.82,0,0,1,25.72,3c0,.1,0,.13-.12.13H23.88c-.08,0-.11,0-.13-.11a1.3,1.3,0,0,0-1.16-1.3,2.6,2.6,0,0,0-1.24,0,1,1,0,0,0-.71,1.27.73.73,0,0,0,.44.48,11.39,11.39,0,0,0,1.71.56,10.37,10.37,0,0,1,1.61.51,3,3,0,0,1,.72.45s.07,0,.07.1H20"
        style="fill: #fff"
      ></path>
      <path
        d="M2.35,5.14a5.62,5.62,0,0,1,1.06-3.5A3.94,3.94,0,0,1,6,.08a4.44,4.44,0,0,1,2.2.14,3.67,3.67,0,0,1,2.53,3c0,.27,0,.27-.22.27H8.93c-.08,0-.12,0-.15-.11A1.89,1.89,0,0,0,7.21,1.87,2.2,2.2,0,0,0,4.6,3.55a6.13,6.13,0,0,0-.25,1.59Z"
        style="fill: #fff"
      ></path>
      <path
        d="M0,5.1C0,3.54,0,2,0,.43c0-.18,0-.2.2-.2H1.88C2,.23,2,.27,2,.39V9.82C2,10,2,10,1.86,10H.15C0,10,0,9.94,0,9.81,0,8.24,0,6.67,0,5.1"
        style="fill: #fff"
      ></path>
      <path
        d="M13.94,5.15h-2c-.11-.33-.21-.67-.32-1-.28-.91-.55-1.82-.83-2.73C10.66,1,10.55.64,10.43.24h2c.09,0,.14,0,.17.12l1,3.27c.13.46.27.91.4,1.37a.29.29,0,0,1,0,.16"
        style="fill: #fff"
      ></path>
      <path
        d="M17.13,5.15h-2c.39-1.28.77-2.57,1.16-3.85l.27-.93c0-.1.07-.12.16-.12h1.81c.12,0,.14,0,.1.15l-.54,1.76c-.2.66-.41,1.32-.62,2a10.5,10.5,0,0,1-.34,1"
        style="fill: #fff"
      ></path>
      <path
        d="M34.31,6.33c0-.15,0-.22.18-.2s0,0,0-.08v-.2c0-.09,0-.15.12-.15s.11.06.11.15V6c0,.12,0,.18.14.15s.11,0,.11.09,0,.11-.1.1-.15,0-.14.16,0,.49,0,.73,0,.2.16.18.09,0,.09.09,0,.11-.09.12c-.27,0-.38,0-.38-.34s0-.55,0-.83-.07-.12-.15-.12-.06.08-.06.13,0,.14-.06.13-.17.07-.17-.1a.16.16,0,0,0-.18-.18.19.19,0,0,0-.21.15.2.2,0,0,0,.13.25l.3.12a.35.35,0,0,1,.22.38.42.42,0,0,1-.23.41.46.46,0,0,1-.68-.36c0-.06,0-.13.07-.12s.16,0,.17.09.09.24.24.24a.18.18,0,0,0,.2-.15A.24.24,0,0,0,34.07,7a.72.72,0,0,0-.24-.1c-.26-.1-.33-.19-.33-.43a.38.38,0,0,1,.25-.38.45.45,0,0,1,.55.16.1.1,0,0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M24,6.18a1.47,1.47,0,0,1,0,.21c0,.1,0,.16.13.14h.23a.28.28,0,0,0,.24-.26c0-.24-.07-.4-.28-.42s-.31,0-.31.32v0Zm-.23.43a5.48,5.48,0,0,0,0-.81c0-.12,0-.15.14-.15h.42c.27,0,.41.11.47.32a.59.59,0,0,1-.22.65c.21.09.21.28.23.47a1.36,1.36,0,0,0,.06.45c-.23.06-.27,0-.28-.21s0-.23,0-.35-.09-.27-.27-.28h-.08C24,6.7,24,6.7,24,7v.56h0c-.24,0-.24,0-.24-.22s0-.48,0-.73"
        style="fill: #fff"
      ></path>
      <path
        d="M10.78,6.67c-.08,0-.17,0-.26,0s-.11,0-.11.13,0,.44,0,.66,0,.15-.1.15-.11-.06-.11-.14c0-.41,0-.82,0-1.24,0-.15,0-.31,0-.46s.05-.1.11-.1.14,0,.13.1,0,.31,0,.46,0,.24.17.23h.3c.1,0,.14,0,.13-.13s0-.36,0-.55,0-.12.11-.12.13,0,.13.12c0,.57,0,1.14,0,1.71,0,.1,0,.13-.12.13s-.13,0-.12-.13,0-.42,0-.63,0-.21-.16-.18-.06,0-.09,0"
        style="fill: #fff"
      ></path>
      <path
        d="M16.36,7.64a2.1,2.1,0,0,1-.24-.06A.55.55,0,0,1,15.83,7c0-.09.09,0,.14,0s.08,0,.08.1c0,.27.14.38.36.36l0,0a.33.33,0,0,0,.15-.56c-.11-.14-.28-.15-.42-.21A.51.51,0,0,1,15.87,6a.46.46,0,0,1,.42-.39.47.47,0,0,1,.55.28.25.25,0,0,0,0,.07c0,.07.08.17-.06.19s-.14,0-.16-.09-.11-.27-.27-.27a.28.28,0,0,0-.3.23.35.35,0,0,0,.18.4,1.44,1.44,0,0,0,.41.15.54.54,0,0,1,.26.62.5.5,0,0,1-.51.43h-.07"
        style="fill: #fff"
      ></path>
      <path
        d="M28.57,6.84l-.27.1a.28.28,0,0,0-.17.34.17.17,0,0,0,.2.16.27.27,0,0,0,.24-.27V6.84m0,.62a.51.51,0,0,1-.25.17.36.36,0,0,1-.44-.26.44.44,0,0,1,.23-.56l.29-.1a.19.19,0,0,0,.16-.22.19.19,0,0,0-.19-.2.21.21,0,0,0-.24.16s0,.12-.07.14-.18,0-.15-.19.27-.34.52-.31.34.16.34.42v.78c0,.06,0,.14.08.15s0,.08,0,.12,0,.05-.08.06-.21,0-.24-.16"
        style="fill: #fff"
      ></path>
      <path
        d="M9.28,6.91a1.11,1.11,0,0,0-.07-.46.23.23,0,0,0-.36-.09c0,.06,0,.13-.06.2a1.28,1.28,0,0,0,0,.7c0,.11.1.19.21.18a.22.22,0,0,0,.23-.18.92.92,0,0,0,0-.35m.2-.7c0,.41,0,.83,0,1.24,0,0,0,.13-.06.14s-.15,0-.14-.11c-.31.25-.48.22-.69-.13a1.52,1.52,0,0,1,0-.92c.11-.35.37-.42.67-.17V5.78c0-.09,0-.12.11-.12s.12,0,.11.12,0,.28,0,.43"
        style="fill: #fff"
      ></path>
      <path
        d="M7.13,6.84,6.81,7a.23.23,0,0,0-.13.24.21.21,0,0,0,.09.21.21.21,0,0,0,.26,0,.24.24,0,0,0,.1-.21c0-.11,0-.21,0-.33m0,.62a.44.44,0,0,1-.25.17.35.35,0,0,1-.44-.28.43.43,0,0,1,.24-.54A1.31,1.31,0,0,1,7,6.72a.19.19,0,0,0,.17-.23A.18.18,0,0,0,7,6.3a.21.21,0,0,0-.25.17s0,.12-.08.13-.18,0-.14-.18.24-.35.52-.32a.35.35,0,0,1,.35.41V7.3c0,.06,0,.13.08.14s0,.07,0,.11,0,.06-.07.07-.24,0-.28-.16"
        style="fill: #fff"
      ></path>
      <path
        d="M30.8,6.27A.69.69,0,0,1,31,6.11a.34.34,0,0,1,.48.31c0,.36,0,.72,0,1.08,0,.1-.06.09-.12.1s-.11,0-.11-.11c0-.3,0-.6,0-.89s-.06-.3-.19-.3a.28.28,0,0,0-.27.31v.86c0,.08,0,.13-.1.13s-.12,0-.12-.14V5.77c0-.09,0-.13.12-.14s.1.07.1.14,0,.32,0,.5"
        style="fill: #fff"
      ></path>
      <path
        d="M21.81,6.72c.06-.07.22.1.22-.11s-.08-.31-.22-.32a.28.28,0,0,0-.24.34c0,.16.17,0,.24.09m.12.18a.75.75,0,0,0-.15,0c-.07,0-.19-.09-.2.08s.07.44.22.45.21-.08.24-.22,0-.11.08-.11.18,0,.13.17a.42.42,0,0,1-.45.36c-.23,0-.35-.12-.42-.36a1.56,1.56,0,0,1,0-.83.43.43,0,0,1,.45-.35.4.4,0,0,1,.41.36c.1.44.09.45-.32.45"
        style="fill: #fff"
      ></path>
      <path
        d="M5.49,6.72c.07-.08.22.09.24-.11s-.09-.33-.23-.33-.24.15-.24.32.17,0,.23.12m-.42-.37c.08,0,.08-.1.13-.14a.44.44,0,0,1,.72.17l0,.09c.09.39.06.43-.31.43a1.08,1.08,0,0,0-.18,0c-.07,0-.19-.09-.2.08s.07.42.21.45.22,0,.26-.2,0-.12.07-.13.19,0,.14.19a.45.45,0,0,1-.51.34A.43.43,0,0,1,5,7.23a1.75,1.75,0,0,1,0-.85s0,0,0,0h0"
        style="fill: #fff"
      ></path>
      <path
        d="M27.33,6.71c.26,0,.26,0,.26-.12s-.08-.3-.22-.3-.25.14-.24.34.14,0,.2.08m.12.19a.65.65,0,0,0-.14,0c-.07,0-.2-.09-.21.09s.08.42.22.44a.22.22,0,0,0,.25-.23c0-.16.11-.1.17-.1s.05.1,0,.15a.44.44,0,0,1-.38.38.39.39,0,0,1-.48-.31,1.41,1.41,0,0,1,0-1,.43.43,0,0,1,.45-.27.42.42,0,0,1,.38.37c.11.43.09.45-.33.45"
        style="fill: #fff"
      ></path>
      <path
        d="M11.82,6.71h.08c.2,0,.21,0,.15-.22,0,0,0,0,0-.06a.19.19,0,0,0-.25-.13.34.34,0,0,0-.18.36c0,.1.13,0,.2,0h0m.44-.33.06.22s0,0,0,.05c0,.25,0,.25-.25.25a2.25,2.25,0,0,0-.26,0c-.07,0-.18-.07-.19.07s.07.44.21.46.21,0,.25-.19,0-.13.07-.14.12,0,.16,0,0,.1,0,.16a.44.44,0,0,1-.4.35.39.39,0,0,1-.46-.3,1.41,1.41,0,0,1,0-.93c.14-.38.52-.43.81-.12h0c0,.05,0,.09,0,.11"
        style="fill: #fff"
      ></path>
      <path
        d="M37.87,6.71h.3c.2,0,.24-.06.15-.27s-.09-.15-.18-.15a.2.2,0,0,0-.2.14.89.89,0,0,0-.07.28m.37.19H38c-.14,0-.15.06-.13.17l0,.13c0,.13.09.24.23.24a.22.22,0,0,0,.22-.23c0-.15.11-.1.18-.1s0,.11,0,.15a.44.44,0,0,1-.39.37c-.26,0-.4,0-.47-.3a1.47,1.47,0,0,1,0-1,.43.43,0,0,1,.44-.28.4.4,0,0,1,.39.33.64.64,0,0,1,0,.45c-.06.1-.23,0-.33,0"
        style="fill: #fff"
      ></path>
      <path
        d="M32.45,6.87V6.26s0-.11,0-.12.14,0,.17,0,.07,0,.1,0a.38.38,0,0,1,.45,0c.15.09.16.24.16.4,0,.31,0,.62,0,.93,0,.11,0,.13-.12.13s-.11,0-.11-.13v-.9c0-.13,0-.26-.17-.28a.25.25,0,0,0-.27.27c0,.29,0,.59,0,.88,0,.09,0,.15-.12.15s-.11-.07-.11-.16a3.57,3.57,0,0,1,0-.57"
        style="fill: #fff"
      ></path>
      <path
        d="M18.81,6.73c.06-.08.21.08.23-.1S19,6.3,18.82,6.3s-.25.14-.24.34.15,0,.23.09m.47,0c0,.11,0,.17-.15.15h-.48c-.07,0-.1,0-.1.11a1.35,1.35,0,0,0,0,.28.24.24,0,0,0,.23.19c.12,0,.18-.08.21-.2s0-.11,0-.13a.26.26,0,0,1,.15,0c.05,0,0,.09,0,.13a.45.45,0,0,1-.34.36.44.44,0,0,1-.47-.2,1.44,1.44,0,0,1,0-1,.44.44,0,0,1,.87.09,1.77,1.77,0,0,0,0,.22"
        style="fill: #fff"
      ></path>
      <path
        d="M37,6.86v.61s0,.12-.05.12-.15,0-.18,0-.06,0-.09,0c-.3.22-.59.07-.61-.31s0-.66,0-1c0-.11,0-.11.12-.11s.11,0,.11.11c0,.33,0,.65,0,1,0,.1,0,.19.15.2a.22.22,0,0,0,.26-.13.49.49,0,0,0,0-.24v-.8c0-.09,0-.13.11-.12s.14,0,.13.12,0,.4,0,.6Z"
        style="fill: #fff"
      ></path>
      <path
        d="M14.84,6.11c.35,0,.44.08.44.46v.89c0,.09,0,.13-.11.13s-.1,0-.1-.12c0-.3,0-.6,0-.89s-.12-.32-.33-.23-.13.27-.12.43a3.75,3.75,0,0,0,0,.67c0,.07,0,.14-.1.14s-.11-.06-.11-.14V6.66a.37.37,0,0,0,0-.18c0-.24,0-.47,0-.71s0-.12.13-.12.12,0,.11.12,0,.31,0,.48a.83.83,0,0,1,.23-.14"
        style="fill: #fff"
      ></path>
      <path
        d="M8.46,7.43c0,.07,0,.16-.11.17s-.13,0-.12-.14,0-.5,0-.74a1.34,1.34,0,0,0,0-.2c0-.11,0-.21-.17-.22a.24.24,0,0,0-.27.2,1.36,1.36,0,0,0,0,.35v.61c0,.09,0,.14-.11.14s-.12,0-.12-.15V6.28s0-.15.07-.15.17,0,.17.12A.6.6,0,0,1,8,6.09a.34.34,0,0,1,.44.33v1"
        style="fill: #fff"
      ></path>
      <path
        d="M26.06,6.83a.51.51,0,0,1-.12-.46.48.48,0,0,1,.67-.22.4.4,0,0,1,.18.31s0,.12-.06.11-.15.06-.17-.07-.08-.23-.23-.21a.18.18,0,0,0-.16.15.19.19,0,0,0,.08.22.85.85,0,0,0,.22.09c.18.06.35.14.37.39a.48.48,0,0,1-.21.45.55.55,0,0,1-.58-.06l0,0a1.69,1.69,0,0,1-.08-.24c0-.1,0-.15.11-.15s.1,0,.11.1a.26.26,0,0,0,.12.22A.23.23,0,1,0,26.46,7c-.14-.08-.27-.12-.4-.18"
        style="fill: #fff"
      ></path>
      <path
        d="M13.07,6.82l-.27.1-.06,0a.29.29,0,0,0-.13.36.18.18,0,0,0,.2.14.3.3,0,0,0,.26-.26V6.82m-.6.07a1.75,1.75,0,0,1,.43-.17.21.21,0,0,0,.17-.25.19.19,0,0,0-.18-.19.23.23,0,0,0-.27.17s0,.1,0,.11a.26.26,0,0,1-.15,0s0-.08,0-.12c0-.22.14-.31.37-.34s.48.09.48.46v.65c0,.09,0,.19.09.25s0,.11,0,.13a.2.2,0,0,1-.26-.16.51.51,0,0,1-.37.2c-.32-.06-.43-.41-.21-.74"
        style="fill: #fff"
      ></path>
      <path
        d="M22.68,6.11a.51.51,0,0,1,.5.18.89.89,0,0,1,0,.14c0,.05.06.15-.06.14s-.17,0-.17-.11a.16.16,0,0,0-.19-.17.18.18,0,0,0-.2.14.19.19,0,0,0,.12.25l.28.1a.45.45,0,0,1,.2.64.48.48,0,0,1-.58.19.43.43,0,0,1-.29-.44c0-.06,0-.08.07-.07s.16,0,.17.08.06.24.2.25A.2.2,0,0,0,23,7.3.23.23,0,0,0,22.91,7a1.57,1.57,0,0,0-.3-.12c-.22-.1-.26-.19-.25-.45s.11-.27.32-.33"
        style="fill: #fff"
      ></path>
      <path
        d="M20.27,6.84c0,.21,0,.43,0,.64s0,.11-.11.11-.11,0-.11-.11c0-.25,0-.49,0-.74V6.52c0-.13-.06-.22-.2-.22a.24.24,0,0,0-.24.23,1.34,1.34,0,0,0,0,.2,4.43,4.43,0,0,0,0,.73c0,.09,0,.12-.11.12s-.1,0-.1-.12a5.93,5.93,0,0,0,0-.73V6.24s0-.1,0-.1.15,0,.17,0,.08,0,.1,0a.38.38,0,0,1,.42,0,.35.35,0,0,1,.17.34c0,.12,0,.25,0,.37"
        style="fill: #fff"
      ></path>
      <path
        d="M17,6.84a1.06,1.06,0,0,1,.06-.45.43.43,0,0,1,.45-.3.4.4,0,0,1,.39.35s.06.13,0,.14-.17.08-.19-.08a.21.21,0,0,0-.12-.19.2.2,0,0,0-.28.15,1.62,1.62,0,0,0,0,.79.21.21,0,0,0,.21.19c.12,0,.17-.09.2-.21s0-.14.08-.15.18,0,.14.18a.41.41,0,0,1-.43.38c-.24,0-.37-.12-.44-.38a1.84,1.84,0,0,1,0-.42"
        style="fill: #fff"
      ></path>
      <path
        d="M29.83,6.89a1.22,1.22,0,0,0,0,.33c0,.13.1.23.23.22s.18-.12.19-.24,0-.12.09-.12.17,0,.14.16a.43.43,0,0,1-.42.39.4.4,0,0,1-.46-.36,1.52,1.52,0,0,1,0-.82.46.46,0,0,1,.45-.37.41.41,0,0,1,.42.34s.07.14,0,.15-.17,0-.18-.1a.2.2,0,0,0-.19-.2c-.12,0-.18.08-.21.18a1.35,1.35,0,0,0-.05.44"
        style="fill: #fff"
      ></path>
      <path
        d="M20.51,7.54a1.29,1.29,0,0,1-.19-.7,1.85,1.85,0,0,1,.08-.47.45.45,0,0,1,.48-.28.41.41,0,0,1,.36.37s.05.13,0,.13S21,6.66,21,6.52,21,6.3,20.81,6.3s-.19.11-.22.24a1.68,1.68,0,0,0,0,.67c0,.13.08.25.23.24s.2-.12.2-.25.1-.11.17-.11.06.1.05.15a.44.44,0,0,1-.72.3"
        style="fill: #fff"
      ></path>
      <path
        d="M34.89,8.47a.33.33,0,0,1,.37.33s0,.11-.06.1-.11,0-.12-.06-.1-.21-.23-.19a.19.19,0,0,0-.18.19.24.24,0,0,0,.18.27l.25.1a.39.39,0,0,1,.22.43A.39.39,0,0,1,35,10c-.31.05-.5-.09-.52-.38,0-.06,0-.12.07-.11s.1,0,.11.08.09.25.25.25a.2.2,0,0,0,.22-.19.27.27,0,0,0-.2-.32l-.17-.07a.38.38,0,0,1-.25-.46.35.35,0,0,1,.39-.33"
        style="fill: #fff"
      ></path>
      <path
        d="M31.82,9.43a.92.92,0,0,0,0-.29A.18.18,0,0,0,31.62,9c-.08,0-.13.06-.15.14a1.14,1.14,0,0,0,0,.58.15.15,0,0,0,.16.12.17.17,0,0,0,.15-.14,1.26,1.26,0,0,0,0-.27m0-.49V8.61c0-.08,0-.11.1-.11s.09,0,.09.11V9.87c0,.1-.06.15-.11.11s-.12,0-.18,0a.29.29,0,0,1-.38-.2,1.27,1.27,0,0,1,0-.67c.06-.29.25-.36.49-.18"
        style="fill: #fff"
      ></path>
      <path
        d="M20.37,9.86c0-.29,0-.58,0-.88,0-.08,0-.14.09-.1s.14,0,.21,0a.2.2,0,0,1,.25,0c.07.08.1.07.18,0a.24.24,0,0,1,.4.19c0,.25,0,.51,0,.76,0,.07,0,.1-.09.1s-.07,0-.07-.1V9.2c0-.11,0-.23-.14-.23s-.19.1-.19.23v.61c0,.06,0,.12-.08.12s-.07-.07-.07-.12V9.18c0-.1,0-.21-.14-.22s-.19.08-.2.21,0,.51,0,.76c-.09.06-.18.09-.18-.07"
        style="fill: #fff"
      ></path>
      <path
        d="M37.22,9.42a1.32,1.32,0,0,0,0,.28.15.15,0,0,0,.14.13.14.14,0,0,0,.17-.1.91.91,0,0,0,0-.61A.17.17,0,0,0,37.39,9a.16.16,0,0,0-.15.14.86.86,0,0,0,0,.28m.36-.49V8.6c0-.08,0-.1.1-.1s.08,0,.08.1V9.88c0,.11-.08.14-.12.1s-.12,0-.17,0a.27.27,0,0,1-.37-.17,1,1,0,0,1,0-.76c.09-.24.26-.28.5-.13"
        style="fill: #fff"
      ></path>
      <path
        d="M4.52,6.33c-.13,0-.11-.1-.06-.19s.16,0,.16-.15.1-.36.35-.35c.06,0,.11,0,.11.09s0,.14-.1.12-.14.07-.14.18.07.11.14.11.06.15.09.22h0c-.23-.05-.23-.05-.23.18v.78a.86.86,0,0,0,0,.16c0,.09,0,.12-.11.12s-.11,0-.11-.13a6.26,6.26,0,0,0,0-.75c0-.1,0-.2,0-.3s0-.11-.09-.09"
        style="fill: #fff"
      ></path>
      <path
        d="M15.63,9.43a.68.68,0,0,0-.06-.34.14.14,0,0,0-.16-.1c-.08,0-.12.06-.14.13a1,1,0,0,0,0,.58.15.15,0,0,0,.15.12.18.18,0,0,0,.17-.12.5.5,0,0,0,0-.27m-.32.54a.86.86,0,0,1-.15-1,.27.27,0,0,1,.38-.08s.05.09.11,0,.12,0,.12.08a2.14,2.14,0,0,0,0,.44,3.85,3.85,0,0,1,0,.59.35.35,0,0,1-.49.31.28.28,0,0,1-.14-.1c0-.05-.1-.12,0-.17s.12,0,.17.05.12.09.2.07.12-.11.12-.2a.12.12,0,0,0,0-.13l-.12.1a.27.27,0,0,1-.16,0"
        style="fill: #fff"
      ></path>
      <path
        d="M35.53,6.89V6.46c0-.09,0-.15-.11-.14s-.09,0-.09-.09,0-.11.1-.1.11,0,.11-.13a1,1,0,0,1,0-.17c0-.09,0-.14.11-.14s.12,0,.11.14a.57.57,0,0,1,0,.13c0,.12,0,.19.15.16s.1,0,.1.1,0,.1-.11.09-.14,0-.14.15,0,.5,0,.75,0,.19.14.18.09,0,.09.11,0,.1-.1.11c-.27,0-.36-.06-.36-.34V6.89"
        style="fill: #fff"
      ></path>
      <path
        d="M30.44,9.72c.08-.39.16-.74.23-1.09,0-.07,0-.14.12-.13s.1,0,.08.12l-.3,1.26c0,.09-.06.11-.14.11s-.11,0-.13-.12c-.09-.42-.19-.84-.29-1.26,0,0,0-.09,0-.1s.12,0,.14,0,.06.22.08.33c.06.27.12.54.18.84"
        style="fill: #fff"
      ></path>
      <path
        d="M28.63,9.42c0-.08,0-.19,0-.29A.16.16,0,0,0,28.43,9a.14.14,0,0,0-.14.13,1.31,1.31,0,0,0,0,.59.14.14,0,0,0,.16.12c.08,0,.14,0,.15-.13l0-.29m0-.49V8.6c0-.07,0-.09.09-.1s.09,0,.09.1V9.89c0,.12-.1.12-.13.08s-.1,0-.15,0a.29.29,0,0,1-.39-.2,1.26,1.26,0,0,1,0-.72c.07-.23.25-.28.49-.13"
        style="fill: #fff"
      ></path>
      <path
        d="M37.18,6.89V6.44c0-.08,0-.13-.1-.12s-.08,0-.08-.1,0-.11.08-.1.1,0,.1-.12V5.84c0-.1,0-.15.12-.15s.11.06.11.14V6c0,.12,0,.18.14.15s.11,0,.11.1,0,.1-.11.09-.15,0-.14.15,0,.47,0,.71,0,.24.17.22.07,0,.07.1,0,.1-.06.11c-.25,0-.42,0-.41-.33V6.89"
        style="fill: #fff"
      ></path>
      <path
        d="M18,9.41l-.22.08c-.11,0-.11.15-.1.25a.12.12,0,0,0,.13.11A.18.18,0,0,0,18,9.67a2.09,2.09,0,0,0,0-.26m.18,0v.3s0,.09,0,.11.1.08,0,.14a.12.12,0,0,1-.18,0c-.06-.08-.08-.05-.14,0a.25.25,0,0,1-.31,0c-.13-.07-.14-.21-.13-.35a.27.27,0,0,1,.18-.25l.23-.08A.13.13,0,0,0,18,9.14c0-.08,0-.14-.12-.15a.16.16,0,0,0-.18.09s0,.05,0,.08-.09.05-.13.05,0-.06,0-.1c0-.2.14-.28.37-.27s.28.09.29.3a2.62,2.62,0,0,0,0,.28"
        style="fill: #fff"
      ></path>
      <path
        d="M32.6,9.41l-.21.08c-.11,0-.13.12-.12.23s0,.14.13.13a.21.21,0,0,0,.2-.19,2.08,2.08,0,0,0,0-.25m.18,0v.3s0,.09,0,.1.1.08.05.13a.13.13,0,0,1-.18,0c-.06-.09-.09-.05-.15,0a.26.26,0,0,1-.31,0,.32.32,0,0,1-.13-.33.27.27,0,0,1,.18-.26l.22-.07a.14.14,0,0,0,.11-.17c0-.08,0-.13-.12-.14a.16.16,0,0,0-.18.11s0,.08,0,.09a.12.12,0,0,1-.13,0s0-.07,0-.1c0-.19.16-.28.4-.26s.26.1.27.31v.28"
        style="fill: #fff"
      ></path>
      <path
        d="M26.61,9.41l-.22.08c-.11,0-.12.12-.11.22s0,.15.13.14a.2.2,0,0,0,.2-.17,2.42,2.42,0,0,0,0-.27m.18,0v.3s0,.09,0,.1.09.08.05.13a.12.12,0,0,1-.17,0c-.08-.1-.13,0-.21,0a.26.26,0,0,1-.37-.15.35.35,0,0,1,.16-.46l.23-.08c.08,0,.11-.07.1-.16A.15.15,0,0,0,26.48,9c-.08,0-.15,0-.18.09a.45.45,0,0,1,0,.11.11.11,0,0,1-.13,0c-.05,0,0-.06,0-.1s.13-.26.33-.27.32.08.33.26a2.25,2.25,0,0,1,0,.36"
        style="fill: #fff"
      ></path>
      <path
        d="M35.89,9.41l-.23.08c-.1,0-.11.13-.1.23s.06.14.13.13a.2.2,0,0,0,.19-.16,1.29,1.29,0,0,0,0-.28m.18,0v.31s0,.08,0,.09.1.07.06.13A.12.12,0,0,1,36,10c-.07-.07-.1-.06-.17,0a.27.27,0,0,1-.31,0,.33.33,0,0,1-.11-.34.26.26,0,0,1,.19-.25l.22-.07a.14.14,0,0,0,.11-.15c0-.08,0-.14-.12-.15a.15.15,0,0,0-.18.09l0,.09c0,.07-.08,0-.12,0s-.05,0,0-.08.12-.28.33-.29.33.08.33.27v.31"
        style="fill: #fff"
      ></path>
      <path
        d="M17,10a.31.31,0,0,1-.26-.25,1,1,0,0,1,0-.74.31.31,0,0,1,.38-.17.3.3,0,0,1,.23.27s0,.1-.05.1-.11,0-.13-.05S17.16,9,17,9s-.14.12-.15.24a1.29,1.29,0,0,0,0,.44.18.18,0,0,0,.15.18c.1,0,.15-.07.16-.17s.07-.13.14-.11,0,.1,0,.15-.16.24-.32.31c.14,0,.24.1.19.25a.26.26,0,0,1-.34.1s0,0,0-.06a0,0,0,0,1,.06,0H17s.07,0,.08-.06a.07.07,0,0,0-.06-.08c-.09,0-.09,0,0-.16"
        style="fill: #fff"
      ></path>
      <path
        d="M29.41,9.41l-.23.08c-.1,0-.1.14-.09.24a.13.13,0,0,0,.14.12.18.18,0,0,0,.18-.17,2.42,2.42,0,0,0,0-.27m.18,0v.3s0,.09,0,.11.09.09,0,.14a.12.12,0,0,1-.18,0c0-.07-.08-.05-.13,0A.26.26,0,0,1,29,10c-.12-.08-.12-.2-.12-.33a.27.27,0,0,1,.18-.26l.23-.08a.13.13,0,0,0,.1-.14.14.14,0,0,0-.1-.15.14.14,0,0,0-.18.06.36.36,0,0,0,0,.11c0,.08-.08.05-.13.05s-.05-.06,0-.1.14-.28.36-.27.29.08.3.29a2.44,2.44,0,0,1,0,.28Z"
        style="fill: #fff"
      ></path>
      <path
        d="M38.24,9.31c0-.06.17.06.17-.09s0-.23-.16-.23-.16.12-.17.23.1,0,.16.09m.09.14h-.06c-.21,0-.24,0-.18.26a.17.17,0,0,0,.16.15.15.15,0,0,0,.15-.14c0-.13.09-.14.16-.1s0,.12,0,.17a.32.32,0,0,1-.34.23.33.33,0,0,1-.31-.27,1.3,1.3,0,0,1,0-.62.34.34,0,0,1,.39-.27c.17,0,.26.13.29.33s0,.26-.26.26"
        style="fill: #fff"
      ></path>
      <path
        d="M33.64,9.31c0-.05.18.07.18-.1s0-.22-.16-.22-.17.11-.18.22.11.06.16.1m.1.14h-.08c-.2,0-.22,0-.17.24s.07.16.17.16.14-.06.15-.16,0-.1.09-.1.11,0,.09.11a.34.34,0,0,1-.31.29.31.31,0,0,1-.35-.23,1.12,1.12,0,0,1,0-.7.32.32,0,0,1,.37-.23.3.3,0,0,1,.28.3c.06.31,0,.32-.25.32"
        style="fill: #fff"
      ></path>
      <path
        d="M16.41,9.41l-.21.08c-.11,0-.14.12-.13.23s.05.15.14.14a.19.19,0,0,0,.19-.18,1.22,1.22,0,0,0,0-.27m-.49-.28.08-.2a.41.41,0,0,1,.41-.07.25.25,0,0,1,.18.27c0,.16,0,.32,0,.48s-.05.2.07.26,0,.08,0,.1a.13.13,0,0,1-.17,0c-.06-.08-.1-.05-.16,0A.26.26,0,0,1,16,10a.34.34,0,0,1-.12-.34.27.27,0,0,1,.18-.25l.19-.06c.09,0,.17-.05.15-.18a.16.16,0,0,0-.31,0c0,.06,0,.07-.08.07s-.11,0-.1-.08"
        style="fill: #fff"
      ></path>
      <path
        d="M9.28,9.43a.53.53,0,0,0,0-.35C9.15,9,9,9,8.94,9.1a.8.8,0,0,0,0,.57c0,.1.06.17.17.16s.14-.09.16-.19,0-.14,0-.21m-.52.33a1.82,1.82,0,0,1,0-.57c.07-.34.25-.42.54-.23V8.63c0-.06,0-.11.07-.11s.08,0,.08.1,0,.41,0,.61,0,.42,0,.63-.06.15-.14.11-.08,0-.14,0-.3,0-.41-.22"
        style="fill: #fff"
      ></path>
      <path
        d="M9.93,9.32c0-.08.17.07.17-.11s0-.21-.16-.22-.19.1-.18.24.11,0,.17.09M9.6,9.13a.45.45,0,0,1,.28-.29c.3,0,.46.21.42.54,0,.07-.05.07-.1.07s-.24,0-.36,0-.11,0-.1.11l0,.15a.16.16,0,0,0,.17.14.15.15,0,0,0,.15-.14c0-.11.06-.14.14-.11s0,.11,0,.16a.33.33,0,0,1-.64,0,1.63,1.63,0,0,1,0-.54h0s0,0,0-.06"
        style="fill: #fff"
      ></path>
      <path
        d="M14.31,6.32c-.22,0-.22,0-.22.21v.69c0,.12,0,.2.16.19s.08,0,.08.08,0,.09-.07.1c-.23,0-.36,0-.36-.3V6.45c0-.1,0-.17-.12-.15s-.09,0-.09-.09,0-.08.09-.07.13,0,.12-.15V5.81c0-.09,0-.1.11-.1s.1,0,.1.09V6c0,.14,0,.18.16.14s.07.12,0,.2"
        style="fill: #fff"
      ></path>
      <path
        d="M18.84,9.42a.83.83,0,0,0,0-.31A.17.17,0,0,0,18.64,9c-.09,0-.13.06-.15.14a1.18,1.18,0,0,0,0,.59.15.15,0,0,0,.3,0,.65.65,0,0,0,.05-.31m.18,0a1.09,1.09,0,0,1,0,.31.34.34,0,0,1-.33.27.32.32,0,0,1-.34-.25,1.2,1.2,0,0,1,0-.65.32.32,0,0,1,.35-.26.33.33,0,0,1,.33.29,1.37,1.37,0,0,1,0,.29"
        style="fill: #fff"
      ></path>
      <path
        d="M22.72,8.52a.43.43,0,0,1,.17.32s0,.1-.05.09-.11,0-.12-.06,0,0,0-.06a.21.21,0,0,0-.18-.18.2.2,0,0,0-.23.13,1.57,1.57,0,0,0,0,1,.19.19,0,0,0,.23.13c.11,0,.16-.09.19-.19s0-.09,0-.13.06-.06.1-.06.06,0,.06.08a.44.44,0,0,1-.35.44.39.39,0,0,1-.44-.33,2,2,0,0,1,0-.84.54.54,0,0,1,.17-.29.46.46,0,0,1,.44,0"
        style="fill: #fff"
      ></path>
      <path
        d="M13.1,9a.21.21,0,0,0-.19.25c0,.11.13,0,.19,0s0,0,.06,0,.09,0,.1,0A.22.22,0,0,0,13.1,9m.17.61c.17,0,.18,0,.11.19l0,.09a.34.34,0,0,1-.41.09.39.39,0,0,1-.2-.36,1.4,1.4,0,0,1,0-.41c0-.19.11-.33.31-.36s.34.11.38.36,0,.22-.16.25a2.08,2.08,0,0,1-.25,0c-.1,0-.11,0-.1.12s0,.26.17.28.16-.12.19-.23,0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M29.21,6.31c.09-.12.17-.21.29-.22s.11,0,.11.12,0,.14-.09.14a.29.29,0,0,0-.3.33c0,.27,0,.54,0,.81,0,.1,0,.12-.12.12s-.12,0-.12-.12c0-.4,0-.79,0-1.19,0-.06,0-.16.08-.16s.19,0,.15.17"
        style="fill: #fff"
      ></path>
      <path
        d="M11.18,9.42c0-.15,0-.3,0-.45s0-.14.11-.11a.18.18,0,0,0,.19,0,.26.26,0,0,1,.37.27v.74c0,.07,0,.11-.09.11s-.09-.05-.09-.12V9.19c0-.1,0-.2-.14-.2a.18.18,0,0,0-.2.2v.66c0,.07,0,.12-.09.12s-.09-.05-.09-.12a2,2,0,0,0,0-.43"
        style="fill: #fff"
      ></path>
      <path
        d="M27.26,8.84a.27.27,0,0,1,.3.25c0,.05,0,.12,0,.12s-.11,0-.12-.08A.13.13,0,0,0,27.21,9a.14.14,0,0,0-.12.13.13.13,0,0,0,.08.14,1.76,1.76,0,0,0,.2.09c.22.05.25.26.2.46a.32.32,0,0,1-.37.19.31.31,0,0,1-.29-.27c0-.05,0-.12.05-.13s.11,0,.13.09.13.21.25.14a.17.17,0,0,0,0-.29.42.42,0,0,0-.18-.08c-.2-.08-.27-.18-.23-.38s.12-.26.31-.25"
        style="fill: #fff"
      ></path>
      <path
        d="M3.66,8.88c.29-.08.4,0,.41.32a.43.43,0,0,0,0,.11v.56c0,.08,0,.1-.1.11s-.08,0-.08-.11V9.21c0-.11,0-.21-.14-.21a.18.18,0,0,0-.19.21v.65c0,.08,0,.12-.1.12s-.08-.06-.08-.12V9c0-.15,0-.18.16-.11s.07,0,.1,0"
        style="fill: #fff"
      ></path>
      <path
        d="M36.91,9.42v.46c0,.12-.12.11-.13.08s-.09,0-.13,0a.26.26,0,0,1-.42-.23c0-.26,0-.52,0-.78,0-.07,0-.1.09-.1s.09,0,.09.11V9.6c0,.1,0,.21.13.22s.2-.08.21-.21,0-.42,0-.63,0-.14.08-.13.08.08.08.14v.43"
        style="fill: #fff"
      ></path>
      <path
        d="M19.87,9.32c.06-.05.19.07.2-.1S20,9,19.89,9a.23.23,0,0,0-.19.25c0,.16.11.07.17.1m.18.37c0-.07.07-.11.13-.08s0,.11,0,.17a.34.34,0,0,1-.65-.11,1.94,1.94,0,0,1,0-.34,2.33,2.33,0,0,1,.07-.25.3.3,0,0,1,.33-.23c.16,0,.25.1.29.28s.05.3-.23.3h-.21q-.09,0-.06.09c0,.05,0,.1,0,.14s.06.18.16.18.14-.05.16-.15"
        style="fill: #fff"
      ></path>
      <path
        d="M32.32,6.62v.86c0,.09,0,.13-.11.12s-.13,0-.13-.13V5.75c0-.1,0-.11.12-.11s.12,0,.12.12v.86"
        style="fill: #fff"
      ></path>
      <path
        d="M4.3,9.39a.32.32,0,0,1,.35-.53.23.23,0,0,1,.18.22s0,.1,0,.1-.1,0-.11-.06S4.65,9,4.59,9a.15.15,0,0,0-.2.07.15.15,0,0,0,.06.22l.12.05c.28.09.32.15.29.46a.33.33,0,0,1-.41.2.3.3,0,0,1-.26-.27s0-.12,0-.13.13,0,.13.08a.16.16,0,0,0,.19.17.16.16,0,0,0,.15-.19.14.14,0,0,0-.11-.15Z"
        style="fill: #fff"
      ></path>
      <path
        d="M25,9.39l0-.16c0-.31.17-.41.5-.37a.31.31,0,0,1,.17.24s0,.11,0,.12-.12,0-.13-.06S25.44,9,25.33,9s-.14.11-.15.2a1.34,1.34,0,0,0,0,.49c0,.1.07.17.17.16s.14-.07.14-.17.05-.12.13-.11.06.1.05.15a.35.35,0,0,1-.33.28A.32.32,0,0,1,25,9.72,1.88,1.88,0,0,1,25,9.39"
        style="fill: #fff"
      ></path>
      <path
        d="M12.31,9.72c.06-.27.12-.51.16-.74s.09-.13.16-.11,0,.1,0,.15c-.07.29-.15.57-.21.86a.13.13,0,0,1-.14.12c-.09,0-.1-.06-.12-.12C12.11,9.6,12,9.31,12,9c0,0-.07-.12,0-.15s.14,0,.16.11.11.46.17.74"
        style="fill: #fff"
      ></path>
      <path
        d="M23.7,9.32c.06-.05.19.07.19-.11S23.81,9,23.71,9s-.18.12-.18.24.11.08.17.11m-.09.68a.46.46,0,0,1-.26-.45,1.06,1.06,0,0,1,.06-.5.31.31,0,0,1,.33-.2A.28.28,0,0,1,24,9.1c.07.31.05.33-.23.33h-.08c-.21,0-.26.08-.18.29a.18.18,0,0,0,.17.14.16.16,0,0,0,.16-.15c0-.1.06-.14.13-.1s0,.11,0,.16a.71.71,0,0,1-.08.15.39.39,0,0,1-.3.08"
        style="fill: #fff"
      ></path>
      <path
        d="M13.67,10a.37.37,0,0,1-.15-.26c0-.05,0-.1.05-.11a.08.08,0,0,1,.1.07c0,.1.06.18.17.18a.18.18,0,0,0,.09-.34l-.21-.09a.26.26,0,0,1-.18-.32.25.25,0,0,1,.24-.25.28.28,0,0,1,.37.2s0,.1,0,.12-.11,0-.12-.08A.14.14,0,0,0,13.8,9c-.1,0-.12.1-.11.19s.06.1.11.13l.09,0c.34.11.4.34.17.62a.42.42,0,0,1-.39,0"
        style="fill: #fff"
      ></path>
      <path
        d="M24.17,9.86a5.79,5.79,0,0,0,0-.83c0-.12,0-.22.14-.08s.06,0,.08,0a.31.31,0,0,1,.32,0,.28.28,0,0,1,.12.28c0,.09,0,.17,0,.26s0,.29,0,.44,0,.11-.09.11-.07-.05-.07-.11V9.59c0-.12,0-.25,0-.38s0-.21-.14-.23-.2.08-.21.23,0,.36,0,.54v.1c0,.06,0,.12-.08.12s-.12,0-.12-.11"
        style="fill: #fff"
      ></path>
      <path
        d="M18.24,6.86c0,.21,0,.42,0,.63s0,.12-.12.12-.12,0-.12-.12c0-.41,0-.83,0-1.24,0-.1,0-.12.12-.11s.12,0,.12.11,0,.4,0,.61"
        style="fill: #fff"
      ></path>
      <path
        d="M35.29,6.87v.61c0,.1,0,.12-.11.12s-.12,0-.12-.11q0-.63,0-1.26c0-.12.07-.1.13-.1s.11,0,.11.11,0,.42,0,.63"
        style="fill: #fff"
      ></path>
      <path
        d="M5,9.83c0-.24,0-.49,0-.73C5,9,5,9,5,9s-.08,0-.08-.06,0-.06.08-.06.06-.11.08-.17,0-.16.07-.15.07.09.07.15,0,.2.13.18,0,0,0,.07a0,0,0,0,1-.06,0c-.11,0-.11.05-.11.14v.53c0,.08,0,.16.11.16s.05.08.06.13c-.23,0-.28,0-.34-.14"
        style="fill: #fff"
      ></path>
      <path
        d="M11,9.24v.61c0,.07,0,.13-.09.13s-.1-.05-.1-.12V8.62c0-.07,0-.12.09-.12s.09.06.09.13,0,.4,0,.61"
        style="fill: #fff"
      ></path>
      <path
        d="M3.24,9.24v.63c0,.07,0,.11-.09.11s-.1,0-.1-.11V8.6c0-.08,0-.1.1-.1s.09,0,.09.11v.63"
        style="fill: #fff"
      ></path>
      <path
        d="M14.45,10a.32.32,0,0,1-.09-.25v-.6c0-.07,0-.14-.09-.13s-.06,0-.06-.06,0-.06,0-.06.1-.08.11-.16,0-.16.07-.16.07.1.07.15,0,.19.13.17,0,0,0,.06a0,0,0,0,1-.06.05c-.13,0-.12.07-.12.16v.51c0,.07,0,.15.09.15s.1.08.08.15Z"
        style="fill: #fff"
      ></path>
      <path
        d="M31.13,9.43v.45c0,.08,0,.11-.1.11s-.09,0-.09-.1V9c0-.07,0-.1.09-.1s.1,0,.09.11,0,.29,0,.45"
        style="fill: #fff"
      ></path>
      <path
        d="M26,9.41v.45c0,.06,0,.12-.08.12s-.09-.05-.08-.12V9c0-.07,0-.11.09-.11S26,8.93,26,9s0,.29,0,.43"
        style="fill: #fff"
      ></path>
      <path
        d="M14.79,10c0-.33,0-.67,0-1,0-.07,0-.08.08-.09s.08,0,.08.09c0,.34,0,.67,0,1h-.14"
        style="fill: #fff"
      ></path>
      <path
        d="M17.77,8.46l.1,0c.05,0,.11.07.15,0s.06,0,.1,0,0,.07,0,.1a.17.17,0,0,1-.22.12c-.08,0-.16-.1-.24,0s-.07,0-.08,0a.11.11,0,0,1,0-.08.17.17,0,0,1,.18-.14"
        style="fill: #fff"
      ></path>
      <path
        d="M18.23,5.79c0,.11,0,.14-.12.14s-.12,0-.11-.14,0-.15.12-.15.13.05.11.15"
        style="fill: #fff"
      ></path>
      <path
        d="M35.29,5.78c0,.11,0,.15-.12.15s-.12,0-.12-.14,0-.16.12-.15.15,0,.12.14"
        style="fill: #fff"
      ></path>
      <path
        d="M4.37,5.84c0,.12-.13.08-.19.06s0-.12,0-.19.08,0,.13-.06h.07Z"
        style="fill: #fff"
      ></path>
      <path
        d="M36.8,8.44c-.11.12-.13.3-.32.29.09-.29.1-.3.32-.29"
        style="fill: #fff"
      ></path>
      <path
        d="M31,8.5c.09,0,.09,0,.1.11s0,.11-.09.11S31,8.67,31,8.6s0-.12.09-.1"
        style="fill: #fff"
      ></path>
      <path
        d="M26,8.6c0,.07,0,.12-.08.12s-.08-.06-.08-.12,0-.11.07-.11.1,0,.09.11"
        style="fill: #fff"
      ></path>
      <path
        d="M4.3,9.39l.3.11c.06,0,.12.06.11.15a.59.59,0,0,1-.41-.26"
        style="fill: #fff"
      ></path>
      <path
        d="M15.49,10l.12-.1a.1.1,0,0,1,0,.13s-.09,0-.12,0"
        style="fill: #fff"
      ></path>
      <path
        d="M25.37,6.71h.09c.17,0,.19,0,.15-.2,0,0,0,0,0-.08a.21.21,0,0,0-.26-.15.35.35,0,0,0-.2.35c0,.15.14,0,.21.07s0,0,0,0m.12.18h-.14c-.08,0-.21-.08-.23.1s.07.43.21.46.24,0,.27-.22.11-.12.18-.1,0,.11,0,.16a.44.44,0,0,1-.43.35A.43.43,0,0,1,25,7.25a1.82,1.82,0,0,1,0-.77.42.42,0,0,1,.45-.37c.24,0,.37.13.42.4s.06.38-.34.38"
        style="fill: #fff"
      ></path>
      <path
        d="M23.2,9.41v.45c0,.06,0,.1-.08.1s-.07-.05-.07-.1V9c0-.06,0-.11.08-.1s.07,0,.07.1v.43"
        style="fill: #fff"
      ></path>
      <path
        d="M23.45,8.7c.09-.09.1-.26.24-.27s.16.17.25.26c-.11,0-.12,0-.19-.08s-.08-.07-.11,0a.13.13,0,0,1-.19.09"
        style="fill: #fff"
      ></path>
      <path
        d="M23.2,8.61c0,.06,0,.09-.07.09s-.08,0-.08-.09,0-.1.08-.1.07.05.07.1"
        style="fill: #fff"
      ></path>
      <path
        d="M3.1,6.62V5.81c0-.08,0-.15.1-.15s.11.08.11.16V7.24c0,.12,0,.15.14.15h.49c.06,0,.11,0,.11.09s0,.11-.11.11H3.23c-.1,0-.13,0-.13-.14,0-.28,0-.56,0-.83"
        style="fill: #fff"
      ></path>
      <path
        d="M7.65,9.42a.7.7,0,0,0,0,.32c.07.15.24.16.3,0a.87.87,0,0,0,0-.67A.17.17,0,0,0,7.85,9c-.07,0-.11,0-.14.11a.82.82,0,0,0-.06.34m.58,0a1.36,1.36,0,0,1-.05.36.32.32,0,0,1-.33.23.31.31,0,0,1-.31-.24,1,1,0,0,1,0-.65.32.32,0,0,1,.31-.25.31.31,0,0,1,.33.24,1.12,1.12,0,0,1,.05.31"
        style="fill: #fff"
      ></path>
      <path
        d="M6.91,9.43v.43c0,.09-.06.13-.1.09s-.14,0-.2,0a.24.24,0,0,1-.36-.25c0-.24,0-.49,0-.73,0-.06,0-.11.08-.11s.08.05.08.11v.65c0,.11,0,.21.14.21a.19.19,0,0,0,.21-.21c0-.22,0-.43,0-.65,0-.06,0-.11.07-.11s.08.05.08.11v.45"
        style="fill: #fff"
      ></path>
      <path
        d="M4.14,6.86V6.25c0-.08,0-.12.1-.11s.11,0,.11.11V7.47c0,.09,0,.11-.11.11s-.11,0-.11-.11,0-.4,0-.61"
        style="fill: #fff"
      ></path>
      <path
        d="M5.84,9.45V9.14c0-.07,0-.14-.09-.13s0,0,0,0,0-.07,0-.06.11-.11.11-.19,0-.14.07-.14.08.08.08.14,0,.21.12.19,0,0,0,.07a0,0,0,0,1,0,0C6,9,6,9.12,6,9.21v.5c0,.08,0,.16.11.16s.06,0,.06.08,0,.05-.08.06-.24,0-.24-.22V9.45"
        style="fill: #fff"
      ></path>
      <path
        d="M7.14,9.44V9.19c0-.08,0-.2-.11-.19s0,0,0-.06,0-.06,0,0,.1-.08.11-.16,0-.16.07-.16.07.11.07.17,0,.17.12.15.06,0,.06,0,0,.07-.07.06-.12.05-.12.14,0,.34,0,.51,0,.18.12.18.06,0,.06.08,0,.05-.06.06-.26,0-.26-.23,0-.21,0-.3"
        style="fill: #fff"
      ></path>
      <path
        d="M5.61,9.44v.43c0,.05,0,.09-.07.09s-.08,0-.08-.09V9c0-.06,0-.09.08-.09s.07,0,.07.09,0,.3,0,.46"
        style="fill: #fff"
      ></path>
      <path
        d="M5.53,8.52c.06,0,.08,0,.08.09s0,.1-.07.1-.08,0-.08-.09,0-.11.07-.1"
        style="fill: #fff"
      ></path>
      <path
        d="M13.64,6.62v.83c0,.08,0,.13-.11.13s-.1-.06-.1-.14V5.77c0-.07,0-.12.09-.12s.11,0,.11.13c0,.28,0,.56,0,.84"
        style="fill: #fff"
      ></path>
      <path
        d="M14.93,8.62c0,.06,0,.08-.08.08s-.08,0-.08-.1,0-.08.09-.08.07.05.07.1"
        style="fill: #fff"
      ></path>
      <path
        d="M23.2,8.61c0-.06,0-.09-.07-.1s-.08,0-.08.1,0,.09.08.09.08,0,.07-.09m.25.09a.14.14,0,0,0,.2-.08c0-.07.07-.06.11,0s.07.1.19.08c-.09-.09-.09-.27-.25-.26s-.16.17-.25.26m-.25.71V9c0-.06,0-.09-.07-.1s-.08,0-.08.1v.88c0,.05,0,.1.07.1s.09,0,.08-.1V9.41m2.29-2.52c.4,0,.4,0,.33-.39s-.18-.39-.42-.4a.43.43,0,0,0-.45.37,1.82,1.82,0,0,0,0,.77.43.43,0,0,0,.85,0s.08-.14,0-.16-.15,0-.18.1-.13.25-.27.22-.23-.22-.21-.46.15-.07.23-.1h.15M20,5.15l.12,0h5.09a1.48,1.48,0,0,1,.5.58,2,2,0,0,1,.25.64.54.54,0,0,0,.12.46C26,6.9,26,7,26,7.09s-.12,0-.11.15a1,1,0,0,0,.08.24,5.25,5.25,0,0,1-.13.57,3.87,3.87,0,0,1-.31.65.19.19,0,0,0-.06.15c-.33,0-.46.06-.5.37l0,.16-.11,0c0-.09,0-.17,0-.26a.28.28,0,0,0-.12-.28.27.27,0,0,0-.32,0s0,.08-.08,0-.14,0-.14.08a5.72,5.72,0,0,1,0,.83c-.09,0-.16.08-.25.07A.48.48,0,0,0,24,9.75c0-.05.07-.12,0-.16s-.12,0-.13.1a.16.16,0,0,1-.16.15.18.18,0,0,1-.17-.14c-.08-.21,0-.29.18-.29h.08c.28,0,.3,0,.23-.33a.28.28,0,0,0-.28-.25.32.32,0,0,0-.33.19,1.21,1.21,0,0,0-.06.5.45.45,0,0,0,.26.45c0,.08-.09.07-.14.08a5.92,5.92,0,0,1-1.26.13A5.37,5.37,0,0,1,20.67,10a.34.34,0,0,0-.14,0c0-.25,0-.51,0-.76a.19.19,0,0,1,.2-.21c.12,0,.14.11.14.22v.63s0,.12.07.12.08-.07.08-.12V9.2c0-.13.06-.23.19-.23s.14.12.14.23v.65c0,.05,0,.09.07.1s.09,0,.09-.1c0-.25,0-.51,0-.76a.24.24,0,0,0-.4-.19C21,9,21,9,20.91,8.89a.21.21,0,0,0-.25,0c-.07,0-.12.08-.21,0s-.09,0-.09.1c0,.29,0,.58,0,.88l-.18-.08c0-.06.06-.13,0-.17s-.11,0-.13.08-.21-.14-.34-.17,0-.09.06-.09H20c.28,0,.28,0,.23-.3s-.12-.27-.29-.28a.3.3,0,0,0-.33.23c0,.08,0,.17-.07.25a.12.12,0,0,1-.1,0,3.07,3.07,0,0,1-1-1.83.43.43,0,0,0,0,0,.44.44,0,0,0,.81-.16s.05-.11,0-.13a.19.19,0,0,0-.15,0c-.06,0,0,.08,0,.13s-.09.2-.21.2a.23.23,0,0,1-.23-.18,1.26,1.26,0,0,1,0-.28c0-.08,0-.11.1-.11h.48c.12,0,.16,0,.15-.15h.08a5.93,5.93,0,0,1,0,.73c0,.08,0,.12.1.12s.11,0,.11-.12a5.77,5.77,0,0,1,0-.72H20c0,.25,0,.49,0,.74,0,.09,0,.11.11.11s.11,0,.11-.11,0-.43,0-.64h.05a1.33,1.33,0,0,0,.18.7c-.07.07,0,.12,0,.17a1.66,1.66,0,0,0,1.18.76l.56.07a.7.7,0,0,0-.17.29,2,2,0,0,0,0,.84.39.39,0,0,0,.44.33.43.43,0,0,0,.35-.44c0-.05,0-.09-.06-.08s-.1,0-.11.06a.59.59,0,0,1,0,.13.2.2,0,0,1-.19.19.2.2,0,0,1-.23-.13,1.57,1.57,0,0,1,0-1,.19.19,0,0,1,.23-.13.19.19,0,0,1,.18.18.13.13,0,0,1,0,.06c0,.09.07.06.12.06s.05,0,.05-.09a.46.46,0,0,0-.17-.32,4.37,4.37,0,0,0,.7-.22,1.21,1.21,0,0,0,.54-.51.28.28,0,0,0,0-.2h0A.68.68,0,0,0,24,7c0-.28,0-.28.21-.28h.08c.19,0,.26.07.27.28s0,.23,0,.35,0,.27.28.21a1,1,0,0,1-.06-.45c0-.19,0-.39-.23-.47A.59.59,0,0,0,24.77,6a.41.41,0,0,0-.47-.32h-.42c-.11,0-.14,0-.14.15a7.3,7.3,0,0,1,0,.81,1.62,1.62,0,0,0-.59-.32.51.51,0,0,0-.5-.18A1.13,1.13,0,0,0,22.18,6c-.52-.15-1-.26-1.54-.45A5.17,5.17,0,0,1,20,5.28c0-.07,0-.08,0-.13"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M5.53,8.52c-.07,0-.07,0-.07.09s0,.09.08.09.07,0,.07-.09,0-.1-.08-.09m.08.92V9c0-.06,0-.1-.07-.09s-.08,0-.08.1v.89c0,.06,0,.09.08.09s.07,0,.07-.09V9.44m1.53,0v.3c0,.2.09.27.26.23s.06,0,.06-.06,0-.08-.06-.08-.12-.09-.12-.18V9.14c0-.09,0-.15.12-.14s.07,0,.07-.07a0,0,0,0,0-.06,0c-.12,0-.11-.06-.12-.15s.06-.17-.07-.17-.06.1-.07.16,0,.18-.11.16,0,0,0,0S7,9,7,9s.11.1.11.19a2.26,2.26,0,0,0,0,.26m-1.3,0v.3c0,.19.07.24.24.22s.08,0,.08-.06,0-.08-.06-.08S6,9.75,6,9.67v-.5C6,9.08,6,9,6.11,9s0,0,0-.05,0-.07,0-.07S6,8.77,6,8.68s0-.14-.08-.14-.07.08-.07.14,0,.2-.12.19,0,0,0,.07,0,.05,0,0,.09.06.09.13,0,.23,0,.34M4.14,6.86v.61c0,.09,0,.11.11.11s.11,0,.11-.11V6.25c0-.09,0-.11-.11-.11s-.1,0-.1.11,0,.41,0,.61M6.91,9.43V9c0-.06,0-.11-.08-.11s-.07.06-.07.11v.65a.19.19,0,0,1-.21.21c-.12,0-.14-.1-.15-.21V9c0-.06,0-.11-.08-.11s-.08.05-.08.11v.73a.25.25,0,0,0,.37.25c.06,0,.11-.11.2,0s.1,0,.1-.09V9.43m1.32,0a1.13,1.13,0,0,0-.05-.32.32.32,0,0,0-.33-.24.33.33,0,0,0-.31.25,1,1,0,0,0,0,.65.33.33,0,0,0,.64,0,1.36,1.36,0,0,0,.05-.36M3.1,6.62v.83c0,.11,0,.14.13.14h.71c.07,0,.11,0,.11-.11s0-.1-.11-.09H3.45c-.11,0-.14,0-.14-.15,0-.47,0-1,0-1.42,0-.08,0-.16-.11-.16s-.1.07-.1.15v.81M2.35,5.14h2l0,.4s0,.09,0,.11H4.26s-.13,0-.13.06,0,.16,0,.19.15,0,.19-.06c.1.07.06.19.09.29s-.07.17.06.19a1,1,0,0,0,.08.38,6.26,6.26,0,0,1,0,.75c0,.08,0,.13.1.13s.12,0,.11-.12,0-.11,0-.16.08.07.12.12a2.13,2.13,0,0,0,1.57,1A2.13,2.13,0,0,0,7.69,8.2a1.31,1.31,0,0,0,.64-.59c.1,0,.09-.1.1-.17s.06-.1.13-.1c.21.35.38.39.69.13,0,.13.06.12.14.11s.06-.08.06-.14c0-.41,0-.83,0-1.24h.7c0,.41,0,.82,0,1.24,0,.09,0,.14.11.14s.1-.07.1-.15V6.77c0-.09,0-.14.11-.13s.17,0,.26,0a4.53,4.53,0,0,1-.83,2,.54.54,0,0,0-.07.13.47.47,0,0,0-.28.29s0,0,0,.07h0c-.05,0-.08,0-.13,0,0-.2,0-.41,0-.61s0-.1-.08-.1-.07.05-.07.11V9c-.29-.19-.47-.11-.54.23a1.82,1.82,0,0,0,0,.57A7.15,7.15,0,0,1,8,10a4.54,4.54,0,0,1-.82.14,4.65,4.65,0,0,1-1.44-.11L5.33,10s.07-.12,0-.12-.11-.08-.11-.16V9.14c0-.09,0-.16.11-.14S5.36,9,5.36,9s0-.07-.05-.07-.12-.08-.13-.18,0-.14-.07-.15-.06.1-.07.16,0,.17-.08.17-.07,0-.07.06S4.93,9,5,9s.07,0,.07.1c0,.24,0,.49,0,.73l-.17,0c0-.31,0-.37-.29-.46l-.11,0A.16.16,0,0,1,4.6,9c.06,0,.08.08.09.14s.06.06.11.06,0-.06,0-.1a.23.23,0,0,0-.18-.22.32.32,0,0,0-.35.53c-.09,0-.13-.08-.21-.08a.43.43,0,0,1,0-.11c0-.32-.12-.4-.41-.32A5.56,5.56,0,0,1,2.35,5.14"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M14.93,8.62s0-.1-.06-.1-.1,0-.09.09,0,.1.08.1.08,0,.07-.09m-1.29-2V5.78c0-.09,0-.13-.11-.13s-.09,0-.09.12V7.44c0,.07,0,.14.1.14s.11,0,.11-.13c0-.27,0-.55,0-.83m2.28,2.51c-.07.09,0,.23-.13.3a2.17,2.17,0,0,1,0-.44c0-.11-.08-.14-.12-.08s-.07,0-.11,0a.26.26,0,0,0-.38.08.86.86,0,0,0,.15,1h-.4c0-.34,0-.67,0-1,0-.06,0-.09-.08-.09s-.08,0-.08.09c0,.33,0,.67,0,1h-.12c0-.08,0-.15-.08-.15s-.08-.08-.08-.15V9.19c0-.09,0-.18.12-.16s.06,0,.06,0,0-.07,0-.06-.13-.06-.13-.17.05-.16-.07-.16-.06.1-.07.16,0,.17-.11.16,0,0,0,.06a.05.05,0,0,0,.06.06c.09,0,.09.06.09.13v.6a.32.32,0,0,0,.09.25,1,1,0,0,1-.39,0c.23-.28.17-.51-.17-.62l-.09,0c-.05,0-.1-.06-.11-.13A.16.16,0,0,1,13.81,9c.1,0,.18,0,.2.12s.07.09.12.08,0-.08,0-.12a.28.28,0,0,0-.37-.2.27.27,0,0,0-.24.25.28.28,0,0,0,.18.32,2,2,0,0,1,.22.09.17.17,0,0,1,.09.22.17.17,0,0,1-.18.12c-.11,0-.15-.08-.17-.18s0-.08-.1-.07-.05.06-.05.11.08.18.15.26c-.12,0-.25.07-.33-.09l0-.09c.07-.17.06-.18-.11-.19,0-.05,0-.1,0-.15.19,0,.19,0,.16-.25s-.1-.32-.38-.36c-.12-.4-.26-.78-.35-1.19a.48.48,0,0,0,.37-.2.2.2,0,0,0,.26.16c.08,0,.08-.11,0-.13s-.09-.16-.09-.25V6.63c0-.37-.13-.5-.48-.46s-.35.12-.37.34c0,0,0,.1,0,.12a.19.19,0,0,0,.15,0c.05,0,0-.08,0-.12a.22.22,0,0,1,.27-.17.19.19,0,0,1,.18.19.21.21,0,0,1-.17.25,1.61,1.61,0,0,0-.43.17c-.08-.08,0-.23-.15-.29l-.06-.22s0-.09,0-.11h0c0-.09,0-.17,0-.25-.08-.3-.17-.6-.26-.89h2a4,4,0,0,1,.22.69c0,.1.06.2.08.3s-.17,0-.16-.14a1.08,1.08,0,0,0,0-.18c0-.08,0-.09-.1-.09s-.11,0-.11.09v.18c0,.1,0,.17-.12.15s-.09,0-.09.07,0,.11.09.09.12,0,.12.15c0,.28,0,.56,0,.84s.14.35.37.3c.06,0,.07,0,.07-.1s0-.08-.08-.08-.16-.07-.16-.19V6.6c0-.23,0-.23.22-.21a.28.28,0,0,0,.06.16.37.37,0,0,1,0,.18v.79c0,.08,0,.15.11.14s.09-.07.1-.14a3.75,3.75,0,0,1,0-.67,1.06,1.06,0,0,0,.12-.43c.21-.1.33,0,.33.23s0,.6,0,.89c0,.07,0,.12.1.12s.11,0,.11-.13V6.64c0-.37-.09-.47-.44-.46.1-.32.2-.65.29-1h2a4.68,4.68,0,0,1-.25.83l0-.07a.52.52,0,0,0-1,.1.5.5,0,0,0,.31.63c.14.07.31.07.42.21l-.15.56a.05.05,0,0,1,0,0c-.22,0-.33-.09-.36-.36,0-.06,0-.11-.08-.1s-.12,0-.14,0a.56.56,0,0,0,.29.55l.24.06c-.06.32-.18.62-.27.94L16,9s-.05.06-.07.13"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M16.67,6.58a1.56,1.56,0,0,1-.41-.15.34.34,0,0,1-.18-.4.28.28,0,0,1,.3-.23c.16,0,.24.07.27.27s.12,0,.16.09,0,.31-.14.42"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M24.35,9.76c0-.18,0-.36,0-.54s.09-.24.21-.23.15.12.14.23,0,.25,0,.38-.2.13-.33.16"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M10.81,6.44H10.6c-.21,0-.21,0-.17-.24h.17c.21,0,.21,0,.21.23"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M24,6.18v0c0-.34,0-.34.31-.32s.32.17.28.42a.27.27,0,0,1-.24.26h-.23c-.11,0-.14,0-.13-.14a1.41,1.41,0,0,0,0-.21"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M9.28,6.91a1.63,1.63,0,0,1,0,.35.22.22,0,0,1-.44,0,1.28,1.28,0,0,1,0-.7c0-.06,0-.14.06-.2a.23.23,0,0,1,.36.09.9.9,0,0,1,.07.47"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M13.07,6.82c0,.13,0,.25,0,.37a.28.28,0,0,1-.26.26.18.18,0,0,1-.2-.14A.29.29,0,0,1,12.74,7l0,0,.28-.1"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M15.63,9.43a.61.61,0,0,1,0,.27.17.17,0,0,1-.17.12c-.08,0-.12-.06-.15-.12a1,1,0,0,1,0-.58A.17.17,0,0,1,15.41,9a.17.17,0,0,1,.16.1.66.66,0,0,1,.06.34"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M8.93,9.67a.75.75,0,0,1,0-.57c.05-.15.21-.15.29,0a.47.47,0,0,1,0,.35.74.74,0,0,0-.35.23"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M13.16,9.29,13.1,9a.22.22,0,0,1,.16.26c0,.08,0,.07-.1,0"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M19.87,9.32c-.06,0-.17.06-.17-.1s.09-.25.19-.25.18.12.18.25-.14.06-.2.1"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M23.7,9.32c-.06,0-.19.06-.18-.1S23.57,9,23.7,9s.18.1.18.24-.12.06-.18.1"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M25.37,6.71h0c-.07,0-.19.07-.21-.07a.32.32,0,0,1,.2-.35.21.21,0,0,1,.26.15.24.24,0,0,1,0,.08c0,.18,0,.2-.15.2h-.09"
        style="fill: #d3d3d3"
      ></path>
      <path
        d="M7.65,9.42a.78.78,0,0,1,0-.34.16.16,0,0,1,.3,0,.86.86,0,0,1,0,.67c-.07.15-.23.14-.3,0a.85.85,0,0,1,0-.32"
        style="fill: #d3d3d3"
      ></path>
    </svg>
    &nbsp;
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="company-logo"
      viewBox="0 0 169.001 112.995"
    >
      <g
        id="Group_23"
        data-name="Group 23"
        transform="translate(-901.6 -447.396)"
      >
        <g id="Group_460" data-name="Group 460">
          <g id="Group_459" data-name="Group 459">
            <path
              id="Path_269"
              data-name="Path 269"
              d="M910.417,530.066h-2.509v7.851c0,2.092-.627,2.735-1.9,2.735s-1.9-.644-1.9-2.735v-7.851H901.6v8.654c0,2.573,1.77,4.054,4.407,4.054s4.407-1.481,4.407-4.054Z"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_461" data-name="Group 461">
          <path
            id="Path_271"
            data-name="Path 271"
            d="M901.795,547.612v12.515h7.159V559h-5.837v-4.875h3.9V553h-3.908v-4.264h5.471v-1.126Z"
            fill="#fff"
          />
        </g>
        <g id="Group_463" data-name="Group 463">
          <g id="Group_462" data-name="Group 462">
            <path
              id="Path_272"
              data-name="Path 272"
              d="M917.108,533.38a4.351,4.351,0,0,0-2.688,1.126v-.933h-2.38v9.007h2.38v-6.3a2.475,2.475,0,0,1,1.691-.98c1.028,0,.98,1.142.98,1.865v5.415h2.383v-6.386c0-2.214-1.386-2.814-2.366-2.814"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_464" data-name="Group 464">
          <path
            id="Path_274"
            data-name="Path 274"
            d="M921.193,530.066v2.187h2.383l0-2.187Zm0,12.515h2.38v-9.007h-2.38Z"
            fill="#fff"
          />
        </g>
        <g id="Group_465" data-name="Group 465">
          <path
            id="Path_275"
            data-name="Path 275"
            d="M932.468,533.573h-2.38l-1.545,6.451h-.035l-1.572-6.451h-2.495l2.8,9.01h2.509Z"
            fill="#fff"
          />
        </g>
        <g id="Group_469" data-name="Group 469">
          <g id="Group_466" data-name="Group 466">
            <path
              id="Path_276"
              data-name="Path 276"
              d="M935.572,537.144c.031-.966.468-2.01,1.546-2.01,1.142,0,1.543,1,1.543,2.01Zm1.481-3.763c-2.64,0-3.959,2.3-3.959,4.7s1.336,4.7,3.959,4.7a4.029,4.029,0,0,0,3.939-2.8l-2.2-.4a1.615,1.615,0,0,1-1.5,1.444,2.069,2.069,0,0,1-1.811-2.3c0-.028.007-.056.011-.084h5.5c.065-4.19-1.671-5.265-3.939-5.265"
              fill="#fff"
            />
          </g>
          <g id="Group_467" data-name="Group 467">
            <path
              id="Path_277"
              data-name="Path 277"
              d="M948.07,533.383h-.451c-1.1,0-1.838.692-2.749,1.77v-1.577h-2.383v9.007h2.383v-3.956a2.73,2.73,0,0,1,2.483-2.956l.028,0a3.356,3.356,0,0,1,.692.1Z"
              fill="#fff"
            />
          </g>
          <g id="Group_468" data-name="Group 468">
            <path
              id="Path_278"
              data-name="Path 278"
              d="M952.429,533.383c-1.753,0-3.315,1.061-3.315,2.881,0,3.505,4.359,2.217,4.359,3.794,0,.692-.563.966-1.156.966-.725,0-1.061-.611-1.111-1.255l-2.234.241a2.938,2.938,0,0,0,3.087,2.782q.088,0,.177-.015c1.834,0,3.427-.932,3.427-2.845,0-3.379-4.357-2.249-4.357-3.8a.946.946,0,0,1,.892-1c.025,0,.05,0,.074,0,.706,0,.916.451,1.028,1.078l2.254-.272a3.052,3.052,0,0,0-3.125-2.555"
              fill="#fff"
            />
          </g>
        </g>
        <path
          id="Path_280"
          data-name="Path 280"
          d="M957.042,532.254h2.38v-2.187h-2.38Zm0-2.187v12.518h2.38v-9.007h-2.38Z"
          fill="#fff"
        />
        <g id="Group_476" data-name="Group 476">
          <g id="Group_470" data-name="Group 470">
            <path
              id="Path_281"
              data-name="Path 281"
              d="M964.894,540.75c-1.431,0-1.641-1.735-1.641-2.813,0-1,.274-2.671,1.593-2.671a2.166,2.166,0,0,1,1.593.98v3.474a1.876,1.876,0,0,1-1.546,1.03m3.926-10.681H966.44v4.393a3.2,3.2,0,0,0-2.221-1.078c-1.3,0-3.3,1.142-3.3,4.471,0,3.8,1.672,4.922,3.491,4.922a3.034,3.034,0,0,0,2.282-.949l.21.756h1.917Z"
              fill="#fff"
            />
          </g>
          <g id="Group_471" data-name="Group 471">
            <path
              id="Path_282"
              data-name="Path 282"
              d="M973.467,541.024c-.563,0-.82-.434-.82-.966,0-1.319,1.946-1.414,2.929-1.593v1.386a2.637,2.637,0,0,1-2.109,1.173m.949-7.641c-1.882,0-3.169.61-3.7,2.525l2.283.353a1.29,1.29,0,0,1,1.434-1.125c.885,0,1.3.451,1.142,1.7-1.915.215-5.261.73-5.261,3.276a2.673,2.673,0,0,0,2.675,2.67c.05,0,.1,0,.151-.005a3.849,3.849,0,0,0,2.564-1.014l.258.82h2.315a4.178,4.178,0,0,1-.322-1.881V536.23c0-1.688-1.109-2.847-3.539-2.847"
              fill="#fff"
            />
          </g>
          <g id="Group_472" data-name="Group 472">
            <path
              id="Path_283"
              data-name="Path 283"
              d="M983.5,540.75c-1.431,0-1.641-1.735-1.641-2.813,0-1,.274-2.671,1.593-2.671a2.166,2.166,0,0,1,1.593.98v3.474a1.876,1.876,0,0,1-1.546,1.03m1.547-10.681v4.393a3.2,3.2,0,0,0-2.221-1.078c-1.3,0-3.3,1.142-3.3,4.471,0,3.8,1.672,4.922,3.491,4.922a3.047,3.047,0,0,0,2.285-.949l.207.756h1.915V530.072Z"
              fill="#fff"
            />
          </g>
          <g id="Group_473" data-name="Group 473">
            <path
              id="Path_284"
              data-name="Path 284"
              d="M991.4,537.15c.034-.966.468-2.01,1.546-2.01,1.14,0,1.543,1,1.543,2.01Zm1.481-3.763c-2.64,0-3.959,2.3-3.959,4.7s1.336,4.7,3.959,4.7a4.029,4.029,0,0,0,3.939-2.8l-2.2-.4a1.615,1.615,0,0,1-1.5,1.444,2.069,2.069,0,0,1-1.811-2.3c0-.028.007-.056.011-.084h5.5c.065-4.19-1.671-5.265-3.939-5.265"
              fill="#fff"
            />
          </g>
          <g id="Group_474" data-name="Group 474">
            <path
              id="Path_285"
              data-name="Path 285"
              d="M1007.052,540.753c-1.431,0-1.641-1.738-1.641-2.816,0-1,.274-2.668,1.593-2.668a2.166,2.166,0,0,1,1.593.98v3.474a1.876,1.876,0,0,1-1.546,1.03m3.926-10.681H1008.6v4.39a3.208,3.208,0,0,0-2.221-1.075c-1.3,0-3.3,1.142-3.3,4.474,0,3.8,1.672,4.926,3.491,4.926a3.033,3.033,0,0,0,2.282-.949l.21.756h1.917Z"
              fill="#fff"
            />
          </g>
          <g id="Group_475" data-name="Group 475">
            <path
              id="Path_286"
              data-name="Path 286"
              d="M1016.428,541.027c-1.288,0-1.512-1.817-1.512-2.943s.224-2.945,1.512-2.945,1.512,1.817,1.512,2.945-.224,2.943-1.512,2.943m0-7.641c-2.637,0-3.956,2.3-3.956,4.7,0,2.38,1.336,4.7,3.956,4.7s3.957-2.322,3.957-4.7c0-2.4-1.319-4.7-3.956-4.7"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_477" data-name="Group 477">
          <path
            id="Path_288"
            data-name="Path 288"
            d="M1031,530.071h-4.119v12.515h2.511v-9.973h.031l2.315,9.976h2.255l2.315-9.973h.034v9.973h2.51V530.071h-4.12l-1.851,8.979h-.029Z"
            fill="#fff"
          />
        </g>
        <path
          id="Path_289"
          data-name="Path 289"
          d="M1040.6,532.262h2.383v-2.189H1040.6Zm0-2.189v12.515h2.383v-9.007H1040.6Z"
          fill="#fff"
        />
        <g id="Group_484" data-name="Group 484">
          <g id="Group_478" data-name="Group 478">
            <path
              id="Path_290"
              data-name="Path 290"
              d="M1049.756,533.388a4.343,4.343,0,0,0-2.685,1.126v-.933h-2.383v9.007h2.383v-6.3a2.462,2.462,0,0,1,1.688-.98c1.03,0,.98,1.142.98,1.865v5.415h2.383v-6.383c0-2.217-1.386-2.817-2.366-2.817"
              fill="#fff"
            />
          </g>
          <g id="Group_479" data-name="Group 479">
            <path
              id="Path_291"
              data-name="Path 291"
              d="M1056.172,530.074h-2.38v12.515h2.38v-6.3a2.463,2.463,0,0,1,1.691-.983c1.028,0,.98,1.142.98,1.868v5.421h2.38V536.2c0-2.22-1.383-2.814-2.363-2.814a4.35,4.35,0,0,0-2.688,1.126Z"
              fill="#fff"
            />
          </g>
          <g id="Group_480" data-name="Group 480">
            <path
              id="Path_292"
              data-name="Path 292"
              d="M1066.644,541.029c-1.288,0-1.512-1.817-1.512-2.943s.224-2.945,1.512-2.945,1.512,1.817,1.512,2.945-.224,2.943-1.512,2.943m0-7.641c-2.637,0-3.956,2.3-3.956,4.7,0,2.38,1.336,4.7,3.956,4.7s3.957-2.322,3.957-4.7c0-2.4-1.319-4.7-3.956-4.7"
              fill="#fff"
            />
          </g>
          <g id="Group_481" data-name="Group 481">
            <path
              id="Path_293"
              data-name="Path 293"
              d="M913.617,550.99a3.12,3.12,0,0,0-1.36.3,2.431,2.431,0,0,0-.988.862,2.322,2.322,0,0,0-.37,1.3,2.147,2.147,0,0,0,.372,1.31,2.481,2.481,0,0,0,.89.773,10.626,10.626,0,0,0,1.392.555,11.593,11.593,0,0,1,1.1.434,2.022,2.022,0,0,1,.666.5,1.137,1.137,0,0,1,.266.787,1.332,1.332,0,0,1-.5,1.117,1.927,1.927,0,0,1-1.238.4,2.457,2.457,0,0,1-2.31-1.438l-1,.627a3.78,3.78,0,0,0,1.389,1.393,3.848,3.848,0,0,0,1.924.473,2.961,2.961,0,0,0,2.1-.756,2.653,2.653,0,0,0,.808-2.037,1.962,1.962,0,0,0-.361-1.235,2.46,2.46,0,0,0-.885-.731,11.485,11.485,0,0,0-1.375-.549,9.839,9.839,0,0,1-1.109-.434,2.1,2.1,0,0,1-.678-.5,1.12,1.12,0,0,1-.273-.771,1.136,1.136,0,0,1,.467-.98,1.857,1.857,0,0,1,1.126-.339,2.2,2.2,0,0,1,1.159.3,2.877,2.877,0,0,1,.868.879l.885-.692a3.374,3.374,0,0,0-1.271-1.162,3.665,3.665,0,0,0-1.689-.386"
              fill="#fff"
            />
          </g>
          <g id="Group_482" data-name="Group 482">
            <path
              id="Path_294"
              data-name="Path 294"
              d="M921.788,550.993a3.207,3.207,0,0,0-2.573,1.156,6.889,6.889,0,0,0,0,7.083,3.206,3.206,0,0,0,2.573,1.152,2.87,2.87,0,0,0,1.868-.666,4.011,4.011,0,0,0,1.221-1.725l-1.014-.454q-.768,1.719-2.075,1.784A1.81,1.81,0,0,1,920,558.236a6.636,6.636,0,0,1,.008-5.107,1.865,1.865,0,0,1,1.832-1.075,1.331,1.331,0,0,1,1.056.459,4.161,4.161,0,0,1,.682,1.215l1.061-.484a3.793,3.793,0,0,0-1.094-1.651,2.631,2.631,0,0,0-1.753-.6"
              fill="#fff"
            />
          </g>
          <g id="Group_483" data-name="Group 483">
            <path
              id="Path_295"
              data-name="Path 295"
              d="M929.911,559.323a1.817,1.817,0,0,1-1.8-1.087,6.742,6.742,0,0,1,0-5.1,2.028,2.028,0,0,1,3.592,0,6.638,6.638,0,0,1,0,5.1,1.817,1.817,0,0,1-1.8,1.087m0-8.33a3.215,3.215,0,0,0-2.568,1.156,6.862,6.862,0,0,0,0,7.078,3.44,3.44,0,0,0,5.146,0,6.862,6.862,0,0,0,0-7.078,3.217,3.217,0,0,0-2.573-1.156"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_485" data-name="Group 485">
          <path
            id="Path_297"
            data-name="Path 297"
            d="M935.2,547.614v12.513h1.257l0-12.513Z"
            fill="#fff"
          />
        </g>
        <g id="Group_489" data-name="Group 489">
          <g id="Group_486" data-name="Group 486">
            <path
              id="Path_298"
              data-name="Path 298"
              d="M940.72,559.194a1.213,1.213,0,0,1-.941-.451,1.518,1.518,0,0,1-.4-1.03,1.646,1.646,0,0,1,.623-1.269,4.234,4.234,0,0,1,1.61-.829c.652-.185,1.028-.3,1.126-.328l.5-.146v2.608a4.675,4.675,0,0,1-1.171,1.033,2.509,2.509,0,0,1-1.352.412m.837-8.2a3.658,3.658,0,0,0-3.057,1.8l.885.661a3.963,3.963,0,0,1,.965-1.023,2.032,2.032,0,0,1,1.207-.378,1.787,1.787,0,0,1,1.229.409,1.472,1.472,0,0,1,.459,1.151v.5l-.4.108-.353.1a20.7,20.7,0,0,0-2.2.708,3.933,3.933,0,0,0-1.459,1.02,2.574,2.574,0,0,0-.623,1.791,2.5,2.5,0,0,0,.33,1.271,2.529,2.529,0,0,0,.893.927,2.3,2.3,0,0,0,1.238.344,2.461,2.461,0,0,0,1.3-.361A7.2,7.2,0,0,0,943.245,559l.129,1.126h1.366a3.026,3.026,0,0,1-.168-.636,5.267,5.267,0,0,1-.065-.764c-.005-.277-.008-.465-.008-.563v-4.407a2.566,2.566,0,0,0-.459-1.568,2.732,2.732,0,0,0-1.133-.91,3.408,3.408,0,0,0-1.35-.288"
              fill="#fff"
            />
          </g>
          <g id="Group_487" data-name="Group 487">
            <path
              id="Path_299"
              data-name="Path 299"
              d="M954.292,559.293a1.639,1.639,0,0,1-.966-.347,2.57,2.57,0,0,1-.809-1.117,5.152,5.152,0,0,1-.325-1.994,6.792,6.792,0,0,1,.476-2.567,1.684,1.684,0,0,1,1.641-1.182,2,2,0,0,1,1.232.4,2.789,2.789,0,0,1,.851,1.028v4.122a3.376,3.376,0,0,1-.89,1.142,1.836,1.836,0,0,1-1.21.515m3.349-11.678h-1.249v4.553a5,5,0,0,0-1.069-.846,2.286,2.286,0,0,0-1.156-.33,2.774,2.774,0,0,0-1.575.515,3.656,3.656,0,0,0-1.24,1.618,6.855,6.855,0,0,0-.484,2.741,5.619,5.619,0,0,0,.532,2.6,3.574,3.574,0,0,0,1.28,1.471,2.8,2.8,0,0,0,1.439.449,2.344,2.344,0,0,0,1.238-.33,3.936,3.936,0,0,0,1.035-.941v1.015h1.249Z"
              fill="#fff"
            />
          </g>
          <g id="Group_488" data-name="Group 488">
            <path
              id="Path_300"
              data-name="Path 300"
              d="M964.734,554.84h-4a3.938,3.938,0,0,1,.257-1.3,2.676,2.676,0,0,1,.7-1.073,1.661,1.661,0,0,1,1.145-.413,1.456,1.456,0,0,1,1.055.434,2.633,2.633,0,0,1,.65,1.086,3.839,3.839,0,0,1,.193,1.266m-1.8-3.847a3.216,3.216,0,0,0-2.573,1.159,6.88,6.88,0,0,0,0,7.078,3.218,3.218,0,0,0,2.576,1.157,3.541,3.541,0,0,0,1.968-.554,3.11,3.11,0,0,0,1.232-1.44l-.9-.6a3.641,3.641,0,0,1-.943,1.09,1.963,1.963,0,0,1-1.232.442,2.08,2.08,0,0,1-1.711-.82,4.192,4.192,0,0,1-.651-2.607h5.356c.022-.258.031-.456.031-.608a6.547,6.547,0,0,0-.322-2.082,3.551,3.551,0,0,0-1.028-1.593,2.638,2.638,0,0,0-1.8-.622"
              fill="#fff"
            />
          </g>
        </g>
        <g id="Group_490" data-name="Group 490">
          <path
            id="Path_302"
            data-name="Path 302"
            d="M980.159,547.617l-2.685,10.309h-.05l-2.736-10.309H972.5V560.13h1.319V548.79h.031l3.06,11.34h1.075l3.057-11.34h.034v11.34h1.316V547.617Z"
            fill="#fff"
          />
        </g>
        <g id="Group_493" data-name="Group 493">
          <g id="Group_491" data-name="Group 491">
            <path
              id="Path_303"
              data-name="Path 303"
              d="M985.483,554.84a4.021,4.021,0,0,1,.255-1.3,2.663,2.663,0,0,1,.708-1.071,1.66,1.66,0,0,1,1.143-.412,1.464,1.464,0,0,1,1.055.434,2.633,2.633,0,0,1,.65,1.086,3.767,3.767,0,0,1,.193,1.263Zm2.2-3.844a3.206,3.206,0,0,0-2.569,1.159,6.856,6.856,0,0,0,0,7.075,3.221,3.221,0,0,0,2.573,1.16,3.551,3.551,0,0,0,1.971-.554,3.141,3.141,0,0,0,1.229-1.44l-.9-.6a3.661,3.661,0,0,1-.941,1.086,1.971,1.971,0,0,1-1.232.446,2.084,2.084,0,0,1-1.714-.823,4.194,4.194,0,0,1-.65-2.606h5.356c.022-.258.034-.459.034-.61a6.628,6.628,0,0,0-.326-2.081,3.576,3.576,0,0,0-1.027-1.593,2.643,2.643,0,0,0-1.8-.619"
              fill="#fff"
            />
          </g>
          <g id="Group_492" data-name="Group 492">
            <path
              id="Path_304"
              data-name="Path 304"
              d="M995.79,559.3a1.639,1.639,0,0,1-.966-.347,2.57,2.57,0,0,1-.809-1.117,5.152,5.152,0,0,1-.325-1.994,6.8,6.8,0,0,1,.476-2.567,1.684,1.684,0,0,1,1.644-1.182,2.006,2.006,0,0,1,1.229.4,2.789,2.789,0,0,1,.851,1.028v4.122a3.376,3.376,0,0,1-.89,1.142,1.835,1.835,0,0,1-1.21.515m3.349-11.678H997.89v4.553a5,5,0,0,0-1.069-.846,2.285,2.285,0,0,0-1.156-.33,2.773,2.773,0,0,0-1.575.515,3.655,3.655,0,0,0-1.24,1.618,6.837,6.837,0,0,0-.484,2.741,5.618,5.618,0,0,0,.532,2.6,3.575,3.575,0,0,0,1.28,1.471,2.794,2.794,0,0,0,1.439.449,2.344,2.344,0,0,0,1.238-.33,3.935,3.935,0,0,0,1.035-.941v1.015h1.249Z"
              fill="#fff"
            />
          </g>
        </g>
        <path
          id="Path_306"
          data-name="Path 306"
          d="M1001.131,549h1.252v-1.383h-1.252Zm0-1.383v12.515h1.252v-8.878Z"
          fill="#fff"
        />
        <g id="Group_495" data-name="Group 495">
          <g id="Group_494" data-name="Group 494">
            <path
              id="Path_307"
              data-name="Path 307"
              d="M1007.678,550.995a3.208,3.208,0,0,0-2.573,1.159,6.884,6.884,0,0,0,0,7.08,3.206,3.206,0,0,0,2.573,1.155,2.87,2.87,0,0,0,1.868-.666,4.009,4.009,0,0,0,1.22-1.728l-1.013-.454q-.768,1.722-2.075,1.786a1.81,1.81,0,0,1-1.792-1.086,6.636,6.636,0,0,1,.008-5.107,1.865,1.865,0,0,1,1.832-1.078,1.331,1.331,0,0,1,1.056.459,4.175,4.175,0,0,1,.682,1.218l1.061-.484a3.794,3.794,0,0,0-1.094-1.654,2.614,2.614,0,0,0-1.753-.6"
              fill="#fff"
            />
          </g>
        </g>
        <path
          id="Path_309"
          data-name="Path 309"
          d="M1012.5,549h1.254V547.62H1012.5Zm0-1.383v12.513h1.254v-8.879H1012.5Z"
          fill="#fff"
        />
        <g id="Group_498" data-name="Group 498">
          <g id="Group_496" data-name="Group 496">
            <path
              id="Path_310"
              data-name="Path 310"
              d="M1019.42,551a2.4,2.4,0,0,0-1.178.283,9.574,9.574,0,0,0-1.263.89v-.915h-1.258v8.878h1.254v-6.756a4.774,4.774,0,0,1,1.084-.924,2.3,2.3,0,0,1,1.2-.426.954.954,0,0,1,.949.456,2.942,2.942,0,0,1,.224,1.263v6.387h1.256v-6.129q0-3.006-2.268-3.007"
              fill="#fff"
            />
          </g>
          <g id="Group_497" data-name="Group 497">
            <path
              id="Path_311"
              data-name="Path 311"
              d="M1025.918,559.2a1.213,1.213,0,0,1-.941-.451,1.517,1.517,0,0,1-.4-1.03,1.655,1.655,0,0,1,.623-1.271,4.263,4.263,0,0,1,1.61-.826c.652-.188,1.03-.3,1.126-.328l.5-.146v2.6a4.709,4.709,0,0,1-1.171,1.04,2.51,2.51,0,0,1-1.352.412m.837-8.2a3.659,3.659,0,0,0-3.057,1.8l.885.661a3.962,3.962,0,0,1,.965-1.023,2.032,2.032,0,0,1,1.207-.378,1.788,1.788,0,0,1,1.229.409,1.473,1.473,0,0,1,.459,1.151v.5l-.4.108-.353.1a20.705,20.705,0,0,0-2.2.708,3.933,3.933,0,0,0-1.459,1.02,2.574,2.574,0,0,0-.623,1.791,2.5,2.5,0,0,0,.33,1.271,2.528,2.528,0,0,0,.893.927,2.3,2.3,0,0,0,1.238.344,2.461,2.461,0,0,0,1.3-.361,7.218,7.218,0,0,0,1.277-1.021l.129,1.121h1.366a3.025,3.025,0,0,1-.168-.636,5.276,5.276,0,0,1-.065-.764q-.008-.416-.008-.563v-4.4a2.566,2.566,0,0,0-.459-1.568,2.733,2.733,0,0,0-1.133-.91,3.408,3.408,0,0,0-1.35-.288"
              fill="#fff"
            />
          </g>
        </g>
        <path
          id="Path_136"
          data-name="Path 136"
          d="M971.7,447.4v70.092h70.092V447.4Zm37.66,34.168a2.13,2.13,0,0,1,2.834-1.02l2.116.94a2.128,2.128,0,1,1-1.8,3.856l-2.114-.935-.015-.007A2.129,2.129,0,0,1,1009.358,481.564Zm-5.218-20.551a2.129,2.129,0,0,1,4.259,0h0v3.407a2.131,2.131,0,1,1-4.262,0Zm4.262,14.276v10.483a2.131,2.131,0,1,1-4.262,0V475.289a2.129,2.129,0,0,1,4.259,0Zm-10.334-5.237,5.369-2.463a2.123,2.123,0,0,1,2.824,1.02l.005.01a2.123,2.123,0,0,1-1.02,2.824l-.009,0-5.371,2.466a2.13,2.13,0,1,1-1.8-3.861Zm-1.036,6.149a2.13,2.13,0,0,1,2.834-1.02l2.116.94a2.13,2.13,0,0,1-1.8,3.859l-2.114-.938-.015-.007A2.129,2.129,0,0,1,997.032,476.2Zm5.956,26.21a2.129,2.129,0,0,1-2.808,1.089l-2.114-.935a2.131,2.131,0,0,1,1.8-3.864l2.116.94A2.131,2.131,0,0,1,1002.988,502.411Zm5.414,4.341a2.131,2.131,0,1,1-4.262,0v-8.514a2.129,2.129,0,0,1,4.259,0h0Zm5.979-16.1c-.024.011-.048.023-.073.033L999.931,497.2a2.129,2.129,0,1,1-1.8-3.859l14.375-6.52a2.129,2.129,0,0,1,1.873,3.825Z"
          fill="#fff"
        />
        <path
          id="Path_137"
          data-name="Path 137"
          d="M901.6,447.4v70.092h70.1V447.4Zm32.787,14.5a2.18,2.18,0,0,1,2.187-2.181h0a2.18,2.18,0,0,1,2.179,2.181v7.652a2.184,2.184,0,1,1-4.368,0Zm-7.811,28.792-6.478,3.908a2.182,2.182,0,1,1-2.2-3.77l.011-.007,6.475-3.911a2.184,2.184,0,1,1,2.189,3.78Zm5-8.6-.058-.034-13.706-7.98a2.181,2.181,0,1,1,2.16-3.789l.027.015,13.708,7.977a2.183,2.183,0,1,1-2.131,3.811Zm7.177,20.9a2.182,2.182,0,0,1-2.181,2.181h0a2.182,2.182,0,0,1-2.184-2.178V487.043a2.182,2.182,0,0,1,4.365,0Zm-.177-21.812a2.182,2.182,0,0,1,.806-2.979l13.86-7.852v0l.078-.044a2.181,2.181,0,1,1,2.1,3.824l-13.862,7.859A2.181,2.181,0,0,1,938.576,481.173ZM956.3,493.727a2.179,2.179,0,0,1-2.994.741l-6.658-3.774-.038-.022a2.186,2.186,0,1,1,2.224-3.764l6.652,3.78h-.005l.078.045A2.181,2.181,0,0,1,956.3,493.727Z"
          fill="#fff"
        />
      </g>
    </svg>

    &nbsp;
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39.4 11.27"
      class="company-logo"
    >
      <path
        d="M2.61,6.21V9.68l-.1.06-1.34.65a.46.46,0,0,1-.23,0H0s0-.07,0-.1V.89C0,.8,0,.76.11.72L1.45.07a.33.33,0,0,1,.14,0h1V1.1h0L2.74,1A4,4,0,0,1,4.58.11,4,4,0,0,1,9.3,2.72a3.65,3.65,0,0,1-3,4.52A4.08,4.08,0,0,1,2.73,6.3l-.12-.09"
        style="fill: #fff"
      ></path>
      <path
        d="M16.3,3.77a3.48,3.48,0,0,1,1.43,4.37,4,4,0,0,1-4.63,2.18,3.66,3.66,0,0,1-3-3.55l6.2-3"
        style="fill: #fff"
      ></path>
      <path
        d="M10.09.75,11.18.22A1.82,1.82,0,0,1,11.61,0a2.55,2.55,0,0,1,.48,0h5.52c0,.1,0,2.17,0,2.41L10.08,6.07V.75Z"
        style="fill: #fff"
      ></path>
      <path
        d="M24.83,6.46h-.34c0-.31,0-.62,0-.93s0-.62,0-.94c-.16.3-.29.62-.42.93s-.27.62-.41.94h-.32l-.82-1.87h0V6.44a1.25,1.25,0,0,1-.33,0c0-.1,0-2.1,0-2.44h.41c.31.67.62,1.34.92,2h0c.3-.67.61-1.34.91-2h.41V6.46Z"
        style="fill: #fff"
      ></path>
      <path
        d="M26.1,9.34h0s0,.08,0,.12a.64.64,0,0,0,.62.59.7.7,0,0,0,.77-.47.77.77,0,0,0,0-.37.67.67,0,0,0-.67-.57.66.66,0,0,0-.73.53c0,.06,0,.12,0,.17m1.43-.55v-.4h.34a.22.22,0,0,1,0,.08c0,.62,0,1.24,0,1.85a1,1,0,0,1-.07.39.87.87,0,0,1-.75.55,1.53,1.53,0,0,1-.6,0,.83.83,0,0,1-.57-.55.19.19,0,0,1,0-.08h.32l.05.09a.57.57,0,0,0,.36.28.91.91,0,0,0,.4,0,.56.56,0,0,0,.51-.49,5.23,5.23,0,0,0,0-.56l0,0-.05.07a.79.79,0,0,1-.65.36.91.91,0,0,1-1-.82A1.28,1.28,0,0,1,25.82,9a1,1,0,0,1,1.23-.56,1,1,0,0,1,.48.39"
        style="fill: #fff"
      ></path>
      <path
        d="M22.49,10a3.21,3.21,0,0,0,.88,0,.82.82,0,0,0,.64-.6,1.32,1.32,0,0,0,0-.44.83.83,0,0,0-.67-.78,3.77,3.77,0,0,0-.89-.05Zm-.35-2.19h0c.37,0,.74,0,1.11,0a1.36,1.36,0,0,1,.43.11,1,1,0,0,1,.63.67,1.4,1.4,0,0,1,0,.81,1.15,1.15,0,0,1-1,.84,1.84,1.84,0,0,1-.33,0h-.91V7.84Z"
        style="fill: #fff"
      ></path>
      <path
        d="M28.13,5.49h0a.28.28,0,0,1,0,.09.65.65,0,0,0,.6.62.7.7,0,0,0,.79-.46.9.9,0,0,0,0-.28.67.67,0,0,0-.4-.61.7.7,0,0,0-1,.47,1.22,1.22,0,0,0,0,.17m1.77,1h-.34V6.05h0l0,0a.8.8,0,0,1-.81.4.9.9,0,0,1-.91-.81,1.07,1.07,0,0,1,.07-.61,1,1,0,0,1,1.26-.5.79.79,0,0,1,.36.29.32.32,0,0,0,.08.09V3.88a.77.77,0,0,1,.34,0V6.46Z"
        style="fill: #fff"
      ></path>
      <path
        d="M39.26,7.8v.27a3.38,3.38,0,0,1-.45,0h-.94v.8l.06,0a1,1,0,0,1,.88-.17.68.68,0,0,1,.54.49.88.88,0,0,1,0,.62.75.75,0,0,1-.64.52,1.28,1.28,0,0,1-.55,0,.77.77,0,0,1-.62-.7,1.22,1.22,0,0,1,.33,0l.06.14a.53.53,0,0,0,.43.31.57.57,0,0,0,.7-.69c-.06-.36-.36-.48-.72-.42a.57.57,0,0,0-.37.2.18.18,0,0,1-.18.08h-.21V7.8Z"
        style="fill: #fff"
      ></path>
      <path
        d="M24.23,1.8h.34a.15.15,0,0,1,0,.07,1.13,1.13,0,0,1-1,.74,1.48,1.48,0,0,1-.47,0,1.14,1.14,0,0,1-.92-.71,1.34,1.34,0,0,1,0-1.09A1.17,1.17,0,0,1,23.22.1a1.6,1.6,0,0,1,.65.08,1.1,1.1,0,0,1,.69.69.11.11,0,0,1,0,.06h-.35l0-.06A1,1,0,0,0,23.1.42a.81.81,0,0,0-.61.5,1.1,1.1,0,0,0,0,.89.83.83,0,0,0,.8.53.91.91,0,0,0,.88-.44l.05-.08s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M38.3,6.21a.63.63,0,0,0,.55-.35.75.75,0,0,0,0-.74.72.72,0,0,0-.7-.33.65.65,0,0,0-.59.45.89.89,0,0,0,0,.46c.07.32.32.51.77.51m.63-1.68h.33c0,.09,0,1.74,0,1.91a.7.7,0,0,1-.33,0v-.4h0l0,0a.83.83,0,0,1-.82.4.89.89,0,0,1-.9-.79,1.18,1.18,0,0,1,.05-.59,1,1,0,0,1,1.24-.55.75.75,0,0,1,.4.3.32.32,0,0,0,.08.09Z"
        style="fill: #fff"
      ></path>
      <path
        d="M32.47,9.39c0-.1,0-.18,0-.26a.67.67,0,0,0-.68-.49.65.65,0,0,0-.69.47.85.85,0,0,0,0,.42.65.65,0,0,0,.6.53.69.69,0,0,0,.74-.38,2.16,2.16,0,0,0,.08-.29m0-.6v-.4h.34v1.92h-.33v-.4h0l-.06.09a.78.78,0,0,1-.62.35.93.93,0,0,1-1.08-.84,1.22,1.22,0,0,1,.1-.65A1,1,0,0,1,32,8.43a.76.76,0,0,1,.34.27l.06.09h0"
        style="fill: #fff"
      ></path>
      <path
        d="M35.68,9c.22,0,.42,0,.62,0a.45.45,0,0,0,.41-.24.47.47,0,0,0-.43-.69h-.6Zm-.34-1.2h.91a1.41,1.41,0,0,1,.35,0,.66.66,0,0,1,.52.59,1.13,1.13,0,0,1,0,.32.6.6,0,0,1-.45.46,1.76,1.76,0,0,1-.4.07h-.57v1h-.34Z"
        style="fill: #fff"
      ></path>
      <path
        d="M27,5.4a.5.5,0,0,0-.21-.52.74.74,0,0,0-.77,0,.58.58,0,0,0-.34.56Zm0,.4h.35a.5.5,0,0,1,0,.13.87.87,0,0,1-.59.51,1.34,1.34,0,0,1-.63,0,.91.91,0,0,1-.76-.85,1.42,1.42,0,0,1,0-.41,1,1,0,0,1,1-.7,1.27,1.27,0,0,1,.39.06.83.83,0,0,1,.57,1H25.7a.57.57,0,0,0,.46.64A.68.68,0,0,0,27,5.8"
        style="fill: #fff"
      ></path>
      <path
        d="M26.66,1.55A.53.53,0,0,0,26.37,1a.76.76,0,0,0-.76,0,.6.6,0,0,0-.3.54Zm.33.16H25.34a.6.6,0,0,0,.5.65.65.65,0,0,0,.8-.41H27a.5.5,0,0,1,0,.13.84.84,0,0,1-.58.5,1.3,1.3,0,0,1-.65,0A.91.91,0,0,1,25,1.75a1.07,1.07,0,0,1,.07-.53.91.91,0,0,1,.84-.57,1.48,1.48,0,0,1,.51,0,.85.85,0,0,1,.61.91.36.36,0,0,1,0,.1"
        style="fill: #fff"
      ></path>
      <path
        d="M34.5,1.65h0a.49.49,0,0,0,0-.12.67.67,0,0,0-.64-.59.68.68,0,0,0-.73.47.83.83,0,0,0,0,.54.72.72,0,0,0,1.3,0,2,2,0,0,0,.07-.31m.35,0c0,.11,0,.22-.06.33a1,1,0,0,1-.92.65A1,1,0,0,1,32.77,2a1.14,1.14,0,0,1,0-.66A.93.93,0,0,1,33.6.67a1.31,1.31,0,0,1,.52,0,.94.94,0,0,1,.7.8.86.86,0,0,1,0,.16s0,0,0,0"
        style="fill: #fff"
      ></path>
      <path
        d="M27.85,2.61h-.34V.69h.33v.36s0,0,0,0l0,0a.76.76,0,0,1,.76-.36.73.73,0,0,1,.76.69c0,.41,0,.83,0,1.24,0,0,0,0,0,0h-.33V1.56a1.07,1.07,0,0,0,0-.25A.49.49,0,0,0,28.6.94a.59.59,0,0,0-.74.54c0,.33,0,.66,0,1v.15"
        style="fill: #fff"
      ></path>
      <path
        d="M34.77,4.53h.33V4.9h0l0,0a.77.77,0,0,1,.74-.37.73.73,0,0,1,.77.67,1.15,1.15,0,0,1,0,.19v1.1h-.34s0-.09,0-.14V5.41a.92.92,0,0,0,0-.29.49.49,0,0,0-.4-.33.61.61,0,0,0-.79.57c0,.24,0,.48,0,.72v.38h-.34V4.53Z"
        style="fill: #fff"
      ></path>
      <path
        d="M33,5.77h.36a.77.77,0,0,1-.41.58,1.16,1.16,0,0,1-1.19,0,.86.86,0,0,1-.41-.64,1.15,1.15,0,0,1,0-.52.93.93,0,0,1,.88-.66,1.28,1.28,0,0,1,.64.11.77.77,0,0,1,.45.61H33l0,0a.6.6,0,0,0-.65-.4.62.62,0,0,0-.61.44.89.89,0,0,0,0,.58.7.7,0,0,0,1.05.28A.64.64,0,0,0,33,5.77"
        style="fill: #fff"
      ></path>
      <path
        d="M30.4,10v.28a1.54,1.54,0,0,1-.57-.05.46.46,0,0,1-.31-.4,1.93,1.93,0,0,1,0-.24v-1H29.2V8.39h.31V7.91h.35v.47h.54v.28h-.52a.45.45,0,0,0,0,.11v1c0,.17.09.24.28.26h.25"
        style="fill: #fff"
      ></path>
      <path
        d="M30.06,1h-.29a.81.81,0,0,1,0-.27h.3V.19h.36V.67H31V1h-.52c0,.05,0,.08,0,.12V2a.76.76,0,0,0,0,.15.22.22,0,0,0,.24.2H31v.28a1.22,1.22,0,0,1-.63-.07.37.37,0,0,1-.23-.3,1.09,1.09,0,0,1,0-.26V1.11a.39.39,0,0,1,0-.16"
        style="fill: #fff"
      ></path>
      <path
        d="M31.38.69h.34V1a1,1,0,0,1,.34-.3,1,1,0,0,1,.43-.09,1.29,1.29,0,0,1,0,.34h-.12a1.52,1.52,0,0,0-.21,0,.49.49,0,0,0-.42.48c0,.11,0,.22,0,.34v.76h-.33c0-.1-.05-1.71,0-1.92"
        style="fill: #fff"
      ></path>
      <path
        d="M33.74,10.31h-.31c0-.1,0-2.46,0-2.61h.32s0,0,0,0v2.49s0,0,0,.06"
        style="fill: #fff"
      ></path>
      <rect
        x="24.93"
        y="8.39"
        width="0.33"
        height="1.92"
        style="fill: #fff"
      ></rect>
      <rect
        x="33.82"
        y="4.54"
        width="0.33"
        height="1.92"
        style="fill: #fff"
      ></rect>
      <path
        d="M28.81,10.31H28.5c0-.09,0-1.75,0-1.92a1.08,1.08,0,0,1,.31,0c0,.1,0,1.73,0,1.93"
        style="fill: #fff"
      ></path>
      <rect
        x="30.52"
        y="4.53"
        width="0.33"
        height="1.92"
        style="fill: #fff"
      ></rect>
      <path
        d="M34,3.76c.14,0,.24.08.24.2a.22.22,0,0,1-.24.2c-.14,0-.23-.08-.23-.19A.21.21,0,0,1,34,3.76"
        style="fill: #fff"
      ></path>
      <path
        d="M30.68,3.76c.15,0,.24.08.24.2s-.1.2-.24.2A.21.21,0,0,1,30.45,4a.21.21,0,0,1,.23-.21"
        style="fill: #fff"
      ></path>
      <path
        d="M28.64,7.62c.14,0,.24.08.24.2s-.1.2-.24.2-.23-.08-.23-.19a.21.21,0,0,1,.23-.21"
        style="fill: #fff"
      ></path>
      <path
        d="M25.09,8c-.14,0-.23-.08-.23-.19s.09-.2.24-.2.23.07.23.19-.09.2-.24.2"
        style="fill: #fff"
      ></path>
      <path
        d="M19.19.49h-.1V.37h.1a.05.05,0,0,1,.06.06c0,.06-.06.06-.06.06m.08.08s.14,0,.14-.15a.17.17,0,0,0-.09-.15l-.08,0H19V.79h.15V.58h0l.13.21h.16Z"
        style="fill: #fff"
      ></path>
      <path
        d="M19.15,1a.47.47,0,0,1-.5-.45.47.47,0,0,1,.5-.45.48.48,0,0,1,.5.45.47.47,0,0,1-.5.45m0-1a.56.56,0,0,0-.59.53.59.59,0,0,0,1.18,0A.56.56,0,0,0,19.15,0"
        style="fill: #fff"
      ></path>
    </svg>
  </div>
  <div style="margin-right: 12px">
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 128.92 8.37"
      class="company-logo"
      style="enable-background: new 0 0 128.92 8.37"
      xml:space="preserve"
    >
      <style type="text/css">
        .cofinanciado_st0 {
          fill: #631a86;
        }
      </style>
      <g>
        <path
          class="cofinanciado_st0"
          d="M0.34,7.93c0.15,0,0.22-0.08,0.22-0.2c0-0.12-0.08-0.21-0.22-0.21H0.17v0.41H0.34z M0,7.44h0.35 c0.2,0,0.31,0.12,0.31,0.28S0.55,8,0.35,8H0.17v0.3h0.09v0.06H0V8.3h0.08V7.51H0V7.44z"
        ></path>
        <path
          class="cofinanciado_st0"
          d="M1.06,7.91c0.16,0,0.23-0.08,0.23-0.2c0-0.12-0.07-0.2-0.23-0.2H0.88v0.4H1.06z M1.09,7.98h-0.2V8.3h0.1v0.07 H0.71V8.3H0.8V7.51H0.71V7.44h0.36c0.2,0,0.31,0.12,0.31,0.27c0,0.12-0.07,0.22-0.2,0.25l0.2,0.33h0.08v0.07H1.32L1.09,7.98z"
        ></path>
        <path
          class="cofinanciado_st0"
          d="M2.35,7.9c0-0.22-0.16-0.39-0.38-0.39C1.76,7.51,1.6,7.68,1.6,7.9c0,0.22,0.16,0.39,0.38,0.39 C2.19,8.29,2.35,8.13,2.35,7.9 M1.5,7.9c0-0.27,0.21-0.47,0.47-0.47c0.26,0,0.47,0.2,0.47,0.47c0,0.27-0.21,0.47-0.47,0.47 C1.71,8.37,1.5,8.17,1.5,7.9"
        ></path>
        <path
          class="cofinanciado_st0"
          d="M3.31,8.26c-0.07,0.07-0.17,0.11-0.3,0.11c-0.25,0-0.46-0.18-0.46-0.47c0-0.27,0.21-0.47,0.46-0.47 c0.13,0,0.22,0.04,0.28,0.12v-0.1h0.07v0.24H3.29C3.26,7.57,3.16,7.51,3.02,7.51c-0.22,0-0.38,0.17-0.38,0.39 c0,0.23,0.16,0.39,0.38,0.39c0.14,0,0.23-0.06,0.29-0.11V7.99H3.03V7.92h0.36v0.44H3.31V8.26z"
        ></path>
        <path
          class="cofinanciado_st0"
          d="M3.87,7.91c0.16,0,0.23-0.08,0.23-0.2c0-0.12-0.07-0.2-0.23-0.2H3.69v0.4H3.87z M3.89,7.98h-0.2V8.3h0.1v0.07 H3.52V8.3H3.6V7.51H3.52V7.44h0.36c0.2,0,0.31,0.12,0.31,0.27c0,0.12-0.07,0.22-0.2,0.25l0.2,0.33h0.08v0.07H4.13L3.89,7.98z"
        ></path>
        <path
          class="cofinanciado_st0"
          d="M4.77,7.53l0.18,0.51H4.59L4.77,7.53z M4.63,7.44v0.06H4.7L4.41,8.29H4.34v0.07h0.24V8.29H4.5l0.07-0.18h0.41 l0.07,0.18H4.95v0.07H5.2V8.29H5.13L4.85,7.51h0.07V7.44H4.63z"
        ></path>
        <polygon
          class="cofinanciado_st0"
          points="6.13,7.44 5.79,7.97 5.46,7.44 5.28,7.44 5.28,7.51 5.37,7.51 5.37,8.29 5.29,8.29 5.29,8.36 5.54,8.36 5.54,8.29 5.45,8.29 5.45,7.58 5.77,8.08 5.81,8.08 6.13,7.58 6.13,8.29 6.04,8.29 6.04,8.36 6.3,8.36 6.3,8.29 6.22,8.29 6.22,7.51 6.3,7.51 6.3,7.44   "
        ></polygon>
        <path
          class="cofinanciado_st0"
          d="M6.81,7.53l0.18,0.51H6.63L6.81,7.53z M6.68,7.44v0.06h0.07L6.45,8.29H6.38v0.07h0.24V8.29H6.54l0.07-0.18 h0.41l0.07,0.18H7v0.07h0.25V8.29H7.17L6.89,7.51h0.07V7.44H6.68z"
        ></path>
        <g>
          <path
            class="cofinanciado_st0"
            d="M8.4,7.9c0-0.22-0.16-0.39-0.38-0.39c-0.22,0-0.38,0.17-0.38,0.39c0,0.22,0.16,0.39,0.38,0.39 C8.24,8.29,8.4,8.13,8.4,7.9 M7.55,7.9c0-0.27,0.21-0.47,0.47-0.47c0.26,0,0.47,0.2,0.47,0.47c0,0.27-0.21,0.47-0.47,0.47 C7.76,8.37,7.55,8.17,7.55,7.9"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M8.93,7.93c0.15,0,0.22-0.08,0.22-0.2c0-0.12-0.08-0.21-0.22-0.21H8.75v0.41H8.93z M8.58,7.44h0.35 c0.2,0,0.31,0.12,0.31,0.28S9.13,8,8.93,8H8.75v0.3h0.09v0.06H8.58V8.3h0.08V7.51H8.58V7.44z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="9.3,7.44 9.3,7.51 9.38,7.51 9.38,8.29 9.3,8.29 9.3,8.36 9.95,8.36 9.95,8.16 9.88,8.16 9.88,8.29 9.47,8.29 9.47,7.93 9.84,7.93 9.84,7.86 9.47,7.86 9.47,7.52 9.86,7.52 9.86,7.64 9.93,7.64 9.93,7.44   "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M10.4,7.91c0.16,0,0.23-0.08,0.23-0.2c0-0.12-0.07-0.2-0.23-0.2h-0.17v0.4H10.4z M10.43,7.98h-0.2V8.3h0.1 v0.07h-0.27V8.3h0.08V7.51h-0.08V7.44h0.36c0.2,0,0.31,0.12,0.31,0.27c0,0.12-0.07,0.22-0.2,0.25l0.2,0.33h0.08v0.07h-0.14 L10.43,7.98z"
          ></path>
        </g>
        <path
          class="cofinanciado_st0"
          d="M11.31,7.53l0.18,0.51h-0.36L11.31,7.53z M11.17,7.44v0.06h0.06l-0.29,0.79h-0.07v0.07h0.24V8.29h-0.09 l0.07-0.18h0.41l0.07,0.18h-0.09v0.07h0.25V8.29h-0.07l-0.29-0.79h0.07V7.44H11.17z"
        ></path>
        <g>
          <path
            class="cofinanciado_st0"
            d="M12.21,7.43c0.13,0,0.23,0.05,0.29,0.12V7.44h0.07V7.7H12.5c-0.03-0.13-0.15-0.19-0.29-0.19 c-0.22,0-0.37,0.17-0.37,0.39c0,0.23,0.16,0.39,0.38,0.39c0.13,0,0.24-0.06,0.31-0.16l0.07,0.05c-0.09,0.12-0.22,0.18-0.38,0.18 c-0.26,0-0.47-0.2-0.47-0.47C11.75,7.63,11.95,7.43,12.21,7.43"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="12.68,7.44 12.68,7.51 12.76,7.51 12.76,8.29 12.68,8.29 12.68,8.36 12.93,8.36 12.93,8.29 12.85,8.29 12.85,7.51 12.93,7.51 12.93,7.44  "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M13.87,7.9c0-0.22-0.16-0.39-0.38-0.39c-0.22,0-0.38,0.17-0.38,0.39c0,0.22,0.16,0.39,0.38,0.39 C13.71,8.29,13.87,8.13,13.87,7.9 M13.02,7.9c0-0.27,0.21-0.47,0.47-0.47c0.26,0,0.47,0.2,0.47,0.47c0,0.27-0.21,0.47-0.47,0.47 C13.23,8.37,13.02,8.17,13.02,7.9"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="14.67,7.44 14.67,7.51 14.76,7.51 14.76,8.19 14.22,7.44 14.05,7.44 14.05,7.51 14.13,7.51 14.13,8.29 14.05,8.29 14.05,8.36 14.3,8.36 14.3,8.29 14.21,8.29 14.21,7.57 14.78,8.36 14.84,8.36 14.84,7.51 14.92,7.51 14.92,7.44   "
        ></polygon>
        <path
          class="cofinanciado_st0"
          d="M15.39,7.53l0.18,0.51h-0.36L15.39,7.53z M15.25,7.44v0.06h0.07l-0.29,0.79h-0.07v0.07h0.24V8.29h-0.09 l0.07-0.18h0.41l0.07,0.18h-0.09v0.07h0.25V8.29h-0.07l-0.29-0.79h0.07V7.44H15.25z"
        ></path>
        <polygon
          class="cofinanciado_st0"
          points="15.9,7.44 15.9,7.51 15.99,7.51 15.99,8.29 15.9,8.29 15.9,8.36 16.51,8.36 16.51,8.16 16.44,8.16 16.44,8.29 16.07,8.29 16.07,7.51 16.16,7.51 16.16,7.44   "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M17.17,7.91c0.16,0,0.23-0.08,0.23-0.2c0-0.12-0.07-0.2-0.23-0.2H17v0.4H17.17z M17.2,7.98H17V8.3h0.1v0.07 h-0.27V8.3h0.08V7.51h-0.08V7.44h0.36c0.2,0,0.31,0.12,0.31,0.27c0,0.12-0.07,0.22-0.2,0.25l0.2,0.33h0.08v0.07h-0.14L17.2,7.98z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="17.66,7.44 17.66,7.51 17.74,7.51 17.74,8.29 17.66,8.29 17.66,8.36 18.32,8.36 18.32,8.16 18.25,8.16 18.25,8.29 17.83,8.29 17.83,7.93 18.2,7.93 18.2,7.86 17.83,7.86 17.83,7.52 18.23,7.52 18.23,7.64 18.3,7.64 18.3,7.44  "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M19.18,8.26c-0.07,0.07-0.17,0.11-0.3,0.11c-0.25,0-0.46-0.18-0.46-0.47c0-0.27,0.21-0.47,0.46-0.47 c0.13,0,0.22,0.04,0.28,0.12v-0.1h0.07v0.24h-0.07c-0.03-0.11-0.13-0.17-0.28-0.17c-0.22,0-0.38,0.17-0.38,0.39 c0,0.23,0.16,0.39,0.38,0.39c0.14,0,0.23-0.06,0.29-0.11V7.99H18.9V7.92h0.36v0.44h-0.08V8.26z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="19.39,7.44 19.39,7.51 19.47,7.51 19.47,8.29 19.39,8.29 19.39,8.36 19.64,8.36 19.64,8.29 19.56,8.29 19.56,7.51 19.64,7.51 19.64,7.44  "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M20.57,7.9c0-0.22-0.16-0.39-0.38-0.39c-0.22,0-0.38,0.17-0.38,0.39c0,0.22,0.16,0.39,0.38,0.39 C20.41,8.29,20.57,8.13,20.57,7.9 M19.73,7.9c0-0.27,0.21-0.47,0.47-0.47c0.26,0,0.47,0.2,0.47,0.47c0,0.27-0.21,0.47-0.47,0.47 C19.94,8.37,19.73,8.17,19.73,7.9"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="21.37,7.44 21.37,7.51 21.46,7.51 21.46,8.19 20.93,7.44 20.76,7.44 20.76,7.51 20.84,7.51 20.84,8.29 20.76,8.29 20.76,8.36 21.01,8.36 21.01,8.29 20.92,8.29 20.92,7.57 21.49,8.36 21.54,8.36 21.54,7.51 21.63,7.51 21.63,7.44   "
        ></polygon>
        <path
          class="cofinanciado_st0"
          d="M22.09,7.53l0.18,0.51h-0.36L22.09,7.53z M21.96,7.44v0.06h0.07l-0.29,0.79h-0.07v0.07h0.24V8.29h-0.09 l0.07-0.18h0.41l0.07,0.18h-0.09v0.07h0.25V8.29h-0.07l-0.29-0.79h0.07V7.44H21.96z"
        ></path>
        <polygon
          class="cofinanciado_st0"
          points="22.61,7.44 22.61,7.51 22.69,7.51 22.69,8.29 22.61,8.29 22.61,8.36 23.21,8.36 23.21,8.16 23.14,8.16 23.14,8.29 22.78,8.29 22.78,7.51 22.86,7.51 22.86,7.44   "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M23.84,8.29c0.27,0,0.4-0.16,0.4-0.39c0-0.22-0.13-0.38-0.4-0.38H23.7v0.77H23.84z M23.53,7.44h0.31 c0.3,0,0.48,0.19,0.48,0.46s-0.18,0.46-0.48,0.46h-0.31V8.3h0.08V7.51h-0.08V7.44z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M25.28,7.9c0-0.22-0.16-0.39-0.38-0.39c-0.22,0-0.38,0.17-0.38,0.39c0,0.22,0.16,0.39,0.38,0.39 C25.12,8.29,25.28,8.13,25.28,7.9 M24.44,7.9c0-0.27,0.21-0.47,0.47-0.47c0.26,0,0.47,0.2,0.47,0.47c0,0.27-0.21,0.47-0.47,0.47 C24.65,8.37,24.44,8.17,24.44,7.9"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="26.33,7.44 26.33,7.51 26.42,7.51 26.42,8.19 25.89,7.44 25.71,7.44 25.71,7.51 25.8,7.51 25.8,8.29 25.71,8.29 25.71,8.36 25.97,8.36 25.97,8.29 25.88,8.29 25.88,7.57 26.45,8.36 26.5,8.36 26.5,7.51 26.59,7.51 26.59,7.44   "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M27.52,7.9c0-0.22-0.16-0.39-0.38-0.39c-0.22,0-0.38,0.17-0.38,0.39c0,0.22,0.16,0.39,0.38,0.39 C27.36,8.29,27.52,8.13,27.52,7.9 M26.67,7.9c0-0.27,0.21-0.47,0.47-0.47c0.26,0,0.47,0.2,0.47,0.47c0,0.27-0.21,0.47-0.47,0.47 C26.88,8.37,26.67,8.17,26.67,7.9"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M28.04,7.91c0.16,0,0.23-0.08,0.23-0.2c0-0.12-0.07-0.2-0.23-0.2h-0.17v0.4H28.04z M28.07,7.98h-0.2V8.3h0.1 v0.07H27.7V8.3h0.08V7.51H27.7V7.44h0.36c0.2,0,0.31,0.12,0.31,0.27c0,0.12-0.07,0.22-0.2,0.25l0.2,0.33h0.08v0.07H28.3 L28.07,7.98z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="28.48,7.44 28.48,7.64 28.55,7.64 28.55,7.52 28.78,7.52 28.78,8.29 28.69,8.29 28.69,8.36 28.96,8.36 28.96,8.29 28.87,8.29 28.87,7.52 29.1,7.52 29.1,7.64 29.17,7.64 29.17,7.44  "
        ></polygon>
        <polygon
          class="cofinanciado_st0"
          points="29.26,7.44 29.26,7.51 29.34,7.51 29.34,8.29 29.26,8.29 29.26,8.36 29.91,8.36 29.91,8.16 29.84,8.16 29.84,8.29 29.43,8.29 29.43,7.93 29.8,7.93 29.8,7.86 29.43,7.86 29.43,7.52 29.82,7.52 29.82,7.64 29.9,7.64 29.9,7.44   "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M45.6,1.73c-0.08-0.04-0.19-0.07-0.31-0.07c-0.33,0-0.64,0.21-1.13,0.73l-1.29-1.09 c0.5-0.62,1.01-1.02,1.73-1.19c0.72-0.13,1.43,0.22,1.3,0.91C45.87,1.23,45.76,1.48,45.6,1.73 M24.92,3.82h3.89V2.29h-3.89V3.82z M22.75,5.98h-1.94V2.29h1.94V5.98z M42.67,3.03c0-1.7-1.38-3.03-3.18-3.03h-0.02c-1.23,0-2.01,1.02-2.01,2.16v0.03 c0,1.14,0.78,2.17,2.01,2.19c-0.74-0.01-1.21-0.63-1.21-1.32V3.03c0-0.68,0.47-1.3,1.21-1.3c1.24,0,2.03,1.04,2.03,2.19v0.03 c0,1.11-0.74,2.12-1.94,2.16c1.76-0.05,3.11-1.38,3.11-3.05V3.03z M36.93,2.19c0,2.09,1.79,3.07,3.17,2.02 c0.38-0.23,0.6-0.67,0.6-1.14V3.05c0-0.03,0-0.07,0-0.1c0.18,0.28,0.27,0.62,0.27,0.99c0,1.48-1.61,2.27-3.2,1.71 c-0.91-0.53-1.49-1.48-1.49-2.59V3.05c0-0.87,0.36-1.65,0.96-2.2C37.04,1.26,36.93,1.72,36.93,2.19 M13.32,5.98h1.94V2.29h-1.94 V5.98z M24.92,4.45h4.98v1.54h-4.98V4.45z M24.92,1.66h4.98V0.13h-4.98V1.66z M19.07,0.13h5.4v1.54h-5.4V0.13z M17.66,3.99 c0.69-0.31,1.15-0.94,1.15-1.79V2.18c0-0.6-0.18-1.04-0.54-1.39c-0.37-0.37-0.95-0.62-1.82-0.66c-0.08-0.01-0.17-0.01-0.26-0.01 l-0.03,0c0.1,0,0.19,0,0.29,0.01c0.95,0.07,1.55,0.51,1.55,1.35v0.04c0,0.88-0.69,1.38-1.83,1.38h-0.49v1.4 C15.69,4.31,16.98,4.29,17.66,3.99 M17.96,4.43l1.06,1.55h-2.23l-0.77-1.16c0.65-0.03,1.33-0.12,1.85-0.35 C17.91,4.46,17.94,4.44,17.96,4.43 M0,1.32v4.66h1.94V4.18L0,1.32z M3.91,0.13h1.94v4.72L3.91,1.98V0.13z M1.94,0.13H0l3.91,5.85 h1.94L1.94,0.13z M12.78,3.05c0,1.67-1.35,3-3.11,3.05c1.19-0.04,1.94-1.05,1.94-2.16V3.92c0-1.15-0.79-2.18-2.03-2.19 c-0.75,0-1.21,0.62-1.21,1.3v0.02c0,0.69,0.47,1.31,1.21,1.32C8.34,4.36,7.56,3.33,7.56,2.19V2.16C7.56,1.02,8.34,0,9.57,0h0.02 c1.8,0,3.18,1.34,3.18,3.03V3.05z M16.12,1.68c0.45,0,0.74,0.22,0.74,0.61c0.46-0.14,0.61-0.44,0.61-0.77 c0-0.91-1.01-1.4-2.13-1.4l-2.04,0v1.56H16.12z M7.04,2.19c0,2.09,1.79,3.07,3.17,2.02c0.38-0.23,0.6-0.67,0.6-1.14V3.05 c0-0.03,0-0.07,0-0.1c0.18,0.28,0.27,0.62,0.27,0.99c0,1.48-1.61,2.27-3.2,1.71c-0.9-0.53-1.49-1.48-1.49-2.59V3.05 c0-0.87,0.36-1.65,0.96-2.2C7.14,1.26,7.04,1.72,7.04,2.19 M31.89,3.8h2.7l0.06-0.04c0.7-0.45,1.18-0.93,1.18-1.83V1.92 c0-1.11-0.96-1.91-2.29-1.91c1.65,0,0.99,1.97-0.15,2.8L31.89,3.8z M30.96,4.42h4.92v1.53h-4.92V4.42z M33.98,1.01 c0.13-0.69-0.58-1.04-1.3-0.91c-0.72,0.17-1.23,0.58-1.73,1.19l1.28,1.09c0.48-0.52,0.79-0.73,1.13-0.73 c0.12,0,0.23,0.03,0.31,0.07C33.83,1.48,33.94,1.23,33.98,1.01 M54.6,3.05c0,1.67-1.35,3-3.11,3.05c1.19-0.04,1.93-1.05,1.93-2.16 V3.92c0-1.15-0.79-2.18-2.03-2.19c-0.75,0-1.21,0.62-1.21,1.3v0.02c0,0.69,0.47,1.31,1.21,1.32c-1.23-0.01-2.01-1.05-2.01-2.19 V2.16c0-1.13,0.77-2.16,2.01-2.16h0.02c1.81,0,3.19,1.34,3.19,3.03V3.05z M49.17,0.85c-0.6,0.55-0.96,1.33-0.96,2.2v0.02 c0,1.1,0.58,2.06,1.49,2.59c1.58,0.56,3.19-0.23,3.19-1.71c0-0.37-0.1-0.71-0.27-0.99c0,0.03,0,0.07,0,0.1v0.02 c0,0.47-0.22,0.91-0.6,1.14c-1.38,1.05-3.17,0.08-3.17-2.02C48.86,1.72,48.96,1.26,49.17,0.85 M45.31,2.8 c1.14-0.82,1.8-2.8,0.15-2.8c1.33,0,2.29,0.8,2.29,1.91v0.02c0,0.89-0.48,1.38-1.18,1.83L46.52,3.8h-2.7L45.31,2.8z M42.89,5.95 h4.92V4.42h-4.92V5.95z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M68.27,7.19l1.78-1.51c0.18-0.15,0.33-0.28,0.45-0.4c0.12-0.12,0.22-0.23,0.3-0.34 c0.08-0.11,0.13-0.21,0.17-0.32c0.03-0.1,0.05-0.21,0.05-0.33c0-0.26-0.08-0.45-0.24-0.59c-0.16-0.14-0.36-0.21-0.59-0.21 c-0.24,0-0.44,0.06-0.62,0.19c-0.18,0.13-0.37,0.32-0.57,0.58l-0.64-0.5c0.12-0.17,0.25-0.33,0.38-0.46 c0.13-0.14,0.27-0.25,0.42-0.34c0.15-0.09,0.32-0.16,0.5-0.21c0.18-0.05,0.39-0.07,0.62-0.07c0.25,0,0.48,0.04,0.69,0.11 c0.21,0.07,0.39,0.18,0.54,0.31c0.15,0.14,0.27,0.3,0.35,0.49c0.08,0.19,0.12,0.4,0.12,0.63v0.02c0,0.2-0.03,0.39-0.08,0.55 c-0.05,0.17-0.14,0.32-0.25,0.48s-0.25,0.31-0.42,0.46c-0.17,0.16-0.37,0.33-0.59,0.51l-1.06,0.89H72v0.8h-3.74V7.19z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M75.14,7.07c0.26,0,0.49-0.05,0.7-0.14c0.21-0.1,0.4-0.23,0.55-0.39c0.15-0.17,0.27-0.36,0.36-0.58 c0.09-0.22,0.13-0.46,0.13-0.71V5.23c0-0.25-0.04-0.49-0.13-0.71c-0.09-0.22-0.21-0.42-0.36-0.58c-0.15-0.17-0.34-0.3-0.55-0.4 c-0.22-0.1-0.45-0.15-0.71-0.15c-0.26,0-0.49,0.05-0.7,0.14c-0.21,0.1-0.4,0.23-0.55,0.39c-0.15,0.17-0.27,0.36-0.36,0.58 c-0.09,0.22-0.13,0.46-0.13,0.71v0.01c0,0.25,0.04,0.49,0.13,0.71c0.09,0.23,0.21,0.42,0.36,0.59c0.15,0.16,0.34,0.3,0.56,0.4 C74.65,7.02,74.88,7.07,75.14,7.07 M75.12,7.9c-0.4,0-0.76-0.07-1.09-0.21c-0.33-0.14-0.61-0.33-0.85-0.57 c-0.24-0.24-0.42-0.52-0.55-0.85c-0.13-0.32-0.2-0.67-0.2-1.03V5.23c0-0.36,0.07-0.71,0.2-1.03c0.13-0.32,0.32-0.61,0.56-0.85 c0.24-0.24,0.53-0.44,0.86-0.58c0.33-0.14,0.69-0.21,1.09-0.21c0.4,0,0.76,0.07,1.09,0.21c0.33,0.14,0.61,0.33,0.85,0.57 c0.24,0.24,0.42,0.52,0.55,0.85c0.13,0.32,0.2,0.67,0.2,1.03v0.01c0,0.36-0.07,0.71-0.2,1.03c-0.13,0.32-0.32,0.61-0.56,0.85 c-0.24,0.24-0.53,0.44-0.86,0.58S75.52,7.9,75.12,7.9"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M78.19,7.19l1.78-1.51c0.18-0.15,0.33-0.28,0.45-0.4c0.12-0.12,0.22-0.23,0.3-0.34 c0.08-0.11,0.13-0.21,0.17-0.32s0.05-0.21,0.05-0.33c0-0.26-0.08-0.45-0.24-0.59c-0.16-0.14-0.36-0.21-0.6-0.21 c-0.24,0-0.44,0.06-0.62,0.19C79.3,3.8,79.11,3.99,78.9,4.26l-0.64-0.5c0.12-0.17,0.25-0.33,0.38-0.46 c0.13-0.14,0.27-0.25,0.42-0.34c0.15-0.09,0.32-0.16,0.49-0.21c0.18-0.05,0.39-0.07,0.62-0.07c0.25,0,0.48,0.04,0.69,0.11 c0.21,0.07,0.39,0.18,0.54,0.31c0.15,0.14,0.27,0.3,0.35,0.49c0.08,0.19,0.13,0.4,0.13,0.63v0.02c0,0.2-0.03,0.39-0.08,0.55 c-0.05,0.17-0.14,0.32-0.25,0.48c-0.11,0.15-0.25,0.31-0.42,0.46c-0.17,0.16-0.37,0.33-0.6,0.51l-1.07,0.89h2.46v0.8h-3.74V7.19z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M85.06,7.07c0.26,0,0.49-0.05,0.7-0.14c0.21-0.1,0.4-0.23,0.55-0.39c0.15-0.17,0.27-0.36,0.36-0.58 c0.09-0.22,0.13-0.46,0.13-0.71V5.23c0-0.25-0.04-0.49-0.13-0.71c-0.09-0.22-0.2-0.42-0.36-0.58c-0.15-0.17-0.34-0.3-0.56-0.4 c-0.22-0.1-0.45-0.15-0.71-0.15c-0.26,0-0.49,0.05-0.7,0.14c-0.21,0.1-0.4,0.23-0.55,0.39c-0.15,0.17-0.27,0.36-0.36,0.58 c-0.09,0.22-0.13,0.46-0.13,0.71v0.01c0,0.25,0.04,0.49,0.13,0.71c0.09,0.23,0.21,0.42,0.36,0.59c0.16,0.16,0.34,0.3,0.56,0.4 C84.57,7.02,84.8,7.07,85.06,7.07 M85.04,7.9c-0.4,0-0.76-0.07-1.09-0.21c-0.33-0.14-0.61-0.33-0.85-0.57 c-0.24-0.24-0.42-0.52-0.55-0.85c-0.13-0.32-0.2-0.67-0.2-1.03V5.23c0-0.36,0.07-0.71,0.2-1.03c0.13-0.32,0.32-0.61,0.56-0.85 c0.24-0.24,0.53-0.44,0.86-0.58c0.33-0.14,0.7-0.21,1.09-0.21c0.4,0,0.76,0.07,1.09,0.21C86.48,2.91,86.77,3.1,87,3.34 c0.24,0.24,0.42,0.52,0.55,0.85c0.13,0.32,0.2,0.67,0.2,1.03v0.01c0,0.36-0.07,0.71-0.2,1.03C87.42,6.58,87.24,6.87,87,7.11 c-0.24,0.24-0.53,0.44-0.86,0.58C85.81,7.83,85.44,7.9,85.04,7.9"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M77.91,1.48V1.3c0.06-0.01,0.12-0.02,0.19-0.02V0.22c-0.06,0-0.13-0.01-0.19-0.03V0.02h0.65V0.2 c-0.06,0.01-0.12,0.02-0.19,0.03v1.02h0.28c0-0.05,0.02-0.11,0.03-0.18h0.21v0.41H77.91z M77.17,0.53 c-0.03-0.08-0.05-0.15-0.07-0.23h0c-0.02,0.07-0.04,0.16-0.07,0.24L76.9,0.89h0.39L77.17,0.53z M77.27,1.48V1.3 c0.05-0.01,0.1-0.02,0.15-0.02l-0.06-0.17h-0.53l-0.06,0.17c0.05,0,0.11,0.01,0.15,0.02v0.17h-0.55V1.3 c0.04-0.01,0.08-0.02,0.11-0.02l0.44-1.26h0.34l0.45,1.26c0.04,0,0.08,0.01,0.11,0.02v0.17H77.27z M76.26,0.91v0.49 c-0.14,0.06-0.32,0.09-0.5,0.09c-0.46,0-0.73-0.27-0.73-0.71c0-0.46,0.31-0.78,0.8-0.78c0.14,0,0.27,0.02,0.41,0.05v0.39h-0.22 C76.01,0.38,76.01,0.33,76,0.27c-0.06-0.02-0.12-0.02-0.18-0.02c-0.28,0-0.49,0.18-0.49,0.51c0,0.31,0.17,0.49,0.46,0.49 c0.07,0,0.13-0.01,0.18-0.03v-0.3c-0.06-0.01-0.13-0.02-0.18-0.03V0.72h0.59v0.18C76.35,0.9,76.3,0.91,76.26,0.91 M74.82,0.22 v0.69c0,0.38-0.21,0.58-0.6,0.58c-0.46,0-0.56-0.25-0.56-0.53V0.22c-0.05,0-0.1-0.01-0.14-0.02V0.02h0.57V0.2 c-0.05,0.01-0.1,0.02-0.15,0.02v0.73c0,0.18,0.06,0.31,0.3,0.31c0.21,0,0.31-0.09,0.31-0.34V0.22c-0.05,0-0.11-0.01-0.15-0.02 V0.02h0.56V0.2C74.91,0.21,74.87,0.22,74.82,0.22 M73.2,0.43c-0.01-0.07-0.02-0.12-0.03-0.18h-0.22v1.02 c0.07,0,0.13,0.02,0.19,0.02v0.17h-0.65V1.3c0.06-0.01,0.12-0.02,0.19-0.02V0.25h-0.22c0,0.06-0.01,0.11-0.03,0.18h-0.21V0.02 h1.19v0.41H73.2z M71.56,0.24c-0.04,0-0.08,0-0.11,0.01v0.42c0.02,0,0.06,0,0.1,0c0.17,0,0.27-0.09,0.27-0.22 C71.82,0.31,71.74,0.24,71.56,0.24 M71.84,1.48l-0.35-0.6h-0.04v0.4c0.04,0,0.09,0.01,0.13,0.02v0.18h-0.6V1.3 c0.06-0.01,0.12-0.02,0.19-0.02V0.22c-0.07,0-0.13-0.01-0.19-0.03V0.02h0.17c0.06,0,0.26-0.01,0.43-0.01 c0.32,0,0.53,0.11,0.53,0.41c0,0.2-0.14,0.35-0.34,0.39c0.03,0.03,0.05,0.07,0.07,0.11l0.22,0.35c0.04,0.01,0.09,0.02,0.14,0.02 v0.18H71.84z M70.2,0.25c-0.2,0-0.39,0.16-0.39,0.48c0,0.31,0.12,0.51,0.38,0.51c0.19,0,0.39-0.15,0.39-0.49 C70.59,0.43,70.45,0.25,70.2,0.25 M70.18,1.5c-0.44,0-0.66-0.28-0.66-0.73c0-0.48,0.32-0.77,0.71-0.77c0.39,0,0.66,0.23,0.66,0.73 C70.89,1.21,70.57,1.5,70.18,1.5 M68.83,0.24c-0.03,0-0.06,0-0.1,0v0.48c0.03,0,0.06,0.01,0.08,0.01c0.17,0,0.29-0.1,0.29-0.25 C69.1,0.34,69.02,0.24,68.83,0.24 M68.82,0.97c-0.03,0-0.06,0-0.09,0v0.31c0.07,0,0.13,0.02,0.19,0.02v0.17h-0.65V1.3 c0.06-0.01,0.12-0.02,0.19-0.02V0.22c-0.07,0-0.13-0.01-0.19-0.03V0.02h0.17c0.07,0,0.26-0.01,0.41-0.01 c0.35,0,0.55,0.17,0.55,0.45C69.39,0.75,69.18,0.97,68.82,0.97"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M63.91,0.06c-1.28,0.51-2.08,1.84-2.08,3.9v3.12c0,0,0.26-2.01,2.08-2.58V0.06z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M64.53,4.8c-0.74,0.15-1.83,0.74-2.15,1.58c1.6-1.94,4.85-0.06,5-3.71c0.05-1.15,0.05-2.58,0.05-2.58 c-1.7,0.1-2.9,0.55-2.9,0.55V4.8z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M64.33,5.86c0,0-1.73,0.14-1.88,1.13c-0.12,0.77,1.88,0.79,1.88,0.79V5.86z"
          ></path>
        </g>
        <path
          class="cofinanciado_st0"
          d="M103.72,4.67l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.2h0.34l0.1-0.32l0.1,0.32h0.33l-0.27,0.2L103.72,4.67z M103.36,6.17l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.2h0.34l0.1-0.32l0.1,0.32h0.33l-0.27,0.2L103.36,6.17z M102.99,2.82l0.1-0.32 l0.1,0.32h0.33l-0.27,0.2l0.1,0.32l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.2H102.99z M102.26,1.98l0.1,0.32l-0.27-0.2l-0.27,0.2 l0.1-0.32l-0.27-0.2h0.33l0.1-0.32l0.1,0.32h0.34L102.26,1.98z M102.28,7.18l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.19h0.33 l0.1-0.32l0.1,0.32h0.34l-0.27,0.19L102.28,7.18z M100.94,7.48l-0.27-0.19l-0.27,0.19l0.1-0.32l-0.27-0.2h0.34l0.1-0.32l0.1,0.32 h0.33l-0.27,0.2L100.94,7.48z M99.56,7.18l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.19h0.34l0.1-0.32l0.1,0.32h0.34l-0.27,0.19 L99.56,7.18z M99.11,1.79l0.1-0.32l0.1,0.32h0.33l-0.27,0.2l0.1,0.32l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.2H99.11z M98.38,3.02 l0.1,0.32l-0.27-0.2l-0.27,0.2l0.1-0.32l-0.27-0.2h0.33l0.1-0.32l0.1,0.32h0.33L98.38,3.02z M98.48,6.17l-0.27-0.2l-0.27,0.2 l0.1-0.32l-0.27-0.2h0.33l0.1-0.32l0.1,0.32h0.33l-0.27,0.2L98.48,6.17z M97.41,4.15h0.34l0.1-0.32l0.1,0.32h0.34l-0.27,0.2 l0.1,0.32l-0.27-0.2l-0.27,0.2l0.1-0.32L97.41,4.15z M100.56,1.38l0.1-0.32l0.1,0.32h0.33l-0.27,0.2l0.1,0.32l-0.27-0.2l-0.27,0.2 l0.1-0.32l-0.27-0.2H100.56z M94.36,8.36h12.58V0.13H94.36V8.36z"
        ></path>
        <g>
          <path
            class="cofinanciado_st0"
            d="M109.55,0.5h0.18v0.77c0,0.13-0.02,0.24-0.05,0.32c-0.03,0.08-0.08,0.14-0.16,0.19 c-0.08,0.05-0.18,0.07-0.31,0.07c-0.12,0-0.23-0.02-0.3-0.06s-0.14-0.1-0.17-0.18c-0.03-0.08-0.05-0.19-0.05-0.33V0.5h0.18v0.77 c0,0.11,0.01,0.2,0.03,0.25c0.02,0.05,0.06,0.1,0.11,0.13c0.05,0.03,0.12,0.04,0.19,0.04c0.13,0,0.22-0.03,0.28-0.09 c0.05-0.06,0.08-0.17,0.08-0.34V0.5z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="110.01,1.82 110.01,0.5 110.19,0.5 110.89,1.54 110.89,0.5 111.06,0.5 111.06,1.82 110.88,1.82 110.18,0.78 110.18,1.82  "
        ></polygon>
        <rect
          x="111.38"
          y="0.5"
          class="cofinanciado_st0"
          width="0.17"
          height="1.33"
        ></rect>
        <g>
          <path
            class="cofinanciado_st0"
            d="M112.1,1.28h0.45l-0.14-0.37c-0.04-0.11-0.07-0.2-0.09-0.27c-0.02,0.08-0.04,0.17-0.07,0.25L112.1,1.28z M112.04,0.41c0-0.06,0.02-0.11,0.05-0.15c0.03-0.04,0.08-0.06,0.13-0.06c0.04,0,0.09,0.02,0.15,0.05 c0.04,0.02,0.06,0.03,0.09,0.03c0.02,0,0.03-0.01,0.04-0.02c0.01-0.01,0.02-0.03,0.02-0.06h0.12c0,0.07-0.02,0.12-0.05,0.16 c-0.03,0.03-0.07,0.05-0.12,0.05c-0.04,0-0.09-0.02-0.15-0.05c-0.04-0.02-0.07-0.03-0.09-0.03c-0.02,0-0.04,0.01-0.05,0.02 c-0.01,0.01-0.02,0.03-0.02,0.06H112.04z M111.72,1.82l0.51-1.32h0.19l0.54,1.32h-0.2l-0.15-0.4h-0.55l-0.15,0.4H111.72z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M113.23,1.18c0,0.16,0.04,0.28,0.13,0.38c0.08,0.09,0.19,0.14,0.32,0.14c0.13,0,0.24-0.05,0.32-0.14 c0.09-0.09,0.13-0.23,0.13-0.4c0-0.11-0.02-0.2-0.06-0.28c-0.04-0.08-0.09-0.14-0.16-0.19c-0.07-0.04-0.15-0.07-0.24-0.07 c-0.12,0-0.23,0.04-0.32,0.13C113.27,0.84,113.23,0.98,113.23,1.18 M113.05,1.17c0-0.22,0.06-0.39,0.18-0.52 c0.12-0.12,0.27-0.19,0.46-0.19c0.12,0,0.23,0.03,0.33,0.09c0.1,0.06,0.17,0.14,0.22,0.24c0.05,0.1,0.08,0.22,0.08,0.36 c0,0.13-0.03,0.26-0.08,0.36c-0.05,0.11-0.13,0.19-0.23,0.24c-0.1,0.06-0.21,0.08-0.32,0.08c-0.12,0-0.24-0.03-0.33-0.09 c-0.1-0.06-0.17-0.14-0.22-0.25C113.07,1.4,113.05,1.29,113.05,1.17"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="115.06,0.5 115.06,1.82 116.05,1.82 116.05,1.66 115.23,1.66 115.23,1.21 115.97,1.21 115.97,1.06 115.23,1.06 115.23,0.65 116.02,0.65 116.02,0.5  "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M117.16,0.5h0.17v0.77c0,0.13-0.02,0.24-0.05,0.32c-0.03,0.08-0.08,0.14-0.16,0.19 c-0.08,0.05-0.18,0.07-0.31,0.07c-0.12,0-0.23-0.02-0.3-0.06s-0.14-0.1-0.17-0.18c-0.03-0.08-0.05-0.19-0.05-0.33V0.5h0.18v0.77 c0,0.11,0.01,0.2,0.03,0.25c0.02,0.05,0.06,0.1,0.11,0.13c0.05,0.03,0.12,0.04,0.19,0.04c0.13,0,0.22-0.03,0.28-0.09 c0.05-0.06,0.08-0.17,0.08-0.34V0.5z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M117.8,1.08h0.38c0.08,0,0.14-0.01,0.19-0.02c0.04-0.02,0.08-0.04,0.1-0.08c0.02-0.04,0.04-0.08,0.04-0.12 c0-0.06-0.02-0.11-0.07-0.15c-0.05-0.04-0.12-0.06-0.22-0.06h-0.42V1.08z M117.63,1.82V0.5h0.59c0.12,0,0.21,0.01,0.27,0.04 c0.06,0.02,0.11,0.07,0.15,0.13c0.04,0.06,0.05,0.13,0.05,0.2c0,0.09-0.03,0.17-0.09,0.24c-0.06,0.07-0.15,0.11-0.28,0.12 c0.05,0.02,0.08,0.04,0.11,0.07c0.05,0.05,0.1,0.11,0.14,0.18l0.23,0.36h-0.22l-0.17-0.28c-0.05-0.08-0.09-0.14-0.13-0.18 c-0.03-0.04-0.06-0.07-0.09-0.09c-0.03-0.02-0.05-0.03-0.08-0.03c-0.02-0.01-0.05-0.01-0.1-0.01h-0.2v0.59H117.63z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M119.09,1.18c0,0.16,0.04,0.28,0.13,0.38c0.08,0.09,0.19,0.14,0.32,0.14c0.13,0,0.24-0.05,0.32-0.14 c0.09-0.09,0.13-0.23,0.13-0.4c0-0.11-0.02-0.2-0.06-0.28c-0.04-0.08-0.09-0.14-0.16-0.19c-0.07-0.04-0.15-0.07-0.24-0.07 c-0.12,0-0.23,0.04-0.32,0.13C119.13,0.84,119.09,0.98,119.09,1.18 M118.91,1.17c0-0.22,0.06-0.39,0.18-0.52 c0.12-0.12,0.27-0.19,0.46-0.19c0.12,0,0.23,0.03,0.33,0.09c0.1,0.06,0.17,0.14,0.22,0.24c0.05,0.1,0.08,0.22,0.08,0.36 c0,0.13-0.03,0.26-0.08,0.36c-0.05,0.11-0.13,0.19-0.23,0.24c-0.1,0.06-0.21,0.08-0.32,0.08c-0.12,0-0.24-0.03-0.33-0.09 c-0.1-0.06-0.17-0.14-0.22-0.25C118.93,1.4,118.91,1.29,118.91,1.17"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M120.58,1.13h0.34c0.11,0,0.19-0.02,0.24-0.06c0.05-0.04,0.07-0.1,0.07-0.18c0-0.06-0.01-0.1-0.04-0.14 c-0.03-0.04-0.07-0.07-0.11-0.08c-0.03-0.01-0.08-0.01-0.16-0.01h-0.34V1.13z M120.4,1.82V0.5h0.5c0.09,0,0.15,0,0.2,0.01 c0.07,0.01,0.12,0.03,0.16,0.06c0.04,0.03,0.08,0.07,0.11,0.13c0.03,0.06,0.04,0.12,0.04,0.18c0,0.11-0.04,0.21-0.11,0.29 c-0.07,0.08-0.2,0.12-0.39,0.12h-0.34v0.54H120.4z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="121.64,0.5 121.64,1.82 122.63,1.82 122.63,1.66 121.81,1.66 121.81,1.21 122.55,1.21 122.55,1.06 121.81,1.06 121.81,0.65 122.6,0.65 122.6,0.5   "
        ></polygon>
        <rect
          x="122.9"
          y="0.5"
          class="cofinanciado_st0"
          width="0.18"
          height="1.33"
        ></rect>
        <g>
          <path
            class="cofinanciado_st0"
            d="M123.62,1.28h0.45l-0.14-0.37c-0.04-0.11-0.07-0.2-0.09-0.27c-0.02,0.08-0.04,0.17-0.07,0.25L123.62,1.28z M123.24,1.82l0.51-1.32h0.19l0.54,1.32h-0.2l-0.16-0.4h-0.55l-0.15,0.4H123.24z"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="108.66,5.24 108.66,6.34 108.81,6.34 108.81,5.84 109.33,5.84 109.33,5.71 108.81,5.71 108.81,5.37 109.41,5.37 109.41,5.24   "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M110.1,6.34V6.23c-0.06,0.09-0.15,0.14-0.25,0.14c-0.05,0-0.09-0.01-0.13-0.03 c-0.04-0.02-0.07-0.04-0.09-0.07c-0.02-0.03-0.03-0.06-0.04-0.1c-0.01-0.03-0.01-0.07-0.01-0.13v-0.5h0.14v0.44 c0,0.07,0,0.12,0.01,0.14c0.01,0.03,0.03,0.06,0.05,0.08c0.03,0.02,0.06,0.03,0.1,0.03c0.04,0,0.08-0.01,0.11-0.03 c0.04-0.02,0.06-0.05,0.08-0.08c0.01-0.04,0.02-0.09,0.02-0.16V5.54h0.14v0.8H110.1z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M110.44,6.34v-0.8h0.12v0.11c0.06-0.09,0.14-0.13,0.26-0.13c0.05,0,0.09,0.01,0.13,0.03 c0.04,0.02,0.07,0.04,0.09,0.07s0.03,0.06,0.04,0.1c0,0.03,0.01,0.07,0.01,0.13v0.49h-0.14V5.86c0-0.06-0.01-0.1-0.02-0.12 c-0.01-0.03-0.03-0.05-0.06-0.07c-0.03-0.02-0.06-0.02-0.1-0.02c-0.06,0-0.11,0.02-0.15,0.05c-0.04,0.04-0.06,0.11-0.06,0.21v0.44 H110.44z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M111.39,5.95c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.09,0.07,0.15,0.07c0.06,0,0.11-0.02,0.15-0.07 c0.04-0.05,0.06-0.12,0.06-0.22c0-0.11-0.02-0.19-0.06-0.24c-0.04-0.05-0.09-0.08-0.16-0.08c-0.06,0-0.11,0.02-0.15,0.07 C111.41,5.76,111.39,5.84,111.39,5.95 M111.81,6.34v-0.1c-0.05,0.08-0.12,0.12-0.22,0.12c-0.06,0-0.12-0.02-0.17-0.05 c-0.05-0.03-0.09-0.08-0.12-0.15c-0.03-0.06-0.04-0.14-0.04-0.22c0-0.08,0.01-0.15,0.04-0.22c0.03-0.07,0.07-0.11,0.12-0.15 c0.05-0.03,0.11-0.05,0.18-0.05c0.05,0,0.09,0.01,0.13,0.03c0.04,0.02,0.07,0.05,0.09,0.08v-0.4h0.14v1.1H111.81z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M112.24,5.94c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.1,0.08,0.17,0.08c0.07,0,0.12-0.03,0.17-0.08 c0.04-0.05,0.07-0.13,0.07-0.24c0-0.1-0.02-0.17-0.07-0.22c-0.04-0.05-0.1-0.08-0.17-0.08c-0.07,0-0.12,0.03-0.17,0.08 C112.26,5.77,112.24,5.84,112.24,5.94 M112.1,5.94c0-0.15,0.04-0.26,0.12-0.33c0.07-0.06,0.15-0.09,0.25-0.09 c0.11,0,0.2,0.04,0.27,0.11s0.11,0.17,0.11,0.3c0,0.1-0.02,0.18-0.05,0.24c-0.03,0.06-0.08,0.1-0.13,0.14 c-0.06,0.03-0.12,0.05-0.19,0.05c-0.11,0-0.2-0.04-0.27-0.11C112.14,6.18,112.1,6.08,112.1,5.94"
          ></path>
        </g>
        <polygon
          class="cofinanciado_st0"
          points="113.46,5.24 113.46,6.34 114.28,6.34 114.28,6.21 113.61,6.21 113.61,5.84 114.22,5.84 114.22,5.71 113.61,5.71 113.61,5.37 114.26,5.37 114.26,5.24  "
        ></polygon>
        <g>
          <path
            class="cofinanciado_st0"
            d="M114.99,6.34V6.23c-0.06,0.09-0.15,0.14-0.25,0.14c-0.05,0-0.09-0.01-0.13-0.03 c-0.04-0.02-0.07-0.04-0.09-0.07c-0.02-0.03-0.03-0.06-0.04-0.1c-0.01-0.03-0.01-0.07-0.01-0.13v-0.5h0.14v0.44 c0,0.07,0,0.12,0.01,0.14c0.01,0.03,0.03,0.06,0.05,0.08c0.03,0.02,0.06,0.03,0.1,0.03c0.04,0,0.08-0.01,0.11-0.03 c0.04-0.02,0.06-0.05,0.08-0.08c0.01-0.04,0.02-0.09,0.02-0.16V5.54h0.14v0.8H114.99z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M115.32,6.34v-0.8h0.12v0.12c0.03-0.06,0.06-0.09,0.09-0.11c0.03-0.02,0.06-0.03,0.09-0.03 c0.05,0,0.09,0.01,0.14,0.04l-0.05,0.12c-0.03-0.02-0.07-0.03-0.1-0.03c-0.03,0-0.06,0.01-0.08,0.03 c-0.02,0.02-0.04,0.04-0.05,0.07c-0.02,0.05-0.02,0.1-0.02,0.16v0.42H115.32z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M115.93,5.94c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.1,0.08,0.17,0.08c0.07,0,0.12-0.03,0.17-0.08 c0.04-0.05,0.07-0.13,0.07-0.24c0-0.1-0.02-0.17-0.07-0.22c-0.04-0.05-0.1-0.08-0.17-0.08c-0.07,0-0.12,0.03-0.17,0.08 C115.95,5.77,115.93,5.84,115.93,5.94 M115.79,5.94c0-0.15,0.04-0.26,0.12-0.33c0.07-0.06,0.15-0.09,0.25-0.09 c0.11,0,0.2,0.04,0.27,0.11c0.07,0.07,0.11,0.17,0.11,0.3c0,0.1-0.02,0.18-0.05,0.24c-0.03,0.06-0.08,0.1-0.13,0.14 c-0.06,0.03-0.12,0.05-0.19,0.05c-0.11,0-0.2-0.04-0.27-0.11C115.82,6.18,115.79,6.08,115.79,5.94"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M116.82,5.95c0,0.1,0.02,0.18,0.06,0.23c0.04,0.05,0.09,0.07,0.15,0.07s0.11-0.02,0.15-0.08 c0.04-0.05,0.06-0.13,0.06-0.24c0-0.1-0.02-0.18-0.06-0.23c-0.04-0.05-0.09-0.08-0.15-0.08s-0.11,0.03-0.15,0.08 C116.84,5.77,116.82,5.85,116.82,5.95 M116.7,6.65V5.54h0.12v0.1c0.03-0.04,0.06-0.07,0.1-0.09c0.04-0.02,0.08-0.03,0.13-0.03 c0.07,0,0.13,0.02,0.18,0.05s0.09,0.08,0.12,0.15c0.03,0.06,0.04,0.13,0.04,0.21c0,0.08-0.01,0.16-0.04,0.22 c-0.03,0.07-0.07,0.12-0.13,0.15c-0.06,0.03-0.11,0.05-0.18,0.05c-0.05,0-0.09-0.01-0.12-0.03c-0.04-0.02-0.07-0.04-0.09-0.07 v0.39H116.7z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M117.66,5.87h0.45c-0.01-0.07-0.02-0.12-0.05-0.15c-0.04-0.05-0.1-0.08-0.17-0.08 c-0.06,0-0.11,0.02-0.16,0.06C117.69,5.74,117.66,5.8,117.66,5.87 M118.1,6.09l0.14,0.02c-0.02,0.08-0.06,0.15-0.12,0.19 c-0.06,0.05-0.14,0.07-0.23,0.07c-0.12,0-0.21-0.04-0.28-0.11c-0.07-0.07-0.1-0.17-0.1-0.3c0-0.14,0.03-0.24,0.1-0.31 c0.07-0.07,0.16-0.11,0.27-0.11c0.11,0,0.19,0.04,0.26,0.11s0.1,0.17,0.1,0.31c0,0.01,0,0.02,0,0.04h-0.6 c0.01,0.09,0.03,0.16,0.07,0.2c0.05,0.05,0.1,0.07,0.17,0.07c0.05,0,0.09-0.01,0.13-0.04C118.05,6.19,118.08,6.14,118.1,6.09"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M118.94,6.34V6.23c-0.06,0.09-0.15,0.14-0.25,0.14c-0.05,0-0.09-0.01-0.13-0.03 c-0.04-0.02-0.07-0.04-0.09-0.07c-0.02-0.03-0.03-0.06-0.04-0.1c-0.01-0.03-0.01-0.07-0.01-0.13v-0.5h0.14v0.44 c0,0.07,0,0.12,0.01,0.14c0.01,0.03,0.03,0.06,0.05,0.08c0.03,0.02,0.06,0.03,0.1,0.03c0.04,0,0.08-0.01,0.11-0.03 c0.04-0.02,0.06-0.05,0.08-0.08c0.02-0.04,0.02-0.09,0.02-0.16V5.54h0.14v0.8H118.94z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M108.73,7.59c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.09,0.08,0.15,0.08c0.06,0,0.11-0.02,0.15-0.07 c0.04-0.05,0.06-0.12,0.06-0.22c0-0.11-0.02-0.19-0.06-0.24c-0.04-0.05-0.09-0.08-0.16-0.08c-0.06,0-0.11,0.02-0.15,0.08 C108.75,7.41,108.73,7.48,108.73,7.59 M109.16,7.99v-0.1c-0.05,0.08-0.12,0.12-0.22,0.12c-0.06,0-0.12-0.02-0.17-0.05 c-0.05-0.04-0.1-0.08-0.12-0.15c-0.03-0.06-0.04-0.14-0.04-0.22c0-0.08,0.01-0.15,0.04-0.22c0.03-0.07,0.07-0.11,0.12-0.15 c0.05-0.03,0.11-0.05,0.18-0.05c0.05,0,0.09,0.01,0.13,0.03c0.04,0.02,0.07,0.05,0.09,0.08v-0.4h0.14v1.1H109.16z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M109.6,7.51h0.45c-0.01-0.07-0.02-0.12-0.05-0.15c-0.04-0.05-0.1-0.08-0.17-0.08c-0.06,0-0.11,0.02-0.16,0.06 C109.63,7.39,109.6,7.44,109.6,7.51 M110.04,7.73l0.14,0.02c-0.02,0.08-0.06,0.15-0.12,0.19s-0.14,0.07-0.23,0.07 c-0.12,0-0.21-0.03-0.28-0.11c-0.07-0.07-0.1-0.17-0.1-0.3c0-0.13,0.03-0.24,0.1-0.31c0.07-0.07,0.16-0.11,0.27-0.11 c0.11,0,0.19,0.04,0.26,0.11s0.1,0.17,0.1,0.31c0,0.01,0,0.02,0,0.04h-0.6c0,0.09,0.03,0.16,0.07,0.2 c0.05,0.05,0.1,0.07,0.17,0.07c0.05,0,0.09-0.01,0.13-0.04C109.99,7.83,110.02,7.79,110.04,7.73"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M110.95,7.86h0.24c0.07,0,0.13-0.01,0.17-0.02c0.04-0.01,0.08-0.03,0.1-0.06c0.03-0.03,0.06-0.08,0.08-0.14 c0.02-0.06,0.03-0.13,0.03-0.21c0-0.12-0.02-0.2-0.06-0.27c-0.04-0.06-0.08-0.1-0.14-0.12c-0.04-0.02-0.1-0.02-0.19-0.02h-0.23 V7.86z M110.8,7.99v-1.1h0.38c0.09,0,0.15,0.01,0.2,0.02c0.06,0.01,0.12,0.04,0.16,0.08c0.06,0.05,0.1,0.11,0.13,0.19 c0.03,0.08,0.04,0.17,0.04,0.26c0,0.08-0.01,0.16-0.03,0.22c-0.02,0.07-0.04,0.12-0.08,0.16c-0.03,0.04-0.06,0.08-0.1,0.1 c-0.04,0.02-0.08,0.04-0.13,0.06c-0.05,0.01-0.11,0.02-0.18,0.02H110.8z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M112,7.51h0.45c-0.01-0.07-0.02-0.12-0.05-0.15c-0.04-0.05-0.1-0.08-0.17-0.08c-0.06,0-0.11,0.02-0.16,0.06 C112.03,7.39,112,7.44,112,7.51 M112.44,7.73l0.14,0.02c-0.02,0.08-0.06,0.15-0.12,0.19c-0.06,0.05-0.14,0.07-0.23,0.07 c-0.12,0-0.21-0.03-0.28-0.11c-0.07-0.07-0.1-0.17-0.1-0.3c0-0.13,0.03-0.24,0.1-0.31c0.07-0.07,0.16-0.11,0.27-0.11 c0.11,0,0.19,0.04,0.26,0.11s0.1,0.17,0.1,0.31c0,0.01,0,0.02,0,0.04h-0.6c0.01,0.09,0.03,0.16,0.07,0.2 c0.05,0.05,0.1,0.07,0.17,0.07c0.05,0,0.09-0.01,0.13-0.04C112.39,7.83,112.42,7.79,112.44,7.73"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M112.7,7.75l0.13-0.02c0.01,0.05,0.03,0.1,0.06,0.12c0.03,0.03,0.08,0.04,0.14,0.04 c0.06,0,0.11-0.01,0.14-0.04c0.03-0.03,0.04-0.06,0.04-0.09c0-0.03-0.01-0.06-0.04-0.07c-0.02-0.01-0.06-0.03-0.14-0.05 c-0.1-0.03-0.17-0.05-0.21-0.07c-0.04-0.02-0.07-0.04-0.09-0.08c-0.02-0.03-0.03-0.07-0.03-0.11c0-0.03,0.01-0.07,0.02-0.1 c0.02-0.03,0.04-0.06,0.07-0.08c0.02-0.02,0.05-0.03,0.09-0.04c0.04-0.01,0.08-0.02,0.12-0.02c0.06,0,0.12,0.01,0.17,0.03 c0.05,0.02,0.08,0.04,0.1,0.07c0.02,0.03,0.04,0.07,0.05,0.12l-0.13,0.02c-0.01-0.04-0.02-0.07-0.05-0.1 c-0.03-0.02-0.07-0.03-0.12-0.03c-0.06,0-0.11,0.01-0.13,0.03c-0.03,0.02-0.04,0.05-0.04,0.07c0,0.02,0.01,0.03,0.02,0.05 c0.01,0.02,0.03,0.03,0.05,0.04c0.01,0,0.05,0.02,0.12,0.03c0.1,0.02,0.16,0.05,0.2,0.06c0.04,0.02,0.07,0.04,0.09,0.07 c0.02,0.03,0.03,0.07,0.03,0.12c0,0.05-0.01,0.09-0.04,0.13c-0.03,0.04-0.07,0.07-0.11,0.09c-0.05,0.02-0.11,0.03-0.17,0.03 c-0.1,0-0.18-0.02-0.24-0.07C112.75,7.9,112.71,7.84,112.7,7.75"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M113.63,7.51h0.45c-0.01-0.07-0.02-0.12-0.05-0.15c-0.04-0.05-0.1-0.08-0.17-0.08 c-0.06,0-0.11,0.02-0.16,0.06C113.65,7.39,113.63,7.44,113.63,7.51 M114.07,7.73l0.14,0.02c-0.02,0.08-0.06,0.15-0.12,0.19 c-0.06,0.05-0.14,0.07-0.23,0.07c-0.12,0-0.21-0.03-0.28-0.11c-0.07-0.07-0.1-0.17-0.1-0.3c0-0.13,0.03-0.24,0.1-0.31 c0.07-0.07,0.16-0.11,0.27-0.11c0.11,0,0.2,0.04,0.26,0.11c0.07,0.07,0.1,0.17,0.1,0.31c0,0.01,0,0.02,0,0.04h-0.6 c0,0.09,0.03,0.16,0.07,0.2c0.05,0.05,0.1,0.07,0.17,0.07c0.05,0,0.09-0.01,0.13-0.04C114.02,7.83,114.05,7.79,114.07,7.73"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M114.38,7.99v-0.8h0.12V7.3c0.06-0.09,0.14-0.13,0.25-0.13c0.05,0,0.09,0.01,0.13,0.03 c0.04,0.02,0.07,0.04,0.09,0.07s0.03,0.06,0.04,0.1c0.01,0.03,0.01,0.07,0.01,0.13v0.49h-0.14V7.5c0-0.06-0.01-0.1-0.02-0.12 c-0.01-0.03-0.03-0.05-0.06-0.07c-0.03-0.02-0.06-0.02-0.09-0.02c-0.06,0-0.11,0.02-0.15,0.06c-0.04,0.04-0.06,0.11-0.06,0.21 v0.44H114.38z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M115.46,7.99l-0.3-0.8h0.14l0.17,0.48c0.02,0.05,0.03,0.11,0.05,0.16c0.01-0.04,0.03-0.09,0.05-0.15 l0.18-0.49h0.14l-0.3,0.8H115.46z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M116.1,7.59c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.1,0.08,0.17,0.08c0.07,0,0.12-0.03,0.17-0.08 c0.04-0.05,0.07-0.13,0.07-0.23c0-0.1-0.02-0.17-0.07-0.23c-0.04-0.05-0.1-0.08-0.17-0.08c-0.07,0-0.12,0.03-0.17,0.08 C116.12,7.41,116.1,7.49,116.1,7.59 M115.96,7.59c0-0.15,0.04-0.26,0.12-0.33c0.07-0.06,0.15-0.09,0.25-0.09 c0.11,0,0.2,0.04,0.27,0.11c0.07,0.07,0.1,0.17,0.1,0.3c0,0.1-0.02,0.18-0.05,0.24c-0.03,0.06-0.08,0.1-0.13,0.14 c-0.06,0.03-0.12,0.05-0.19,0.05c-0.11,0-0.2-0.04-0.27-0.11C116,7.83,115.96,7.72,115.96,7.59"
          ></path>
        </g>
        <rect
          x="116.87"
          y="6.89"
          class="cofinanciado_st0"
          width="0.14"
          height="1.1"
        ></rect>
        <g>
          <path
            class="cofinanciado_st0"
            d="M117.43,7.99l-0.3-0.8h0.14l0.17,0.48c0.02,0.05,0.03,0.11,0.05,0.16c0.01-0.04,0.03-0.09,0.05-0.15 l0.18-0.49h0.14l-0.3,0.8H117.43z"
          ></path>
        </g>
        <path
          class="cofinanciado_st0"
          d="M117.98,7.99h0.14v-0.8h-0.14V7.99z M117.98,7.04h0.14V6.89h-0.14V7.04z"
        ></path>
        <g>
          <path
            class="cofinanciado_st0"
            d="M118.33,7.99v-0.8h0.12V7.3c0.03-0.04,0.06-0.07,0.1-0.1c0.04-0.02,0.09-0.04,0.14-0.04 c0.06,0,0.11,0.01,0.15,0.04c0.04,0.02,0.06,0.06,0.08,0.1c0.06-0.09,0.15-0.14,0.25-0.14c0.08,0,0.14,0.02,0.18,0.07 c0.04,0.04,0.06,0.11,0.06,0.2v0.55h-0.13v-0.5c0-0.05,0-0.09-0.01-0.12c-0.01-0.02-0.03-0.04-0.05-0.06 c-0.02-0.01-0.05-0.02-0.08-0.02c-0.06,0-0.1,0.02-0.14,0.06c-0.04,0.04-0.06,0.1-0.06,0.18v0.46h-0.14V7.47 c0-0.06-0.01-0.11-0.03-0.14c-0.02-0.03-0.06-0.05-0.11-0.05c-0.04,0-0.07,0.01-0.11,0.03c-0.03,0.02-0.06,0.05-0.07,0.09 c-0.01,0.04-0.02,0.09-0.02,0.17v0.41H118.33z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M119.71,7.51h0.45c-0.01-0.07-0.02-0.12-0.05-0.15c-0.04-0.05-0.1-0.08-0.17-0.08 c-0.06,0-0.11,0.02-0.16,0.06C119.74,7.39,119.72,7.44,119.71,7.51 M120.16,7.73l0.14,0.02c-0.02,0.08-0.06,0.15-0.12,0.19 c-0.06,0.05-0.14,0.07-0.23,0.07c-0.12,0-0.21-0.03-0.28-0.11c-0.07-0.07-0.1-0.17-0.1-0.3c0-0.13,0.03-0.24,0.1-0.31 c0.07-0.07,0.16-0.11,0.27-0.11c0.11,0,0.2,0.04,0.26,0.11c0.07,0.07,0.1,0.17,0.1,0.31c0,0.01,0,0.02,0,0.04h-0.6 c0.01,0.09,0.03,0.16,0.07,0.2c0.05,0.05,0.1,0.07,0.17,0.07c0.05,0,0.09-0.01,0.13-0.04C120.11,7.83,120.14,7.79,120.16,7.73"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M120.47,7.99v-0.8h0.12V7.3c0.06-0.09,0.14-0.13,0.25-0.13c0.05,0,0.09,0.01,0.13,0.03 c0.04,0.02,0.07,0.04,0.09,0.07s0.03,0.06,0.04,0.1c0.01,0.03,0.01,0.07,0.01,0.13v0.49h-0.14V7.5c0-0.06-0.01-0.1-0.02-0.12 c-0.01-0.03-0.03-0.05-0.06-0.07c-0.03-0.02-0.06-0.02-0.09-0.02c-0.06,0-0.11,0.02-0.15,0.06c-0.04,0.04-0.06,0.11-0.06,0.21 v0.44H120.47z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M121.62,7.87l0.02,0.12C121.6,8,121.57,8,121.54,8c-0.05,0-0.09-0.01-0.11-0.02 c-0.03-0.02-0.05-0.04-0.06-0.06c-0.01-0.02-0.02-0.08-0.02-0.16V7.3h-0.1v-0.1h0.1v-0.2l0.14-0.08v0.28h0.14v0.1h-0.14v0.47 c0,0.04,0,0.06,0.01,0.08c0.01,0.01,0.01,0.02,0.02,0.03c0.01,0.01,0.03,0.01,0.05,0.01C121.58,7.87,121.6,7.87,121.62,7.87"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M121.84,7.59c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.1,0.08,0.17,0.08c0.07,0,0.12-0.03,0.17-0.08 c0.04-0.05,0.07-0.13,0.07-0.23c0-0.1-0.02-0.17-0.07-0.23c-0.04-0.05-0.1-0.08-0.17-0.08c-0.07,0-0.12,0.03-0.17,0.08 C121.86,7.41,121.84,7.49,121.84,7.59 M121.7,7.59c0-0.15,0.04-0.26,0.12-0.33c0.07-0.06,0.15-0.09,0.25-0.09 c0.11,0,0.2,0.04,0.27,0.11c0.07,0.07,0.1,0.17,0.1,0.3c0,0.1-0.02,0.18-0.05,0.24c-0.03,0.06-0.08,0.1-0.13,0.14 c-0.06,0.03-0.12,0.05-0.19,0.05c-0.11,0-0.2-0.04-0.27-0.11C121.74,7.83,121.7,7.72,121.7,7.59"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M123.21,7.37h0.31c0.07,0,0.12-0.01,0.16-0.02c0.04-0.01,0.07-0.04,0.09-0.07c0.02-0.03,0.03-0.06,0.03-0.1 c0-0.05-0.02-0.09-0.06-0.13c-0.04-0.03-0.1-0.05-0.18-0.05h-0.35V7.37z M123.06,7.99v-1.1h0.49c0.1,0,0.17,0.01,0.23,0.03 c0.05,0.02,0.09,0.06,0.12,0.1c0.03,0.05,0.04,0.11,0.04,0.17c0,0.08-0.02,0.15-0.08,0.2c-0.05,0.05-0.13,0.09-0.23,0.1 c0.04,0.02,0.07,0.04,0.09,0.06c0.04,0.04,0.08,0.09,0.12,0.15l0.19,0.3h-0.18l-0.15-0.23c-0.04-0.07-0.08-0.12-0.11-0.15 c-0.03-0.03-0.05-0.06-0.07-0.07c-0.02-0.01-0.05-0.02-0.07-0.03c-0.02,0-0.04-0.01-0.08-0.01h-0.17v0.49H123.06z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M124.26,7.51h0.45c-0.01-0.07-0.02-0.12-0.05-0.15c-0.04-0.05-0.1-0.08-0.17-0.08 c-0.06,0-0.11,0.02-0.16,0.06C124.28,7.39,124.26,7.44,124.26,7.51 M124.7,7.73l0.14,0.02c-0.02,0.08-0.06,0.15-0.12,0.19 c-0.06,0.05-0.14,0.07-0.23,0.07c-0.12,0-0.21-0.03-0.28-0.11c-0.07-0.07-0.1-0.17-0.1-0.3c0-0.13,0.03-0.24,0.1-0.31 c0.07-0.07,0.16-0.11,0.27-0.11c0.11,0,0.19,0.04,0.26,0.11s0.1,0.17,0.1,0.31c0,0.01,0,0.02,0,0.04h-0.6 c0.01,0.09,0.03,0.16,0.07,0.2c0.05,0.05,0.1,0.07,0.17,0.07c0.05,0,0.09-0.01,0.13-0.04C124.65,7.83,124.68,7.79,124.7,7.73"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M125.1,7.57c0,0.11,0.02,0.18,0.06,0.23c0.04,0.05,0.09,0.07,0.16,0.07c0.06,0,0.11-0.02,0.16-0.07 c0.04-0.05,0.06-0.12,0.06-0.23c0-0.1-0.02-0.17-0.07-0.22c-0.04-0.05-0.1-0.07-0.16-0.07c-0.06,0-0.11,0.02-0.15,0.07 C125.12,7.41,125.1,7.48,125.1,7.57 M124.99,8.06l0.13,0.02c0.01,0.04,0.02,0.07,0.05,0.09c0.03,0.02,0.08,0.04,0.14,0.04 c0.06,0,0.11-0.01,0.15-0.04c0.03-0.03,0.06-0.06,0.07-0.11c0.01-0.03,0.01-0.09,0.01-0.17c-0.06,0.07-0.13,0.1-0.22,0.1 c-0.11,0-0.2-0.04-0.26-0.12c-0.06-0.08-0.09-0.17-0.09-0.29c0-0.08,0.01-0.15,0.04-0.21c0.03-0.07,0.07-0.11,0.12-0.15 c0.05-0.03,0.11-0.05,0.18-0.05c0.09,0,0.17,0.04,0.23,0.11v-0.1h0.12v0.69c0,0.12-0.01,0.21-0.04,0.26 c-0.03,0.05-0.07,0.09-0.12,0.12c-0.05,0.03-0.12,0.05-0.2,0.05c-0.1,0-0.17-0.02-0.23-0.06C125.01,8.21,124.98,8.14,124.99,8.06"
          ></path>
        </g>
        <path
          class="cofinanciado_st0"
          d="M125.87,7.99h0.14v-0.8h-0.14V7.99z M125.87,7.04h0.14V6.89h-0.14V7.04z"
        ></path>
        <g>
          <path
            class="cofinanciado_st0"
            d="M126.3,7.59c0,0.1,0.02,0.18,0.07,0.23c0.04,0.05,0.1,0.08,0.17,0.08c0.07,0,0.12-0.03,0.17-0.08 c0.04-0.05,0.07-0.13,0.07-0.23c0-0.1-0.02-0.17-0.07-0.23c-0.04-0.05-0.1-0.08-0.17-0.08c-0.07,0-0.12,0.03-0.17,0.08 C126.32,7.41,126.3,7.49,126.3,7.59 M126.16,7.59c0-0.15,0.04-0.26,0.12-0.33c0.07-0.06,0.15-0.09,0.25-0.09 c0.11,0,0.2,0.04,0.27,0.11c0.07,0.07,0.1,0.17,0.1,0.3c0,0.1-0.02,0.18-0.05,0.24c-0.03,0.06-0.08,0.1-0.13,0.14 c-0.06,0.03-0.12,0.05-0.19,0.05c-0.11,0-0.2-0.04-0.27-0.11C126.2,7.83,126.16,7.72,126.16,7.59"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M127.07,7.99v-0.8h0.12V7.3c0.06-0.09,0.14-0.13,0.25-0.13c0.05,0,0.09,0.01,0.13,0.03 c0.04,0.02,0.07,0.04,0.09,0.07s0.03,0.06,0.04,0.1c0.01,0.03,0.01,0.07,0.01,0.13v0.49h-0.14V7.5c0-0.06-0.01-0.1-0.02-0.12 c-0.01-0.03-0.03-0.05-0.06-0.07c-0.03-0.02-0.06-0.02-0.09-0.02c-0.06,0-0.11,0.02-0.15,0.06c-0.04,0.04-0.06,0.11-0.06,0.21 v0.44H127.07z"
          ></path>
          <path
            class="cofinanciado_st0"
            d="M128.44,7.59c-0.05,0.02-0.12,0.04-0.22,0.05c-0.05,0.01-0.09,0.02-0.12,0.03s-0.04,0.02-0.05,0.05 c-0.01,0.02-0.02,0.04-0.02,0.06c0,0.04,0.01,0.07,0.04,0.09c0.03,0.02,0.07,0.04,0.12,0.04c0.05,0,0.1-0.01,0.14-0.03 c0.04-0.02,0.07-0.05,0.09-0.09c0.01-0.03,0.02-0.08,0.02-0.14V7.59z M128.45,7.89c-0.05,0.04-0.1,0.07-0.15,0.09 c-0.05,0.02-0.1,0.03-0.15,0.03c-0.09,0-0.16-0.02-0.2-0.07c-0.05-0.04-0.07-0.1-0.07-0.16c0-0.04,0.01-0.07,0.03-0.11 c0.02-0.03,0.04-0.06,0.07-0.08c0.03-0.02,0.06-0.03,0.1-0.05c0.03-0.01,0.07-0.01,0.12-0.02c0.11-0.01,0.19-0.03,0.24-0.05 c0-0.02,0-0.03,0-0.03c0-0.06-0.01-0.09-0.04-0.12c-0.04-0.03-0.09-0.05-0.16-0.05c-0.06,0-0.11,0.01-0.14,0.03 c-0.03,0.02-0.05,0.06-0.07,0.12l-0.13-0.02c0.01-0.06,0.03-0.1,0.06-0.14c0.03-0.03,0.07-0.06,0.12-0.08 c0.05-0.02,0.11-0.03,0.18-0.03c0.07,0,0.12,0.01,0.17,0.02c0.04,0.02,0.07,0.04,0.09,0.06c0.02,0.02,0.03,0.06,0.04,0.09 c0,0.02,0.01,0.06,0.01,0.12v0.18c0,0.13,0,0.21,0.01,0.24c0.01,0.03,0.02,0.07,0.03,0.1h-0.14 C128.46,7.96,128.45,7.93,128.45,7.89"
          ></path>
        </g>
        <rect
          x="128.78"
          y="6.89"
          class="cofinanciado_st0"
          width="0.14"
          height="1.1"
        ></rect>
      </g>
    </svg>
  </div>
</div>
